import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export enum AppUse {
  Corporate = 'CORPORATE',
  Investment = 'INVESTMENT'
}

export enum Country_Codes {
  Gh = 'GH',
  Ke = 'KE',
  Ng = 'NG',
  Za = 'ZA',
  Ug = 'UG'
}

export enum Id_Types {
  AlienCard = 'ALIEN_CARD',
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT',
  DriversLicense = 'DRIVERS_LICENSE'
}

export enum OnboardingSteps {
  PersonalInformation = 'PERSONAL_INFORMATION',
  ContactDetails = 'CONTACT_DETAILS',
  CompanyInformation = 'COMPANY_INFORMATION',
  CompanyDetails = 'COMPANY_DETAILS'
}

export enum InvestorOnboardingSteps {
  BasicInformation = 'BASIC_INFORMATION',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  ReasonForInvesting = 'REASON_FOR_INVESTING',
  Agreement = 'AGREEMENT'
}

export enum Investor_Reasons_For_Investing {
  Retirement = 'RETIREMENT',
  TuitionSavings = 'TUITION_SAVINGS',
  BuildingSavings = 'BUILDING_SAVINGS',
  EarnAGoodReturn = 'EARN_A_GOOD_RETURN'
}

export type OnboardingCompanyInput = {
  logo?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  companyType?: Maybe<Enum_Companies_Companytype>;
  industryType?: Maybe<Enum_Companies_Industrytype>;
  briefDescription?: Maybe<Scalars['String']>;
  platformUseReason?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
};

export type ChangeCurrencyInput = {
  currency: Scalars['String'];
};

export type OnboardingInput = {
  onboardingStep: OnboardingSteps;
  idNumber?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
};

export type InvestorOnboardingInput = {
  investorOnboardingStep: InvestorOnboardingSteps;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  taxNumber?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  reasonForInvesting?: Maybe<Scalars['String']>;
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  certifiedId?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  idType?: Maybe<Scalars['String']>;
  nationalId?: Maybe<Array<Scalars['ID']>>;
  selfie?: Maybe<Scalars['ID']>;
};

export type UpdateRegulatoryProfileInput = {
  profilePicture?: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
};

export type ChangeMyPasswordPayload = {
  __typename?: 'ChangeMyPasswordPayload';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubmitBankWithdrawRequestInput = {
  amount?: Maybe<Scalars['Int']>;
  bankName?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  mpesaNumber?: Maybe<Scalars['String']>;
  withdrawType?: Maybe<Scalars['String']>;
};

export type UpdateOrCreateMyBankingInput = {
  bankName: Scalars['String'];
  accountHolder: Scalars['String'];
  typeOfAccount: Scalars['String'];
  accountNumber: Scalars['String'];
};

export type CpFilter = {
  userId?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Commercialpapers_Status>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  payoutStartDate?: Maybe<Scalars['DateTime']>;
  payoutEndDate?: Maybe<Scalars['DateTime']>;
  approvalStartDate?: Maybe<Scalars['DateTime']>;
  approvalEndDate?: Maybe<Scalars['DateTime']>;
};

export type GetCommercialPapersPayload = {
  __typename?: 'GetCommercialPapersPayload';
  commercialPapers?: Maybe<Array<Maybe<CommercialPapers>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export enum Cp_Sort_By {
  SortByNewest = 'SORT_BY_NEWEST',
  SortByOldest = 'SORT_BY_OLDEST'
}

export enum InvestorSortby {
  ClosingDate = 'CLOSING_DATE',
  MinimumInvestment = 'MINIMUM_INVESTMENT',
  MaturityDate = 'MATURITY_DATE',
  InterestRate = 'INTEREST_RATE',
  DatePublished = 'DATE_PUBLISHED',
  Amount = 'AMOUNT'
}

export type CreateMyCommercialPaperInput = {
  id?: Maybe<Scalars['String']>;
  currentStep?: Maybe<Enum_Commercialpapers_Currentstep>;
  amountNeeded?: Maybe<Scalars['Long']>;
  nextInterestPayment?: Maybe<Scalars['DateTime']>;
  followup?: Maybe<Scalars['Int']>;
  minInvestment?: Maybe<Scalars['Int']>;
  proposedDateOfIssue?: Maybe<Scalars['DateTime']>;
  interestRate?: Maybe<Scalars['Float']>;
  lengthOfCP?: Maybe<Scalars['Int']>;
  conditions?: Maybe<Scalars['String']>;
  purposeOfIssue?: Maybe<Scalars['String']>;
  masterNote?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  interestFrequency?: Maybe<Scalars['String']>;
  commercialPaperType?: Maybe<Scalars['String']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDescription?: Maybe<Scalars['String']>;
  managementFee?: Maybe<Scalars['Float']>;
  interestFrequencyDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  memorandum?: Maybe<Array<Scalars['ID']>>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  payoutDate?: Maybe<Scalars['DateTime']>;
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
  sellFee?: Maybe<Scalars['Float']>;
  incorporationWithLimitedLiability?: Maybe<Scalars['Boolean']>;
  incorporationWithLimitedLiabilityComment?: Maybe<Scalars['String']>;
  shareCapitalAndNetAssetsOfIssuer?: Maybe<Scalars['Boolean']>;
  shareCapitalAndNetAssetsOfIssuerComment?: Maybe<Scalars['String']>;
  listingAndTransferabilityOfSecurities?: Maybe<Scalars['Boolean']>;
  listingAndTransferabilityOfSecuritiesComment?: Maybe<Scalars['String']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecordsComment?: Maybe<Scalars['String']>;
  directorsAndSeniorManagement?: Maybe<Scalars['Boolean']>;
  directorsAndSeniorManagementComment?: Maybe<Scalars['String']>;
  certificateOfComfort?: Maybe<Scalars['Boolean']>;
  certificateOfComfortComment?: Maybe<Scalars['String']>;
  profitableHistoricTrackRecordAndFutureProspects?: Maybe<Scalars['Boolean']>;
  profitableHistoricTrackRecordAndFutureProspectsComment?: Maybe<Scalars['String']>;
  guaranteeRequirements?: Maybe<Scalars['Boolean']>;
  guaranteeRequirementsComment?: Maybe<Scalars['String']>;
  debtRatios?: Maybe<Scalars['Boolean']>;
  debtRatiosComment?: Maybe<Scalars['String']>;
  sizeIssue?: Maybe<Scalars['Boolean']>;
  sizeIssueComment?: Maybe<Scalars['String']>;
  minimumSize?: Maybe<Scalars['Boolean']>;
  minimumSizeComment?: Maybe<Scalars['String']>;
  renewalDate?: Maybe<Scalars['Boolean']>;
  renewalDateComment?: Maybe<Scalars['String']>;
  reasonsForNonCompliance?: Maybe<Scalars['Boolean']>;
  strategicGuidance?: Maybe<Scalars['Boolean']>;
  relevantCommittees?: Maybe<Scalars['Boolean']>;
  committeeSpecificationsBoard?: Maybe<Scalars['Boolean']>;
  balanceOfExecutiveAndNonExecutiveDirectors?: Maybe<Scalars['Boolean']>;
  reasonsForNonComplianceComment?: Maybe<Scalars['String']>;
  strategicGuidanceComment?: Maybe<Scalars['String']>;
  relevantCommitteesComment?: Maybe<Scalars['String']>;
  committeeSpecificationsBoardComment?: Maybe<Scalars['String']>;
  balanceOfExecutiveAndNonExecutiveDirectorsComment?: Maybe<Scalars['String']>;
  rolesAndResponsibilities?: Maybe<Scalars['Boolean']>;
  chairpersonCompliance?: Maybe<Scalars['Boolean']>;
  nominatingCommittee?: Maybe<Scalars['Boolean']>;
  auditCommittee?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilitiesComment?: Maybe<Scalars['String']>;
  chairpersonComplianceComment?: Maybe<Scalars['String']>;
  nominatingCommitteeComment?: Maybe<Scalars['String']>;
  auditCommitteeComment?: Maybe<Scalars['String']>;
  directorCompliance?: Maybe<Scalars['Boolean']>;
  directorComplianceComment?: Maybe<Scalars['String']>;
};

export type SubmitCommercialPaperInput = {
  id: Scalars['ID'];
  infavourOf: Scalars['String'];
};

export type ApproveCommercialPaperInput = {
  id: Scalars['ID'];
  signedAt?: Maybe<Scalars['DateTime']>;
  signature: Scalars['String'];
};

export type MarketValueInput = {
  id: Scalars['ID'];
  marketValue: Scalars['Float'];
};

export type DeclineCommercialPaperInput = {
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type RequestMoreInfoInput = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};

export type CreateInternalNoteInput = {
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type AvailableCommercialPapersInput = {
  search?: Maybe<Scalars['String']>;
  page: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  priceRange?: Maybe<Scalars['JSON']>;
  minimumInvs?: Maybe<Array<Maybe<Scalars['String']>>>;
  industryTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  sortBy?: Maybe<InvestorSortby>;
};

export type AvailableCommercialPapersPayload = {
  __typename?: 'AvailableCommercialPapersPayload';
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  commercialPapers?: Maybe<Array<Maybe<CommercialPapers>>>;
};

export type CommercialPaperForInvestorPayload = {
  __typename?: 'CommercialPaperForInvestorPayload';
  commercialPaper?: Maybe<CommercialPapers>;
  isAnInvestorOfCP?: Maybe<Scalars['Boolean']>;
  amountInvested?: Maybe<Scalars['Int']>;
};

export type DownloadCommercialPaperSummaryPayload = {
  __typename?: 'DownloadCommercialPaperSummaryPayload';
  url?: Maybe<Scalars['String']>;
};

export type UpdateCompanyDocumentsInput = {
  informationMemorandum?: Maybe<Array<Scalars['ID']>>;
  certificateOfIncorporation?: Maybe<Array<Scalars['ID']>>;
  memorandumAndArticlesOfAssociation?: Maybe<Array<Scalars['ID']>>;
  boardOfDirectorsApproval?: Maybe<Array<Scalars['ID']>>;
  reportingAccountsReport?: Maybe<Array<Scalars['ID']>>;
  financialStatements?: Maybe<Array<Scalars['ID']>>;
  companyTAXCertificate?: Maybe<Array<Scalars['ID']>>;
  relevantCompanyDocuments?: Maybe<Array<Scalars['ID']>>;
  companyConsent?: Maybe<Array<Scalars['ID']>>;
};

export type UpdateOrCreateMyFinancialSummaryInput = {
  netWorth: Scalars['Int'];
  totalDeptOutstanding: Scalars['Int'];
  totalDeptOutstandingOther: Scalars['Int'];
  grossIncome: Scalars['Int'];
  grossProfit: Scalars['Int'];
  operatingProfit: Scalars['Int'];
  netProfit: Scalars['Int'];
  detailsOfDefaultCP: Scalars['String'];
  detailsOfDefaultDelay: Scalars['String'];
};

export type CalculateInvestmentPayload = {
  __typename?: 'CalculateInvestmentPayload';
  interestRate?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Int']>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['Date']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  investorTotalReturn?: Maybe<Scalars['Float']>;
};

export type CalculateSellPayload = {
  __typename?: 'CalculateSellPayload';
  sellAmount?: Maybe<Scalars['Float']>;
  deadline?: Maybe<Scalars['Date']>;
  customerAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  shortHoldFeeAmount?: Maybe<Scalars['Float']>;
};

export type BuyInvestmentPayload = {
  __typename?: 'BuyInvestmentPayload';
  id: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  merchantRequestID?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
};

export type CreateSellInput = {
  commercialPaperId: Scalars['ID'];
  investmentId: Scalars['ID'];
  customerAmount: Scalars['Float'];
  currency: Scalars['String'];
  sellAmount: Scalars['Float'];
  sellFeeAmount: Scalars['Float'];
  shortHoldFeeAmount: Scalars['Float'];
};

export type CalculateSellInput = {
  amount: Scalars['Float'];
  investmentId: Scalars['ID'];
};

export type CalculateInvestmentInput = {
  id: Scalars['ID'];
  investmentDate?: Maybe<Scalars['DateTime']>;
  buyinAmount: Scalars['Float'];
};

export type InvestmentFilter = {
  search?: Maybe<Scalars['String']>;
  approvalStartDate?: Maybe<Scalars['DateTime']>;
  approvalEndDate?: Maybe<Scalars['DateTime']>;
  investmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type GetInvestmentsPayload = {
  __typename?: 'GetInvestmentsPayload';
  investments?: Maybe<Array<Maybe<Investments>>>;
};

export type BuyInvestmentInput = {
  amount: Scalars['String'];
  commercialPaperId: Scalars['ID'];
  currency: Scalars['String'];
};

export type MpesaResponse = {
  __typename?: 'MpesaResponse';
  message?: Maybe<Scalars['String']>;
};

export type GetInvestmentsByNoteIdPayload = {
  __typename?: 'GetInvestmentsByNoteIdPayload';
  investments?: Maybe<Array<Maybe<Investments>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type ManagerMetricsPayload = {
  __typename?: 'ManagerMetricsPayload';
  investors?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
  createdNotes?: Maybe<Array<Maybe<CommercialPapers>>>;
  fundedNotes?: Maybe<Array<Maybe<CommercialPapers>>>;
  fundingNotes?: Maybe<Array<Maybe<CommercialPapers>>>;
  closedNotes?: Maybe<Array<Maybe<CommercialPapers>>>;
};

export type GetManagerMetricsFilters = {
  startDate?: Maybe<Scalars['DateTime']>;
};

export type MarketValueLogPayload = {
  __typename?: 'MarketValueLogPayload';
  marketValueLog?: Maybe<Array<Maybe<MarketValueLog>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type CreateMasterNoteByUserInput = {
  title?: Maybe<Scalars['String']>;
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Scalars['String']>;
  maturityDate?: Maybe<Scalars['DateTime']>;
  marketValue?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  memorandum?: Maybe<Array<Scalars['ID']>>;
  assetType?: Maybe<Scalars['String']>;
  fundManager?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
};

export type MasterNoteFilter = {
  status?: Maybe<Enum_Masternote_Status>;
  currency?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type GetAllMyMasterNotesPayload = {
  __typename?: 'GetAllMyMasterNotesPayload';
  masterNotes?: Maybe<Array<Maybe<MasterNote>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type SendPayoutByUserInput = {
  id: Scalars['String'];
};

export type SendInterestInput = {
  id: Scalars['String'];
  interestMetric: Scalars['Int'];
};

export type SubmitRolloverRequestInput = {
  rolloverDate: Scalars['DateTime'];
  commercialPaperID: Scalars['ID'];
  reason: Scalars['String'];
};

export type CreateMyRolloverResponseInput = {
  rolloverRequestId: Scalars['ID'];
};

export type SellRequestLoss = {
  __typename?: 'SellRequestLoss';
  loss?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['Date']>;
};

export type GetAcceptedSellRequestsResponse = {
  __typename?: 'GetAcceptedSellRequestsResponse';
  sellRequestLosses?: Maybe<Array<Maybe<SellRequestLoss>>>;
};

export type SubmitTopupRequestInput = {
  amount: Scalars['String'];
  source: Scalars['String'];
  currency: Scalars['String'];
};

export type DownloadReceiptPayload = {
  __typename?: 'DownloadReceiptPayload';
  url?: Maybe<Scalars['String']>;
};

export type RequestCompanyUpdateInput = {
  logo?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  companyType?: Maybe<Enum_Companies_Companytype>;
  industryType?: Maybe<Enum_Companies_Industrytype>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
};

export type RequestProfileUpdateInput = {
  profilePicture?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  taxNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
};

export type RequestMasterNoteUpdateInput = {
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Scalars['String']>;
  maturityDate?: Maybe<Scalars['DateTime']>;
  memorandum?: Maybe<Array<Scalars['ID']>>;
  potentialRisks?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type OkResponse = {
  __typename?: 'OkResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type TopupMyWalletInput = {
  amount: Scalars['String'];
  phoneNumber: Scalars['String'];
  source: Scalars['String'];
};

export type SupportTopic = {
  __typename?: 'SupportTopic';
  id?: Maybe<Scalars['ID']>;
  displayName?: Maybe<Scalars['String']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  id?: Maybe<Scalars['ID']>;
};

export type SupportTicketInput = {
  subject?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  ticketFormID?: Maybe<Scalars['String']>;
};

export type HelpAndSupportInput = {
  queryType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export enum Enum_Bankwithdrawalrequest_Status {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum Enum_Bankwithdrawalrequest_Withdrawtype {
  Bank = 'BANK',
  Mpesa = 'MPESA'
}

export enum Enum_Bankwithdrawalrequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export type BankWithdrawalRequest = {
  __typename?: 'BankWithdrawalRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  bankName?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  user?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Enum_Bankwithdrawalrequest_Status>;
  transaction?: Maybe<Transactions>;
  mpesaNumber?: Maybe<Scalars['String']>;
  withdrawType?: Maybe<Enum_Bankwithdrawalrequest_Withdrawtype>;
  currency?: Maybe<Enum_Bankwithdrawalrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type BankWithdrawalRequestConnection = {
  __typename?: 'BankWithdrawalRequestConnection';
  values?: Maybe<Array<Maybe<BankWithdrawalRequest>>>;
  groupBy?: Maybe<BankWithdrawalRequestGroupBy>;
  aggregate?: Maybe<BankWithdrawalRequestAggregator>;
};

export type BankWithdrawalRequestAggregator = {
  __typename?: 'BankWithdrawalRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<BankWithdrawalRequestAggregatorSum>;
  avg?: Maybe<BankWithdrawalRequestAggregatorAvg>;
  min?: Maybe<BankWithdrawalRequestAggregatorMin>;
  max?: Maybe<BankWithdrawalRequestAggregatorMax>;
};

export type BankWithdrawalRequestAggregatorSum = {
  __typename?: 'BankWithdrawalRequestAggregatorSum';
  amount?: Maybe<Scalars['Float']>;
};

export type BankWithdrawalRequestAggregatorAvg = {
  __typename?: 'BankWithdrawalRequestAggregatorAvg';
  amount?: Maybe<Scalars['Float']>;
};

export type BankWithdrawalRequestAggregatorMin = {
  __typename?: 'BankWithdrawalRequestAggregatorMin';
  amount?: Maybe<Scalars['Float']>;
};

export type BankWithdrawalRequestAggregatorMax = {
  __typename?: 'BankWithdrawalRequestAggregatorMax';
  amount?: Maybe<Scalars['Float']>;
};

export type BankWithdrawalRequestGroupBy = {
  __typename?: 'BankWithdrawalRequestGroupBy';
  id?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionUpdated_At>>>;
  bankName?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionBankName>>>;
  accountName?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionAccountName>>>;
  accountNumber?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionAccountNumber>>>;
  amount?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionAmount>>>;
  user?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionUser>>>;
  status?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionStatus>>>;
  transaction?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionTransaction>>>;
  mpesaNumber?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionMpesaNumber>>>;
  withdrawType?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionWithdrawType>>>;
  currency?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionCurrency>>>;
  published_at?: Maybe<Array<Maybe<BankWithdrawalRequestConnectionPublished_At>>>;
};

export type BankWithdrawalRequestConnectionId = {
  __typename?: 'BankWithdrawalRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionCreated_At = {
  __typename?: 'BankWithdrawalRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionUpdated_At = {
  __typename?: 'BankWithdrawalRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionBankName = {
  __typename?: 'BankWithdrawalRequestConnectionBankName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionAccountName = {
  __typename?: 'BankWithdrawalRequestConnectionAccountName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionAccountNumber = {
  __typename?: 'BankWithdrawalRequestConnectionAccountNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionAmount = {
  __typename?: 'BankWithdrawalRequestConnectionAmount';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionUser = {
  __typename?: 'BankWithdrawalRequestConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionStatus = {
  __typename?: 'BankWithdrawalRequestConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionTransaction = {
  __typename?: 'BankWithdrawalRequestConnectionTransaction';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionMpesaNumber = {
  __typename?: 'BankWithdrawalRequestConnectionMpesaNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionWithdrawType = {
  __typename?: 'BankWithdrawalRequestConnectionWithdrawType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionCurrency = {
  __typename?: 'BankWithdrawalRequestConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestConnectionPublished_At = {
  __typename?: 'BankWithdrawalRequestConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BankWithdrawalRequestConnection>;
};

export type BankWithdrawalRequestInput = {
  bankName?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Bankwithdrawalrequest_Status>;
  transaction?: Maybe<Scalars['ID']>;
  mpesaNumber?: Maybe<Scalars['String']>;
  withdrawType?: Maybe<Enum_Bankwithdrawalrequest_Withdrawtype>;
  currency?: Maybe<Enum_Bankwithdrawalrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBankWithdrawalRequestInput = {
  bankName?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Bankwithdrawalrequest_Status>;
  transaction?: Maybe<Scalars['ID']>;
  mpesaNumber?: Maybe<Scalars['String']>;
  withdrawType?: Maybe<Enum_Bankwithdrawalrequest_Withdrawtype>;
  currency?: Maybe<Enum_Bankwithdrawalrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateBankWithdrawalRequestInput = {
  data?: Maybe<BankWithdrawalRequestInput>;
};

export type CreateBankWithdrawalRequestPayload = {
  __typename?: 'createBankWithdrawalRequestPayload';
  bankWithdrawalRequest?: Maybe<BankWithdrawalRequest>;
};

export type UpdateBankWithdrawalRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBankWithdrawalRequestInput>;
};

export type UpdateBankWithdrawalRequestPayload = {
  __typename?: 'updateBankWithdrawalRequestPayload';
  bankWithdrawalRequest?: Maybe<BankWithdrawalRequest>;
};

export type DeleteBankWithdrawalRequestInput = {
  where?: Maybe<InputId>;
};

export type DeleteBankWithdrawalRequestPayload = {
  __typename?: 'deleteBankWithdrawalRequestPayload';
  bankWithdrawalRequest?: Maybe<BankWithdrawalRequest>;
};

export type BankingInformation = {
  __typename?: 'BankingInformation';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  bankName?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  typeOfAccount?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Companies>;
};

export type BankingInformationConnection = {
  __typename?: 'BankingInformationConnection';
  values?: Maybe<Array<Maybe<BankingInformation>>>;
  groupBy?: Maybe<BankingInformationGroupBy>;
  aggregate?: Maybe<BankingInformationAggregator>;
};

export type BankingInformationAggregator = {
  __typename?: 'BankingInformationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BankingInformationGroupBy = {
  __typename?: 'BankingInformationGroupBy';
  id?: Maybe<Array<Maybe<BankingInformationConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BankingInformationConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BankingInformationConnectionUpdated_At>>>;
  bankName?: Maybe<Array<Maybe<BankingInformationConnectionBankName>>>;
  accountHolder?: Maybe<Array<Maybe<BankingInformationConnectionAccountHolder>>>;
  typeOfAccount?: Maybe<Array<Maybe<BankingInformationConnectionTypeOfAccount>>>;
  accountNumber?: Maybe<Array<Maybe<BankingInformationConnectionAccountNumber>>>;
  company?: Maybe<Array<Maybe<BankingInformationConnectionCompany>>>;
};

export type BankingInformationConnectionId = {
  __typename?: 'BankingInformationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionCreated_At = {
  __typename?: 'BankingInformationConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionUpdated_At = {
  __typename?: 'BankingInformationConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionBankName = {
  __typename?: 'BankingInformationConnectionBankName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionAccountHolder = {
  __typename?: 'BankingInformationConnectionAccountHolder';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionTypeOfAccount = {
  __typename?: 'BankingInformationConnectionTypeOfAccount';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionAccountNumber = {
  __typename?: 'BankingInformationConnectionAccountNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationConnectionCompany = {
  __typename?: 'BankingInformationConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BankingInformationConnection>;
};

export type BankingInformationInput = {
  bankName?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  typeOfAccount?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditBankingInformationInput = {
  bankName?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  typeOfAccount?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateBankingInformationInput = {
  data?: Maybe<BankingInformationInput>;
};

export type CreateBankingInformationPayload = {
  __typename?: 'createBankingInformationPayload';
  bankingInformation?: Maybe<BankingInformation>;
};

export type UpdateBankingInformationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBankingInformationInput>;
};

export type UpdateBankingInformationPayload = {
  __typename?: 'updateBankingInformationPayload';
  bankingInformation?: Maybe<BankingInformation>;
};

export type DeleteBankingInformationInput = {
  where?: Maybe<InputId>;
};

export type DeleteBankingInformationPayload = {
  __typename?: 'deleteBankingInformationPayload';
  bankingInformation?: Maybe<BankingInformation>;
};

export enum Enum_Commercialpapers_Status {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  InfoRequired = 'INFO_REQUIRED',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Active = 'ACTIVE',
  Funding = 'FUNDING',
  PaymentDue = 'PAYMENT_DUE',
  NewRequest = 'NEW_REQUEST',
  InfoProvided = 'INFO_PROVIDED',
  Funded = 'FUNDED',
  Closed = 'CLOSED'
}

export enum Enum_Commercialpapers_Industrytype {
  Transport = 'TRANSPORT',
  Computer = 'COMPUTER',
  Telecommunication = 'TELECOMMUNICATION',
  Agriculture = 'AGRICULTURE',
  Construction = 'CONSTRUCTION',
  Pharmaceutical = 'PHARMACEUTICAL',
  Electronics = 'ELECTRONICS',
  Energy = 'ENERGY',
  Entertainment = 'ENTERTAINMENT',
  Hospitality = 'HOSPITALITY',
  Manufacturing = 'MANUFACTURING',
  Mining = 'MINING'
}

export enum Enum_Commercialpapers_Commercialpapertype {
  Ordinary = 'Ordinary',
  Sophisticated = 'Sophisticated'
}

export enum Enum_Commercialpapers_Investmenttermtype {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS'
}

export enum Enum_Commercialpapers_Currentstep {
  BasicInformation = 'BASIC_INFORMATION',
  EligibilityRequirements1 = 'ELIGIBILITY_REQUIREMENTS1',
  EligibilityRequirements2 = 'ELIGIBILITY_REQUIREMENTS2',
  CorporateGovernanceRequirements1 = 'CORPORATE_GOVERNANCE_REQUIREMENTS1',
  CorporateGovernanceRequirements2 = 'CORPORATE_GOVERNANCE_REQUIREMENTS2',
  AdditionalInformation = 'ADDITIONAL_INFORMATION'
}

export enum Enum_Commercialpapers_Interestfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY',
  Weekly = 'WEEKLY',
  Daily = 'DAILY'
}

export enum Enum_Commercialpapers_Type {
  Bond = 'Bond',
  Fund = 'Fund'
}

export enum Enum_Commercialpapers_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export type CommercialPapers = {
  __typename?: 'CommercialPapers';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  submittedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Companies>;
  amount?: Maybe<Scalars['Long']>;
  amountNeeded?: Maybe<Scalars['Long']>;
  payoutDate?: Maybe<Scalars['Date']>;
  interestRate?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Commercialpapers_Status>;
  industryType?: Maybe<Enum_Commercialpapers_Industrytype>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  conditions?: Maybe<Scalars['String']>;
  purposeOfIssue?: Maybe<Scalars['String']>;
  commercialPaperType?: Maybe<Enum_Commercialpapers_Commercialpapertype>;
  certOfIncorporation?: Maybe<UploadFile>;
  directorsApproval?: Maybe<UploadFile>;
  accountsReport?: Maybe<UploadFile>;
  financialStatements?: Maybe<UploadFile>;
  taxCertificate?: Maybe<UploadFile>;
  companyConsent?: Maybe<UploadFile>;
  eligibilityRequirements?: Maybe<Array<Maybe<ComponentComplianceComplianceSection>>>;
  corporateGovRequirements?: Maybe<Array<Maybe<ComponentComplianceComplianceSection>>>;
  signature?: Maybe<UploadFile>;
  signedBy?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  maturesAt?: Maybe<Scalars['Date']>;
  investmentTermType?: Maybe<Enum_Commercialpapers_Investmenttermtype>;
  investmentTerm?: Maybe<Scalars['Int']>;
  user?: Maybe<UsersPermissionsUser>;
  currentStep?: Maybe<Enum_Commercialpapers_Currentstep>;
  lengthOfCP?: Maybe<Scalars['Int']>;
  eligibilityRequirement?: Maybe<EligibilityRequirement>;
  corporateGovernanceRequirement?: Maybe<CorporateGovernanceRequirements>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  payout_request?: Maybe<PayoutRequest>;
  dateFunded?: Maybe<Scalars['DateTime']>;
  minInvestment?: Maybe<Scalars['Long']>;
  interestFrequency?: Maybe<Enum_Commercialpapers_Interestfrequency>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDescription?: Maybe<Scalars['String']>;
  interestFrequencyDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Commercialpapers_Type>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Int']>;
  masterNote?: Maybe<MasterNote>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Int']>;
  faceValue?: Maybe<Scalars['Long']>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Commercialpapers_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  followup?: Maybe<Scalars['Int']>;
  memorandum?: Maybe<Array<Maybe<UploadFile>>>;
  relevantDocuments?: Maybe<Array<Maybe<UploadFile>>>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
  investments?: Maybe<Array<Maybe<Investments>>>;
  purchaseRequests?: Maybe<Array<Maybe<PurchaseRequest>>>;
  rolloverRequests?: Maybe<Array<Maybe<RolloverRequests>>>;
  market_value_logs?: Maybe<Array<Maybe<MarketValueLog>>>;
};


export type CommercialPapersMemorandumArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersRelevantDocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersTransactionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersInvestmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersPurchaseRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersRolloverRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CommercialPapersMarket_Value_LogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CommercialPapersConnection = {
  __typename?: 'CommercialPapersConnection';
  values?: Maybe<Array<Maybe<CommercialPapers>>>;
  groupBy?: Maybe<CommercialPapersGroupBy>;
  aggregate?: Maybe<CommercialPapersAggregator>;
};

export type CommercialPapersAggregator = {
  __typename?: 'CommercialPapersAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CommercialPapersAggregatorSum>;
  avg?: Maybe<CommercialPapersAggregatorAvg>;
  min?: Maybe<CommercialPapersAggregatorMin>;
  max?: Maybe<CommercialPapersAggregatorMax>;
};

export type CommercialPapersAggregatorSum = {
  __typename?: 'CommercialPapersAggregatorSum';
  interestRate?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  lengthOfCP?: Maybe<Scalars['Float']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Float']>;
  followup?: Maybe<Scalars['Float']>;
};

export type CommercialPapersAggregatorAvg = {
  __typename?: 'CommercialPapersAggregatorAvg';
  interestRate?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  lengthOfCP?: Maybe<Scalars['Float']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Float']>;
  followup?: Maybe<Scalars['Float']>;
};

export type CommercialPapersAggregatorMin = {
  __typename?: 'CommercialPapersAggregatorMin';
  interestRate?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  lengthOfCP?: Maybe<Scalars['Float']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Float']>;
  followup?: Maybe<Scalars['Float']>;
};

export type CommercialPapersAggregatorMax = {
  __typename?: 'CommercialPapersAggregatorMax';
  interestRate?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  lengthOfCP?: Maybe<Scalars['Float']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Float']>;
  followup?: Maybe<Scalars['Float']>;
};

export type CommercialPapersGroupBy = {
  __typename?: 'CommercialPapersGroupBy';
  id?: Maybe<Array<Maybe<CommercialPapersConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CommercialPapersConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CommercialPapersConnectionUpdated_At>>>;
  submittedAt?: Maybe<Array<Maybe<CommercialPapersConnectionSubmittedAt>>>;
  company?: Maybe<Array<Maybe<CommercialPapersConnectionCompany>>>;
  amount?: Maybe<Array<Maybe<CommercialPapersConnectionAmount>>>;
  amountNeeded?: Maybe<Array<Maybe<CommercialPapersConnectionAmountNeeded>>>;
  payoutDate?: Maybe<Array<Maybe<CommercialPapersConnectionPayoutDate>>>;
  interestRate?: Maybe<Array<Maybe<CommercialPapersConnectionInterestRate>>>;
  status?: Maybe<Array<Maybe<CommercialPapersConnectionStatus>>>;
  industryType?: Maybe<Array<Maybe<CommercialPapersConnectionIndustryType>>>;
  proposedDateOfIssue?: Maybe<Array<Maybe<CommercialPapersConnectionProposedDateOfIssue>>>;
  conditions?: Maybe<Array<Maybe<CommercialPapersConnectionConditions>>>;
  purposeOfIssue?: Maybe<Array<Maybe<CommercialPapersConnectionPurposeOfIssue>>>;
  commercialPaperType?: Maybe<Array<Maybe<CommercialPapersConnectionCommercialPaperType>>>;
  certOfIncorporation?: Maybe<Array<Maybe<CommercialPapersConnectionCertOfIncorporation>>>;
  directorsApproval?: Maybe<Array<Maybe<CommercialPapersConnectionDirectorsApproval>>>;
  accountsReport?: Maybe<Array<Maybe<CommercialPapersConnectionAccountsReport>>>;
  financialStatements?: Maybe<Array<Maybe<CommercialPapersConnectionFinancialStatements>>>;
  taxCertificate?: Maybe<Array<Maybe<CommercialPapersConnectionTaxCertificate>>>;
  companyConsent?: Maybe<Array<Maybe<CommercialPapersConnectionCompanyConsent>>>;
  signature?: Maybe<Array<Maybe<CommercialPapersConnectionSignature>>>;
  signedBy?: Maybe<Array<Maybe<CommercialPapersConnectionSignedBy>>>;
  signedAt?: Maybe<Array<Maybe<CommercialPapersConnectionSignedAt>>>;
  maturesAt?: Maybe<Array<Maybe<CommercialPapersConnectionMaturesAt>>>;
  investmentTermType?: Maybe<Array<Maybe<CommercialPapersConnectionInvestmentTermType>>>;
  investmentTerm?: Maybe<Array<Maybe<CommercialPapersConnectionInvestmentTerm>>>;
  user?: Maybe<Array<Maybe<CommercialPapersConnectionUser>>>;
  currentStep?: Maybe<Array<Maybe<CommercialPapersConnectionCurrentStep>>>;
  lengthOfCP?: Maybe<Array<Maybe<CommercialPapersConnectionLengthOfCp>>>;
  eligibilityRequirement?: Maybe<Array<Maybe<CommercialPapersConnectionEligibilityRequirement>>>;
  corporateGovernanceRequirement?: Maybe<Array<Maybe<CommercialPapersConnectionCorporateGovernanceRequirement>>>;
  approvedAt?: Maybe<Array<Maybe<CommercialPapersConnectionApprovedAt>>>;
  serviceInterestRate?: Maybe<Array<Maybe<CommercialPapersConnectionServiceInterestRate>>>;
  payout_request?: Maybe<Array<Maybe<CommercialPapersConnectionPayout_Request>>>;
  dateFunded?: Maybe<Array<Maybe<CommercialPapersConnectionDateFunded>>>;
  minInvestment?: Maybe<Array<Maybe<CommercialPapersConnectionMinInvestment>>>;
  interestFrequency?: Maybe<Array<Maybe<CommercialPapersConnectionInterestFrequency>>>;
  purchaseFee?: Maybe<Array<Maybe<CommercialPapersConnectionPurchaseFee>>>;
  shortHoldFee?: Maybe<Array<Maybe<CommercialPapersConnectionShortHoldFee>>>;
  shortHoldDescription?: Maybe<Array<Maybe<CommercialPapersConnectionShortHoldDescription>>>;
  interestFrequencyDescription?: Maybe<Array<Maybe<CommercialPapersConnectionInterestFrequencyDescription>>>;
  type?: Maybe<Array<Maybe<CommercialPapersConnectionType>>>;
  description?: Maybe<Array<Maybe<CommercialPapersConnectionDescription>>>;
  potentialRisks?: Maybe<Array<Maybe<CommercialPapersConnectionPotentialRisks>>>;
  title?: Maybe<Array<Maybe<CommercialPapersConnectionTitle>>>;
  managementFee?: Maybe<Array<Maybe<CommercialPapersConnectionManagementFee>>>;
  shortHoldFeeDuration?: Maybe<Array<Maybe<CommercialPapersConnectionShortHoldFeeDuration>>>;
  sellFee?: Maybe<Array<Maybe<CommercialPapersConnectionSellFee>>>;
  masterNoteMarketValue?: Maybe<Array<Maybe<CommercialPapersConnectionMasterNoteMarketValue>>>;
  noteMarketValue?: Maybe<Array<Maybe<CommercialPapersConnectionNoteMarketValue>>>;
  numberOfPaidInterest?: Maybe<Array<Maybe<CommercialPapersConnectionNumberOfPaidInterest>>>;
  masterNote?: Maybe<Array<Maybe<CommercialPapersConnectionMasterNote>>>;
  purchasePrice?: Maybe<Array<Maybe<CommercialPapersConnectionPurchasePrice>>>;
  lockDown?: Maybe<Array<Maybe<CommercialPapersConnectionLockDown>>>;
  faceValue?: Maybe<Array<Maybe<CommercialPapersConnectionFaceValue>>>;
  nextInterestPayment?: Maybe<Array<Maybe<CommercialPapersConnectionNextInterestPayment>>>;
  currency?: Maybe<Array<Maybe<CommercialPapersConnectionCurrency>>>;
  fundManager?: Maybe<Array<Maybe<CommercialPapersConnectionFundManager>>>;
  assetType?: Maybe<Array<Maybe<CommercialPapersConnectionAssetType>>>;
  followup?: Maybe<Array<Maybe<CommercialPapersConnectionFollowup>>>;
};

export type CommercialPapersConnectionId = {
  __typename?: 'CommercialPapersConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCreated_At = {
  __typename?: 'CommercialPapersConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionUpdated_At = {
  __typename?: 'CommercialPapersConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionSubmittedAt = {
  __typename?: 'CommercialPapersConnectionSubmittedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCompany = {
  __typename?: 'CommercialPapersConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionAmount = {
  __typename?: 'CommercialPapersConnectionAmount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionAmountNeeded = {
  __typename?: 'CommercialPapersConnectionAmountNeeded';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionPayoutDate = {
  __typename?: 'CommercialPapersConnectionPayoutDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionInterestRate = {
  __typename?: 'CommercialPapersConnectionInterestRate';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionStatus = {
  __typename?: 'CommercialPapersConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionIndustryType = {
  __typename?: 'CommercialPapersConnectionIndustryType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionProposedDateOfIssue = {
  __typename?: 'CommercialPapersConnectionProposedDateOfIssue';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionConditions = {
  __typename?: 'CommercialPapersConnectionConditions';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionPurposeOfIssue = {
  __typename?: 'CommercialPapersConnectionPurposeOfIssue';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCommercialPaperType = {
  __typename?: 'CommercialPapersConnectionCommercialPaperType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCertOfIncorporation = {
  __typename?: 'CommercialPapersConnectionCertOfIncorporation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionDirectorsApproval = {
  __typename?: 'CommercialPapersConnectionDirectorsApproval';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionAccountsReport = {
  __typename?: 'CommercialPapersConnectionAccountsReport';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionFinancialStatements = {
  __typename?: 'CommercialPapersConnectionFinancialStatements';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionTaxCertificate = {
  __typename?: 'CommercialPapersConnectionTaxCertificate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCompanyConsent = {
  __typename?: 'CommercialPapersConnectionCompanyConsent';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionSignature = {
  __typename?: 'CommercialPapersConnectionSignature';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionSignedBy = {
  __typename?: 'CommercialPapersConnectionSignedBy';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionSignedAt = {
  __typename?: 'CommercialPapersConnectionSignedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionMaturesAt = {
  __typename?: 'CommercialPapersConnectionMaturesAt';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionInvestmentTermType = {
  __typename?: 'CommercialPapersConnectionInvestmentTermType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionInvestmentTerm = {
  __typename?: 'CommercialPapersConnectionInvestmentTerm';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionUser = {
  __typename?: 'CommercialPapersConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCurrentStep = {
  __typename?: 'CommercialPapersConnectionCurrentStep';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionLengthOfCp = {
  __typename?: 'CommercialPapersConnectionLengthOfCP';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionEligibilityRequirement = {
  __typename?: 'CommercialPapersConnectionEligibilityRequirement';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCorporateGovernanceRequirement = {
  __typename?: 'CommercialPapersConnectionCorporateGovernanceRequirement';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionApprovedAt = {
  __typename?: 'CommercialPapersConnectionApprovedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionServiceInterestRate = {
  __typename?: 'CommercialPapersConnectionServiceInterestRate';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionPayout_Request = {
  __typename?: 'CommercialPapersConnectionPayout_request';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionDateFunded = {
  __typename?: 'CommercialPapersConnectionDateFunded';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionMinInvestment = {
  __typename?: 'CommercialPapersConnectionMinInvestment';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionInterestFrequency = {
  __typename?: 'CommercialPapersConnectionInterestFrequency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionPurchaseFee = {
  __typename?: 'CommercialPapersConnectionPurchaseFee';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionShortHoldFee = {
  __typename?: 'CommercialPapersConnectionShortHoldFee';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionShortHoldDescription = {
  __typename?: 'CommercialPapersConnectionShortHoldDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionInterestFrequencyDescription = {
  __typename?: 'CommercialPapersConnectionInterestFrequencyDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionType = {
  __typename?: 'CommercialPapersConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionDescription = {
  __typename?: 'CommercialPapersConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionPotentialRisks = {
  __typename?: 'CommercialPapersConnectionPotentialRisks';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionTitle = {
  __typename?: 'CommercialPapersConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionManagementFee = {
  __typename?: 'CommercialPapersConnectionManagementFee';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionShortHoldFeeDuration = {
  __typename?: 'CommercialPapersConnectionShortHoldFeeDuration';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionSellFee = {
  __typename?: 'CommercialPapersConnectionSellFee';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionMasterNoteMarketValue = {
  __typename?: 'CommercialPapersConnectionMasterNoteMarketValue';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionNoteMarketValue = {
  __typename?: 'CommercialPapersConnectionNoteMarketValue';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionNumberOfPaidInterest = {
  __typename?: 'CommercialPapersConnectionNumberOfPaidInterest';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionMasterNote = {
  __typename?: 'CommercialPapersConnectionMasterNote';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionPurchasePrice = {
  __typename?: 'CommercialPapersConnectionPurchasePrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionLockDown = {
  __typename?: 'CommercialPapersConnectionLockDown';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionFaceValue = {
  __typename?: 'CommercialPapersConnectionFaceValue';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionNextInterestPayment = {
  __typename?: 'CommercialPapersConnectionNextInterestPayment';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionCurrency = {
  __typename?: 'CommercialPapersConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionFundManager = {
  __typename?: 'CommercialPapersConnectionFundManager';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionAssetType = {
  __typename?: 'CommercialPapersConnectionAssetType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPapersConnectionFollowup = {
  __typename?: 'CommercialPapersConnectionFollowup';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CommercialPapersConnection>;
};

export type CommercialPaperInput = {
  submittedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['ID']>;
  amount?: Maybe<Scalars['Long']>;
  amountNeeded?: Maybe<Scalars['Long']>;
  payoutDate?: Maybe<Scalars['Date']>;
  interestRate?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Commercialpapers_Status>;
  industryType?: Maybe<Enum_Commercialpapers_Industrytype>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  conditions?: Maybe<Scalars['String']>;
  purposeOfIssue?: Maybe<Scalars['String']>;
  commercialPaperType?: Maybe<Enum_Commercialpapers_Commercialpapertype>;
  certOfIncorporation?: Maybe<Scalars['ID']>;
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  directorsApproval?: Maybe<Scalars['ID']>;
  accountsReport?: Maybe<Scalars['ID']>;
  financialStatements?: Maybe<Scalars['ID']>;
  taxCertificate?: Maybe<Scalars['ID']>;
  relevantDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyConsent?: Maybe<Scalars['ID']>;
  eligibilityRequirements?: Maybe<Array<Maybe<ComponentComplianceComplianceSectionInput>>>;
  corporateGovRequirements?: Maybe<Array<Maybe<ComponentComplianceComplianceSectionInput>>>;
  signature?: Maybe<Scalars['ID']>;
  signedBy?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  maturesAt?: Maybe<Scalars['Date']>;
  investmentTermType?: Maybe<Enum_Commercialpapers_Investmenttermtype>;
  investmentTerm?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  purchaseRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currentStep?: Maybe<Enum_Commercialpapers_Currentstep>;
  lengthOfCP?: Maybe<Scalars['Int']>;
  eligibilityRequirement?: Maybe<Scalars['ID']>;
  corporateGovernanceRequirement?: Maybe<Scalars['ID']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  rolloverRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contractAddress?: Maybe<Scalars['String']>;
  payout_request?: Maybe<Scalars['ID']>;
  dateFunded?: Maybe<Scalars['DateTime']>;
  minInvestment?: Maybe<Scalars['Long']>;
  interestFrequency?: Maybe<Enum_Commercialpapers_Interestfrequency>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDescription?: Maybe<Scalars['String']>;
  interestFrequencyDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Commercialpapers_Type>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  market_value_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Int']>;
  masterNote?: Maybe<Scalars['ID']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Int']>;
  faceValue?: Maybe<Scalars['Long']>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Commercialpapers_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  followup?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCommercialPaperInput = {
  submittedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['ID']>;
  amount?: Maybe<Scalars['Long']>;
  amountNeeded?: Maybe<Scalars['Long']>;
  payoutDate?: Maybe<Scalars['Date']>;
  interestRate?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Commercialpapers_Status>;
  industryType?: Maybe<Enum_Commercialpapers_Industrytype>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  conditions?: Maybe<Scalars['String']>;
  purposeOfIssue?: Maybe<Scalars['String']>;
  commercialPaperType?: Maybe<Enum_Commercialpapers_Commercialpapertype>;
  certOfIncorporation?: Maybe<Scalars['ID']>;
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  directorsApproval?: Maybe<Scalars['ID']>;
  accountsReport?: Maybe<Scalars['ID']>;
  financialStatements?: Maybe<Scalars['ID']>;
  taxCertificate?: Maybe<Scalars['ID']>;
  relevantDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyConsent?: Maybe<Scalars['ID']>;
  eligibilityRequirements?: Maybe<Array<Maybe<EditComponentComplianceComplianceSectionInput>>>;
  corporateGovRequirements?: Maybe<Array<Maybe<EditComponentComplianceComplianceSectionInput>>>;
  signature?: Maybe<Scalars['ID']>;
  signedBy?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  maturesAt?: Maybe<Scalars['Date']>;
  investmentTermType?: Maybe<Enum_Commercialpapers_Investmenttermtype>;
  investmentTerm?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  purchaseRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currentStep?: Maybe<Enum_Commercialpapers_Currentstep>;
  lengthOfCP?: Maybe<Scalars['Int']>;
  eligibilityRequirement?: Maybe<Scalars['ID']>;
  corporateGovernanceRequirement?: Maybe<Scalars['ID']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  rolloverRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contractAddress?: Maybe<Scalars['String']>;
  payout_request?: Maybe<Scalars['ID']>;
  dateFunded?: Maybe<Scalars['DateTime']>;
  minInvestment?: Maybe<Scalars['Long']>;
  interestFrequency?: Maybe<Enum_Commercialpapers_Interestfrequency>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDescription?: Maybe<Scalars['String']>;
  interestFrequencyDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Commercialpapers_Type>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  market_value_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Int']>;
  masterNote?: Maybe<Scalars['ID']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Int']>;
  faceValue?: Maybe<Scalars['Long']>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Commercialpapers_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  followup?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateCommercialPaperInput = {
  data?: Maybe<CommercialPaperInput>;
};

export type CreateCommercialPaperPayload = {
  __typename?: 'createCommercialPaperPayload';
  commercialPaper?: Maybe<CommercialPapers>;
};

export type UpdateCommercialPaperInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCommercialPaperInput>;
};

export type UpdateCommercialPaperPayload = {
  __typename?: 'updateCommercialPaperPayload';
  commercialPaper?: Maybe<CommercialPapers>;
};

export type DeleteCommercialPaperInput = {
  where?: Maybe<InputId>;
};

export type DeleteCommercialPaperPayload = {
  __typename?: 'deleteCommercialPaperPayload';
  commercialPaper?: Maybe<CommercialPapers>;
};

export enum Enum_Companies_Companytype {
  PubliclyListedCompany = 'PUBLICLY_LISTED_COMPANY',
  PrivateCompany = 'PRIVATE_COMPANY',
  Government = 'GOVERNMENT'
}

export enum Enum_Companies_Industrytype {
  Agriculture = 'AGRICULTURE',
  Construction = 'CONSTRUCTION',
  ConsumerGoods = 'CONSUMER_GOODS',
  Energy = 'ENERGY',
  Entertainment = 'ENTERTAINMENT',
  FinancialServices = 'FINANCIAL_SERVICES',
  Government = 'GOVERNMENT',
  Healthcare = 'HEALTHCARE',
  Hospitality = 'HOSPITALITY',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Infrastructure = 'INFRASTRUCTURE',
  Manufacturing = 'MANUFACTURING',
  Mining = 'MINING',
  Pharmaceuticals = 'PHARMACEUTICALS',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RealEstate = 'REAL_ESTATE',
  Retail = 'RETAIL',
  Telecommunication = 'TELECOMMUNICATION',
  Tourism = 'TOURISM',
  Transport = 'TRANSPORT',
  Other = 'OTHER'
}

export enum Enum_Companies_Registrationstatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type Companies = {
  __typename?: 'Companies';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
  name?: Maybe<Scalars['String']>;
  companyType?: Maybe<Enum_Companies_Companytype>;
  industryType?: Maybe<Enum_Companies_Industrytype>;
  logo?: Maybe<UploadFile>;
  briefDescription?: Maybe<Scalars['String']>;
  platformUseReason?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  financialSummary?: Maybe<FinancialSummaries>;
  registrationStatus?: Maybe<Enum_Companies_Registrationstatus>;
  formattedAddress?: Maybe<Scalars['String']>;
  netWorth?: Maybe<Scalars['Int']>;
  grossIncome?: Maybe<Scalars['Int']>;
  totalDebt?: Maybe<Scalars['Int']>;
  bankingInformation?: Maybe<BankingInformation>;
  activeSince?: Maybe<Scalars['DateTime']>;
  commercialPapers?: Maybe<Array<Maybe<CommercialPapers>>>;
  certificateOfIncorporation?: Maybe<Array<Maybe<UploadFile>>>;
  memorandumAndArticlesOfAssociation?: Maybe<Array<Maybe<UploadFile>>>;
  boardOfDirectorsApproval?: Maybe<Array<Maybe<UploadFile>>>;
  reportingAccountsReport?: Maybe<Array<Maybe<UploadFile>>>;
  financialStatements?: Maybe<Array<Maybe<UploadFile>>>;
  companyTAXCertificate?: Maybe<Array<Maybe<UploadFile>>>;
  relevantCompanyDocuments?: Maybe<Array<Maybe<UploadFile>>>;
  companyConsent?: Maybe<Array<Maybe<UploadFile>>>;
  informationMemorandum?: Maybe<Array<Maybe<UploadFile>>>;
  investments?: Maybe<Array<Maybe<Investments>>>;
};


export type CompaniesCommercialPapersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesCertificateOfIncorporationArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesMemorandumAndArticlesOfAssociationArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesBoardOfDirectorsApprovalArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesReportingAccountsReportArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesFinancialStatementsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesCompanyTaxCertificateArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesRelevantCompanyDocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesCompanyConsentArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesInformationMemorandumArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompaniesInvestmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  values?: Maybe<Array<Maybe<Companies>>>;
  groupBy?: Maybe<CompaniesGroupBy>;
  aggregate?: Maybe<CompaniesAggregator>;
};

export type CompaniesAggregator = {
  __typename?: 'CompaniesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CompaniesAggregatorSum>;
  avg?: Maybe<CompaniesAggregatorAvg>;
  min?: Maybe<CompaniesAggregatorMin>;
  max?: Maybe<CompaniesAggregatorMax>;
};

export type CompaniesAggregatorSum = {
  __typename?: 'CompaniesAggregatorSum';
  netWorth?: Maybe<Scalars['Float']>;
  grossIncome?: Maybe<Scalars['Float']>;
  totalDebt?: Maybe<Scalars['Float']>;
};

export type CompaniesAggregatorAvg = {
  __typename?: 'CompaniesAggregatorAvg';
  netWorth?: Maybe<Scalars['Float']>;
  grossIncome?: Maybe<Scalars['Float']>;
  totalDebt?: Maybe<Scalars['Float']>;
};

export type CompaniesAggregatorMin = {
  __typename?: 'CompaniesAggregatorMin';
  netWorth?: Maybe<Scalars['Float']>;
  grossIncome?: Maybe<Scalars['Float']>;
  totalDebt?: Maybe<Scalars['Float']>;
};

export type CompaniesAggregatorMax = {
  __typename?: 'CompaniesAggregatorMax';
  netWorth?: Maybe<Scalars['Float']>;
  grossIncome?: Maybe<Scalars['Float']>;
  totalDebt?: Maybe<Scalars['Float']>;
};

export type CompaniesGroupBy = {
  __typename?: 'CompaniesGroupBy';
  id?: Maybe<Array<Maybe<CompaniesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CompaniesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CompaniesConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<CompaniesConnectionUser>>>;
  name?: Maybe<Array<Maybe<CompaniesConnectionName>>>;
  companyType?: Maybe<Array<Maybe<CompaniesConnectionCompanyType>>>;
  industryType?: Maybe<Array<Maybe<CompaniesConnectionIndustryType>>>;
  logo?: Maybe<Array<Maybe<CompaniesConnectionLogo>>>;
  briefDescription?: Maybe<Array<Maybe<CompaniesConnectionBriefDescription>>>;
  platformUseReason?: Maybe<Array<Maybe<CompaniesConnectionPlatformUseReason>>>;
  registrationNumber?: Maybe<Array<Maybe<CompaniesConnectionRegistrationNumber>>>;
  registeredAt?: Maybe<Array<Maybe<CompaniesConnectionRegisteredAt>>>;
  countryOfRegistration?: Maybe<Array<Maybe<CompaniesConnectionCountryOfRegistration>>>;
  vatNumber?: Maybe<Array<Maybe<CompaniesConnectionVatNumber>>>;
  taxNumber?: Maybe<Array<Maybe<CompaniesConnectionTaxNumber>>>;
  financialSummary?: Maybe<Array<Maybe<CompaniesConnectionFinancialSummary>>>;
  registrationStatus?: Maybe<Array<Maybe<CompaniesConnectionRegistrationStatus>>>;
  formattedAddress?: Maybe<Array<Maybe<CompaniesConnectionFormattedAddress>>>;
  netWorth?: Maybe<Array<Maybe<CompaniesConnectionNetWorth>>>;
  grossIncome?: Maybe<Array<Maybe<CompaniesConnectionGrossIncome>>>;
  totalDebt?: Maybe<Array<Maybe<CompaniesConnectionTotalDebt>>>;
  bankingInformation?: Maybe<Array<Maybe<CompaniesConnectionBankingInformation>>>;
  activeSince?: Maybe<Array<Maybe<CompaniesConnectionActiveSince>>>;
};

export type CompaniesConnectionId = {
  __typename?: 'CompaniesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionCreated_At = {
  __typename?: 'CompaniesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionUpdated_At = {
  __typename?: 'CompaniesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionUser = {
  __typename?: 'CompaniesConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionName = {
  __typename?: 'CompaniesConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionCompanyType = {
  __typename?: 'CompaniesConnectionCompanyType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionIndustryType = {
  __typename?: 'CompaniesConnectionIndustryType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionLogo = {
  __typename?: 'CompaniesConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionBriefDescription = {
  __typename?: 'CompaniesConnectionBriefDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionPlatformUseReason = {
  __typename?: 'CompaniesConnectionPlatformUseReason';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionRegistrationNumber = {
  __typename?: 'CompaniesConnectionRegistrationNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionRegisteredAt = {
  __typename?: 'CompaniesConnectionRegisteredAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionCountryOfRegistration = {
  __typename?: 'CompaniesConnectionCountryOfRegistration';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionVatNumber = {
  __typename?: 'CompaniesConnectionVatNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionTaxNumber = {
  __typename?: 'CompaniesConnectionTaxNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionFinancialSummary = {
  __typename?: 'CompaniesConnectionFinancialSummary';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionRegistrationStatus = {
  __typename?: 'CompaniesConnectionRegistrationStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionFormattedAddress = {
  __typename?: 'CompaniesConnectionFormattedAddress';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionNetWorth = {
  __typename?: 'CompaniesConnectionNetWorth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionGrossIncome = {
  __typename?: 'CompaniesConnectionGrossIncome';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionTotalDebt = {
  __typename?: 'CompaniesConnectionTotalDebt';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionBankingInformation = {
  __typename?: 'CompaniesConnectionBankingInformation';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompaniesConnectionActiveSince = {
  __typename?: 'CompaniesConnectionActiveSince';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompaniesConnection>;
};

export type CompanyInput = {
  user?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  companyType?: Maybe<Enum_Companies_Companytype>;
  industryType?: Maybe<Enum_Companies_Industrytype>;
  logo?: Maybe<Scalars['ID']>;
  briefDescription?: Maybe<Scalars['String']>;
  platformUseReason?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  financialSummary?: Maybe<Scalars['ID']>;
  commercialPapers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  registrationStatus?: Maybe<Enum_Companies_Registrationstatus>;
  formattedAddress?: Maybe<Scalars['String']>;
  netWorth?: Maybe<Scalars['Int']>;
  grossIncome?: Maybe<Scalars['Int']>;
  totalDebt?: Maybe<Scalars['Int']>;
  bankingInformation?: Maybe<Scalars['ID']>;
  certificateOfIncorporation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  memorandumAndArticlesOfAssociation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  boardOfDirectorsApproval?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reportingAccountsReport?: Maybe<Array<Maybe<Scalars['ID']>>>;
  financialStatements?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyTAXCertificate?: Maybe<Array<Maybe<Scalars['ID']>>>;
  relevantCompanyDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyConsent?: Maybe<Array<Maybe<Scalars['ID']>>>;
  informationMemorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  activeSince?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCompanyInput = {
  user?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  companyType?: Maybe<Enum_Companies_Companytype>;
  industryType?: Maybe<Enum_Companies_Industrytype>;
  logo?: Maybe<Scalars['ID']>;
  briefDescription?: Maybe<Scalars['String']>;
  platformUseReason?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  financialSummary?: Maybe<Scalars['ID']>;
  commercialPapers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  registrationStatus?: Maybe<Enum_Companies_Registrationstatus>;
  formattedAddress?: Maybe<Scalars['String']>;
  netWorth?: Maybe<Scalars['Int']>;
  grossIncome?: Maybe<Scalars['Int']>;
  totalDebt?: Maybe<Scalars['Int']>;
  bankingInformation?: Maybe<Scalars['ID']>;
  certificateOfIncorporation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  memorandumAndArticlesOfAssociation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  boardOfDirectorsApproval?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reportingAccountsReport?: Maybe<Array<Maybe<Scalars['ID']>>>;
  financialStatements?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyTAXCertificate?: Maybe<Array<Maybe<Scalars['ID']>>>;
  relevantCompanyDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyConsent?: Maybe<Array<Maybe<Scalars['ID']>>>;
  informationMemorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  activeSince?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateCompanyInput = {
  data?: Maybe<CompanyInput>;
};

export type CreateCompanyPayload = {
  __typename?: 'createCompanyPayload';
  company?: Maybe<Companies>;
};

export type UpdateCompanyInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCompanyInput>;
};

export type UpdateCompanyPayload = {
  __typename?: 'updateCompanyPayload';
  company?: Maybe<Companies>;
};

export type DeleteCompanyInput = {
  where?: Maybe<InputId>;
};

export type DeleteCompanyPayload = {
  __typename?: 'deleteCompanyPayload';
  company?: Maybe<Companies>;
};

export type CorporateGovernanceRequirements = {
  __typename?: 'CorporateGovernanceRequirements';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  reasonsForNonCompliance?: Maybe<Scalars['Boolean']>;
  strategicGuidance?: Maybe<Scalars['Boolean']>;
  relevantCommittees?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  balanceOfExecutiveAndNonExecutiveDirectors?: Maybe<Scalars['Boolean']>;
  directorCompliance?: Maybe<Scalars['Boolean']>;
  reasonsForNonComplianceComment?: Maybe<Scalars['String']>;
  strategicGuidanceComment?: Maybe<Scalars['String']>;
  relevantCommitteesComment?: Maybe<Scalars['String']>;
  committeeSpecificationsBoardComment?: Maybe<Scalars['String']>;
  balanceOfExecutiveAndNonExecutiveDirectorsComment?: Maybe<Scalars['String']>;
  directorComplianceComment?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<CommercialPapers>;
  committeeSpecificationsBoard?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilities?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilitiesComment?: Maybe<Scalars['String']>;
  chairpersonCompliance?: Maybe<Scalars['Boolean']>;
  chairpersonComplianceComment?: Maybe<Scalars['String']>;
  nominatingCommittee?: Maybe<Scalars['Boolean']>;
  nominatingCommitteeComment?: Maybe<Scalars['String']>;
  auditCommittee?: Maybe<Scalars['Boolean']>;
  auditCommitteeComment?: Maybe<Scalars['String']>;
};

export type CorporateGovernanceRequirementsConnection = {
  __typename?: 'CorporateGovernanceRequirementsConnection';
  values?: Maybe<Array<Maybe<CorporateGovernanceRequirements>>>;
  groupBy?: Maybe<CorporateGovernanceRequirementsGroupBy>;
  aggregate?: Maybe<CorporateGovernanceRequirementsAggregator>;
};

export type CorporateGovernanceRequirementsAggregator = {
  __typename?: 'CorporateGovernanceRequirementsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CorporateGovernanceRequirementsGroupBy = {
  __typename?: 'CorporateGovernanceRequirementsGroupBy';
  id?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionUpdated_At>>>;
  reasonsForNonCompliance?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionReasonsForNonCompliance>>>;
  strategicGuidance?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionStrategicGuidance>>>;
  relevantCommittees?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionRelevantCommittees>>>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionAvailabilityAndReliabilityOfFinancialRecords>>>;
  balanceOfExecutiveAndNonExecutiveDirectors?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectors>>>;
  directorCompliance?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionDirectorCompliance>>>;
  reasonsForNonComplianceComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionReasonsForNonComplianceComment>>>;
  strategicGuidanceComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionStrategicGuidanceComment>>>;
  relevantCommitteesComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionRelevantCommitteesComment>>>;
  committeeSpecificationsBoardComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoardComment>>>;
  balanceOfExecutiveAndNonExecutiveDirectorsComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectorsComment>>>;
  directorComplianceComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionDirectorComplianceComment>>>;
  commercialPaper?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionCommercialPaper>>>;
  committeeSpecificationsBoard?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoard>>>;
  rolesAndResponsibilities?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionRolesAndResponsibilities>>>;
  rolesAndResponsibilitiesComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionRolesAndResponsibilitiesComment>>>;
  chairpersonCompliance?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionChairpersonCompliance>>>;
  chairpersonComplianceComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionChairpersonComplianceComment>>>;
  nominatingCommittee?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionNominatingCommittee>>>;
  nominatingCommitteeComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionNominatingCommitteeComment>>>;
  auditCommittee?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionAuditCommittee>>>;
  auditCommitteeComment?: Maybe<Array<Maybe<CorporateGovernanceRequirementsConnectionAuditCommitteeComment>>>;
};

export type CorporateGovernanceRequirementsConnectionId = {
  __typename?: 'CorporateGovernanceRequirementsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionCreated_At = {
  __typename?: 'CorporateGovernanceRequirementsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionUpdated_At = {
  __typename?: 'CorporateGovernanceRequirementsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionReasonsForNonCompliance = {
  __typename?: 'CorporateGovernanceRequirementsConnectionReasonsForNonCompliance';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionStrategicGuidance = {
  __typename?: 'CorporateGovernanceRequirementsConnectionStrategicGuidance';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionRelevantCommittees = {
  __typename?: 'CorporateGovernanceRequirementsConnectionRelevantCommittees';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionAvailabilityAndReliabilityOfFinancialRecords = {
  __typename?: 'CorporateGovernanceRequirementsConnectionAvailabilityAndReliabilityOfFinancialRecords';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectors = {
  __typename?: 'CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectors';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionDirectorCompliance = {
  __typename?: 'CorporateGovernanceRequirementsConnectionDirectorCompliance';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionReasonsForNonComplianceComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionReasonsForNonComplianceComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionStrategicGuidanceComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionStrategicGuidanceComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionRelevantCommitteesComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionRelevantCommitteesComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoardComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoardComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectorsComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectorsComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionDirectorComplianceComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionDirectorComplianceComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionCommercialPaper = {
  __typename?: 'CorporateGovernanceRequirementsConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoard = {
  __typename?: 'CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoard';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionRolesAndResponsibilities = {
  __typename?: 'CorporateGovernanceRequirementsConnectionRolesAndResponsibilities';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionRolesAndResponsibilitiesComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionRolesAndResponsibilitiesComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionChairpersonCompliance = {
  __typename?: 'CorporateGovernanceRequirementsConnectionChairpersonCompliance';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionChairpersonComplianceComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionChairpersonComplianceComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionNominatingCommittee = {
  __typename?: 'CorporateGovernanceRequirementsConnectionNominatingCommittee';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionNominatingCommitteeComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionNominatingCommitteeComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionAuditCommittee = {
  __typename?: 'CorporateGovernanceRequirementsConnectionAuditCommittee';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementsConnectionAuditCommitteeComment = {
  __typename?: 'CorporateGovernanceRequirementsConnectionAuditCommitteeComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CorporateGovernanceRequirementsConnection>;
};

export type CorporateGovernanceRequirementInput = {
  reasonsForNonCompliance?: Maybe<Scalars['Boolean']>;
  strategicGuidance?: Maybe<Scalars['Boolean']>;
  relevantCommittees?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  balanceOfExecutiveAndNonExecutiveDirectors?: Maybe<Scalars['Boolean']>;
  directorCompliance?: Maybe<Scalars['Boolean']>;
  reasonsForNonComplianceComment?: Maybe<Scalars['String']>;
  strategicGuidanceComment?: Maybe<Scalars['String']>;
  relevantCommitteesComment?: Maybe<Scalars['String']>;
  committeeSpecificationsBoardComment?: Maybe<Scalars['String']>;
  balanceOfExecutiveAndNonExecutiveDirectorsComment?: Maybe<Scalars['String']>;
  directorComplianceComment?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  committeeSpecificationsBoard?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilities?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilitiesComment?: Maybe<Scalars['String']>;
  chairpersonCompliance?: Maybe<Scalars['Boolean']>;
  chairpersonComplianceComment?: Maybe<Scalars['String']>;
  nominatingCommittee?: Maybe<Scalars['Boolean']>;
  nominatingCommitteeComment?: Maybe<Scalars['String']>;
  auditCommittee?: Maybe<Scalars['Boolean']>;
  auditCommitteeComment?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCorporateGovernanceRequirementInput = {
  reasonsForNonCompliance?: Maybe<Scalars['Boolean']>;
  strategicGuidance?: Maybe<Scalars['Boolean']>;
  relevantCommittees?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  balanceOfExecutiveAndNonExecutiveDirectors?: Maybe<Scalars['Boolean']>;
  directorCompliance?: Maybe<Scalars['Boolean']>;
  reasonsForNonComplianceComment?: Maybe<Scalars['String']>;
  strategicGuidanceComment?: Maybe<Scalars['String']>;
  relevantCommitteesComment?: Maybe<Scalars['String']>;
  committeeSpecificationsBoardComment?: Maybe<Scalars['String']>;
  balanceOfExecutiveAndNonExecutiveDirectorsComment?: Maybe<Scalars['String']>;
  directorComplianceComment?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  committeeSpecificationsBoard?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilities?: Maybe<Scalars['Boolean']>;
  rolesAndResponsibilitiesComment?: Maybe<Scalars['String']>;
  chairpersonCompliance?: Maybe<Scalars['Boolean']>;
  chairpersonComplianceComment?: Maybe<Scalars['String']>;
  nominatingCommittee?: Maybe<Scalars['Boolean']>;
  nominatingCommitteeComment?: Maybe<Scalars['String']>;
  auditCommittee?: Maybe<Scalars['Boolean']>;
  auditCommitteeComment?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateCorporateGovernanceRequirementInput = {
  data?: Maybe<CorporateGovernanceRequirementInput>;
};

export type CreateCorporateGovernanceRequirementPayload = {
  __typename?: 'createCorporateGovernanceRequirementPayload';
  corporateGovernanceRequirement?: Maybe<CorporateGovernanceRequirements>;
};

export type UpdateCorporateGovernanceRequirementInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCorporateGovernanceRequirementInput>;
};

export type UpdateCorporateGovernanceRequirementPayload = {
  __typename?: 'updateCorporateGovernanceRequirementPayload';
  corporateGovernanceRequirement?: Maybe<CorporateGovernanceRequirements>;
};

export type DeleteCorporateGovernanceRequirementInput = {
  where?: Maybe<InputId>;
};

export type DeleteCorporateGovernanceRequirementPayload = {
  __typename?: 'deleteCorporateGovernanceRequirementPayload';
  corporateGovernanceRequirement?: Maybe<CorporateGovernanceRequirements>;
};

export type EligibilityRequirement = {
  __typename?: 'EligibilityRequirement';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  incorporationWithLimitedLiability?: Maybe<Scalars['Boolean']>;
  incorporationWithLimitedLiabilityComment?: Maybe<Scalars['String']>;
  shareCapitalAndNetAssetsOfIssuer?: Maybe<Scalars['Boolean']>;
  shareCapitalAndNetAssetsOfIssuerComment?: Maybe<Scalars['String']>;
  listingAndTransferabilityOfSecurities?: Maybe<Scalars['Boolean']>;
  listingAndTransferabilityOfSecuritiesComment?: Maybe<Scalars['String']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecordsComment?: Maybe<Scalars['String']>;
  directorsAndSeniorManagement?: Maybe<Scalars['Boolean']>;
  directorsAndSeniorManagementComment?: Maybe<Scalars['String']>;
  certificateOfComfort?: Maybe<Scalars['Boolean']>;
  certificateOfComfortComment?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<CommercialPapers>;
  profitableHistoricTrackRecordAndFutureProspects?: Maybe<Scalars['Boolean']>;
  profitableHistoricTrackRecordAndFutureProspectsComment?: Maybe<Scalars['String']>;
  guaranteeRequirements?: Maybe<Scalars['Boolean']>;
  guaranteeRequirementsComment?: Maybe<Scalars['String']>;
  debtRatio?: Maybe<Scalars['Boolean']>;
  debtRatioComment?: Maybe<Scalars['String']>;
  sizeIssue?: Maybe<Scalars['Boolean']>;
  sizeIssueComment?: Maybe<Scalars['String']>;
  minimumSize?: Maybe<Scalars['Boolean']>;
  minimumSizeComment?: Maybe<Scalars['String']>;
  renewalDate?: Maybe<Scalars['Boolean']>;
  renewalDateComment?: Maybe<Scalars['String']>;
};

export type EligibilityRequirementConnection = {
  __typename?: 'EligibilityRequirementConnection';
  values?: Maybe<Array<Maybe<EligibilityRequirement>>>;
  groupBy?: Maybe<EligibilityRequirementGroupBy>;
  aggregate?: Maybe<EligibilityRequirementAggregator>;
};

export type EligibilityRequirementAggregator = {
  __typename?: 'EligibilityRequirementAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EligibilityRequirementGroupBy = {
  __typename?: 'EligibilityRequirementGroupBy';
  id?: Maybe<Array<Maybe<EligibilityRequirementConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EligibilityRequirementConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EligibilityRequirementConnectionUpdated_At>>>;
  incorporationWithLimitedLiability?: Maybe<Array<Maybe<EligibilityRequirementConnectionIncorporationWithLimitedLiability>>>;
  incorporationWithLimitedLiabilityComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionIncorporationWithLimitedLiabilityComment>>>;
  shareCapitalAndNetAssetsOfIssuer?: Maybe<Array<Maybe<EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuer>>>;
  shareCapitalAndNetAssetsOfIssuerComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuerComment>>>;
  listingAndTransferabilityOfSecurities?: Maybe<Array<Maybe<EligibilityRequirementConnectionListingAndTransferabilityOfSecurities>>>;
  listingAndTransferabilityOfSecuritiesComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionListingAndTransferabilityOfSecuritiesComment>>>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Array<Maybe<EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecords>>>;
  availabilityAndReliabilityOfFinancialRecordsComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecordsComment>>>;
  directorsAndSeniorManagement?: Maybe<Array<Maybe<EligibilityRequirementConnectionDirectorsAndSeniorManagement>>>;
  directorsAndSeniorManagementComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionDirectorsAndSeniorManagementComment>>>;
  certificateOfComfort?: Maybe<Array<Maybe<EligibilityRequirementConnectionCertificateOfComfort>>>;
  certificateOfComfortComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionCertificateOfComfortComment>>>;
  commercialPaper?: Maybe<Array<Maybe<EligibilityRequirementConnectionCommercialPaper>>>;
  profitableHistoricTrackRecordAndFutureProspects?: Maybe<Array<Maybe<EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspects>>>;
  profitableHistoricTrackRecordAndFutureProspectsComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspectsComment>>>;
  guaranteeRequirements?: Maybe<Array<Maybe<EligibilityRequirementConnectionGuaranteeRequirements>>>;
  guaranteeRequirementsComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionGuaranteeRequirementsComment>>>;
  debtRatio?: Maybe<Array<Maybe<EligibilityRequirementConnectionDebtRatio>>>;
  debtRatioComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionDebtRatioComment>>>;
  sizeIssue?: Maybe<Array<Maybe<EligibilityRequirementConnectionSizeIssue>>>;
  sizeIssueComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionSizeIssueComment>>>;
  minimumSize?: Maybe<Array<Maybe<EligibilityRequirementConnectionMinimumSize>>>;
  minimumSizeComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionMinimumSizeComment>>>;
  renewalDate?: Maybe<Array<Maybe<EligibilityRequirementConnectionRenewalDate>>>;
  renewalDateComment?: Maybe<Array<Maybe<EligibilityRequirementConnectionRenewalDateComment>>>;
};

export type EligibilityRequirementConnectionId = {
  __typename?: 'EligibilityRequirementConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionCreated_At = {
  __typename?: 'EligibilityRequirementConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionUpdated_At = {
  __typename?: 'EligibilityRequirementConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionIncorporationWithLimitedLiability = {
  __typename?: 'EligibilityRequirementConnectionIncorporationWithLimitedLiability';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionIncorporationWithLimitedLiabilityComment = {
  __typename?: 'EligibilityRequirementConnectionIncorporationWithLimitedLiabilityComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuer = {
  __typename?: 'EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuer';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuerComment = {
  __typename?: 'EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuerComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionListingAndTransferabilityOfSecurities = {
  __typename?: 'EligibilityRequirementConnectionListingAndTransferabilityOfSecurities';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionListingAndTransferabilityOfSecuritiesComment = {
  __typename?: 'EligibilityRequirementConnectionListingAndTransferabilityOfSecuritiesComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecords = {
  __typename?: 'EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecords';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecordsComment = {
  __typename?: 'EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecordsComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionDirectorsAndSeniorManagement = {
  __typename?: 'EligibilityRequirementConnectionDirectorsAndSeniorManagement';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionDirectorsAndSeniorManagementComment = {
  __typename?: 'EligibilityRequirementConnectionDirectorsAndSeniorManagementComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionCertificateOfComfort = {
  __typename?: 'EligibilityRequirementConnectionCertificateOfComfort';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionCertificateOfComfortComment = {
  __typename?: 'EligibilityRequirementConnectionCertificateOfComfortComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionCommercialPaper = {
  __typename?: 'EligibilityRequirementConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspects = {
  __typename?: 'EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspects';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspectsComment = {
  __typename?: 'EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspectsComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionGuaranteeRequirements = {
  __typename?: 'EligibilityRequirementConnectionGuaranteeRequirements';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionGuaranteeRequirementsComment = {
  __typename?: 'EligibilityRequirementConnectionGuaranteeRequirementsComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionDebtRatio = {
  __typename?: 'EligibilityRequirementConnectionDebtRatio';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionDebtRatioComment = {
  __typename?: 'EligibilityRequirementConnectionDebtRatioComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionSizeIssue = {
  __typename?: 'EligibilityRequirementConnectionSizeIssue';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionSizeIssueComment = {
  __typename?: 'EligibilityRequirementConnectionSizeIssueComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionMinimumSize = {
  __typename?: 'EligibilityRequirementConnectionMinimumSize';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionMinimumSizeComment = {
  __typename?: 'EligibilityRequirementConnectionMinimumSizeComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionRenewalDate = {
  __typename?: 'EligibilityRequirementConnectionRenewalDate';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementConnectionRenewalDateComment = {
  __typename?: 'EligibilityRequirementConnectionRenewalDateComment';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EligibilityRequirementConnection>;
};

export type EligibilityRequirementInput = {
  incorporationWithLimitedLiability?: Maybe<Scalars['Boolean']>;
  incorporationWithLimitedLiabilityComment?: Maybe<Scalars['String']>;
  shareCapitalAndNetAssetsOfIssuer?: Maybe<Scalars['Boolean']>;
  shareCapitalAndNetAssetsOfIssuerComment?: Maybe<Scalars['String']>;
  listingAndTransferabilityOfSecurities?: Maybe<Scalars['Boolean']>;
  listingAndTransferabilityOfSecuritiesComment?: Maybe<Scalars['String']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecordsComment?: Maybe<Scalars['String']>;
  directorsAndSeniorManagement?: Maybe<Scalars['Boolean']>;
  directorsAndSeniorManagementComment?: Maybe<Scalars['String']>;
  certificateOfComfort?: Maybe<Scalars['Boolean']>;
  certificateOfComfortComment?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  profitableHistoricTrackRecordAndFutureProspects?: Maybe<Scalars['Boolean']>;
  profitableHistoricTrackRecordAndFutureProspectsComment?: Maybe<Scalars['String']>;
  guaranteeRequirements?: Maybe<Scalars['Boolean']>;
  guaranteeRequirementsComment?: Maybe<Scalars['String']>;
  debtRatio?: Maybe<Scalars['Boolean']>;
  debtRatioComment?: Maybe<Scalars['String']>;
  sizeIssue?: Maybe<Scalars['Boolean']>;
  sizeIssueComment?: Maybe<Scalars['String']>;
  minimumSize?: Maybe<Scalars['Boolean']>;
  minimumSizeComment?: Maybe<Scalars['String']>;
  renewalDate?: Maybe<Scalars['Boolean']>;
  renewalDateComment?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEligibilityRequirementInput = {
  incorporationWithLimitedLiability?: Maybe<Scalars['Boolean']>;
  incorporationWithLimitedLiabilityComment?: Maybe<Scalars['String']>;
  shareCapitalAndNetAssetsOfIssuer?: Maybe<Scalars['Boolean']>;
  shareCapitalAndNetAssetsOfIssuerComment?: Maybe<Scalars['String']>;
  listingAndTransferabilityOfSecurities?: Maybe<Scalars['Boolean']>;
  listingAndTransferabilityOfSecuritiesComment?: Maybe<Scalars['String']>;
  availabilityAndReliabilityOfFinancialRecords?: Maybe<Scalars['Boolean']>;
  availabilityAndReliabilityOfFinancialRecordsComment?: Maybe<Scalars['String']>;
  directorsAndSeniorManagement?: Maybe<Scalars['Boolean']>;
  directorsAndSeniorManagementComment?: Maybe<Scalars['String']>;
  certificateOfComfort?: Maybe<Scalars['Boolean']>;
  certificateOfComfortComment?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  profitableHistoricTrackRecordAndFutureProspects?: Maybe<Scalars['Boolean']>;
  profitableHistoricTrackRecordAndFutureProspectsComment?: Maybe<Scalars['String']>;
  guaranteeRequirements?: Maybe<Scalars['Boolean']>;
  guaranteeRequirementsComment?: Maybe<Scalars['String']>;
  debtRatio?: Maybe<Scalars['Boolean']>;
  debtRatioComment?: Maybe<Scalars['String']>;
  sizeIssue?: Maybe<Scalars['Boolean']>;
  sizeIssueComment?: Maybe<Scalars['String']>;
  minimumSize?: Maybe<Scalars['Boolean']>;
  minimumSizeComment?: Maybe<Scalars['String']>;
  renewalDate?: Maybe<Scalars['Boolean']>;
  renewalDateComment?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateEligibilityRequirementInput = {
  data?: Maybe<EligibilityRequirementInput>;
};

export type CreateEligibilityRequirementPayload = {
  __typename?: 'createEligibilityRequirementPayload';
  eligibilityRequirement?: Maybe<EligibilityRequirement>;
};

export type UpdateEligibilityRequirementInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEligibilityRequirementInput>;
};

export type UpdateEligibilityRequirementPayload = {
  __typename?: 'updateEligibilityRequirementPayload';
  eligibilityRequirement?: Maybe<EligibilityRequirement>;
};

export type DeleteEligibilityRequirementInput = {
  where?: Maybe<InputId>;
};

export type DeleteEligibilityRequirementPayload = {
  __typename?: 'deleteEligibilityRequirementPayload';
  eligibilityRequirement?: Maybe<EligibilityRequirement>;
};

export type FinancialSummaries = {
  __typename?: 'FinancialSummaries';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  netWorth?: Maybe<Scalars['Long']>;
  totalDeptOutstanding?: Maybe<Scalars['Long']>;
  totalDeptOutstandingOther?: Maybe<Scalars['Long']>;
  grossIncome?: Maybe<Scalars['Long']>;
  grossProfit?: Maybe<Scalars['Long']>;
  operatingProfit?: Maybe<Scalars['Long']>;
  netProfit?: Maybe<Scalars['Long']>;
  detailsOfDefaultCP?: Maybe<Scalars['String']>;
  detailsOfDefaultDelay?: Maybe<Scalars['String']>;
  company?: Maybe<Companies>;
};

export type FinancialSummariesConnection = {
  __typename?: 'FinancialSummariesConnection';
  values?: Maybe<Array<Maybe<FinancialSummaries>>>;
  groupBy?: Maybe<FinancialSummariesGroupBy>;
  aggregate?: Maybe<FinancialSummariesAggregator>;
};

export type FinancialSummariesAggregator = {
  __typename?: 'FinancialSummariesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FinancialSummariesGroupBy = {
  __typename?: 'FinancialSummariesGroupBy';
  id?: Maybe<Array<Maybe<FinancialSummariesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FinancialSummariesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FinancialSummariesConnectionUpdated_At>>>;
  netWorth?: Maybe<Array<Maybe<FinancialSummariesConnectionNetWorth>>>;
  totalDeptOutstanding?: Maybe<Array<Maybe<FinancialSummariesConnectionTotalDeptOutstanding>>>;
  totalDeptOutstandingOther?: Maybe<Array<Maybe<FinancialSummariesConnectionTotalDeptOutstandingOther>>>;
  grossIncome?: Maybe<Array<Maybe<FinancialSummariesConnectionGrossIncome>>>;
  grossProfit?: Maybe<Array<Maybe<FinancialSummariesConnectionGrossProfit>>>;
  operatingProfit?: Maybe<Array<Maybe<FinancialSummariesConnectionOperatingProfit>>>;
  netProfit?: Maybe<Array<Maybe<FinancialSummariesConnectionNetProfit>>>;
  detailsOfDefaultCP?: Maybe<Array<Maybe<FinancialSummariesConnectionDetailsOfDefaultCp>>>;
  detailsOfDefaultDelay?: Maybe<Array<Maybe<FinancialSummariesConnectionDetailsOfDefaultDelay>>>;
  company?: Maybe<Array<Maybe<FinancialSummariesConnectionCompany>>>;
};

export type FinancialSummariesConnectionId = {
  __typename?: 'FinancialSummariesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionCreated_At = {
  __typename?: 'FinancialSummariesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionUpdated_At = {
  __typename?: 'FinancialSummariesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionNetWorth = {
  __typename?: 'FinancialSummariesConnectionNetWorth';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionTotalDeptOutstanding = {
  __typename?: 'FinancialSummariesConnectionTotalDeptOutstanding';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionTotalDeptOutstandingOther = {
  __typename?: 'FinancialSummariesConnectionTotalDeptOutstandingOther';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionGrossIncome = {
  __typename?: 'FinancialSummariesConnectionGrossIncome';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionGrossProfit = {
  __typename?: 'FinancialSummariesConnectionGrossProfit';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionOperatingProfit = {
  __typename?: 'FinancialSummariesConnectionOperatingProfit';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionNetProfit = {
  __typename?: 'FinancialSummariesConnectionNetProfit';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionDetailsOfDefaultCp = {
  __typename?: 'FinancialSummariesConnectionDetailsOfDefaultCP';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionDetailsOfDefaultDelay = {
  __typename?: 'FinancialSummariesConnectionDetailsOfDefaultDelay';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummariesConnectionCompany = {
  __typename?: 'FinancialSummariesConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FinancialSummariesConnection>;
};

export type FinancialSummaryInput = {
  netWorth?: Maybe<Scalars['Long']>;
  totalDeptOutstanding?: Maybe<Scalars['Long']>;
  totalDeptOutstandingOther?: Maybe<Scalars['Long']>;
  grossIncome?: Maybe<Scalars['Long']>;
  grossProfit?: Maybe<Scalars['Long']>;
  operatingProfit?: Maybe<Scalars['Long']>;
  netProfit?: Maybe<Scalars['Long']>;
  detailsOfDefaultCP?: Maybe<Scalars['String']>;
  detailsOfDefaultDelay?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFinancialSummaryInput = {
  netWorth?: Maybe<Scalars['Long']>;
  totalDeptOutstanding?: Maybe<Scalars['Long']>;
  totalDeptOutstandingOther?: Maybe<Scalars['Long']>;
  grossIncome?: Maybe<Scalars['Long']>;
  grossProfit?: Maybe<Scalars['Long']>;
  operatingProfit?: Maybe<Scalars['Long']>;
  netProfit?: Maybe<Scalars['Long']>;
  detailsOfDefaultCP?: Maybe<Scalars['String']>;
  detailsOfDefaultDelay?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateFinancialSummaryInput = {
  data?: Maybe<FinancialSummaryInput>;
};

export type CreateFinancialSummaryPayload = {
  __typename?: 'createFinancialSummaryPayload';
  financialSummary?: Maybe<FinancialSummaries>;
};

export type UpdateFinancialSummaryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFinancialSummaryInput>;
};

export type UpdateFinancialSummaryPayload = {
  __typename?: 'updateFinancialSummaryPayload';
  financialSummary?: Maybe<FinancialSummaries>;
};

export type DeleteFinancialSummaryInput = {
  where?: Maybe<InputId>;
};

export type DeleteFinancialSummaryPayload = {
  __typename?: 'deleteFinancialSummaryPayload';
  financialSummary?: Maybe<FinancialSummaries>;
};

export enum Enum_Investments_Status {
  PaidOut = 'PAID_OUT',
  Invested = 'INVESTED',
  Pending = 'PENDING'
}

export enum Enum_Investments_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export type Investments = {
  __typename?: 'Investments';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  amount?: Maybe<Scalars['Int']>;
  commercialPaper?: Maybe<CommercialPapers>;
  status?: Maybe<Enum_Investments_Status>;
  company?: Maybe<Companies>;
  user?: Maybe<UsersPermissionsUser>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  totalReturn?: Maybe<Scalars['Int']>;
  lastPayInterestDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Investments_Currency>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
};


export type InvestmentsTransactionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type InvestmentsConnection = {
  __typename?: 'InvestmentsConnection';
  values?: Maybe<Array<Maybe<Investments>>>;
  groupBy?: Maybe<InvestmentsGroupBy>;
  aggregate?: Maybe<InvestmentsAggregator>;
};

export type InvestmentsAggregator = {
  __typename?: 'InvestmentsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<InvestmentsAggregatorSum>;
  avg?: Maybe<InvestmentsAggregatorAvg>;
  min?: Maybe<InvestmentsAggregatorMin>;
  max?: Maybe<InvestmentsAggregatorMax>;
};

export type InvestmentsAggregatorSum = {
  __typename?: 'InvestmentsAggregatorSum';
  amount?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
};

export type InvestmentsAggregatorAvg = {
  __typename?: 'InvestmentsAggregatorAvg';
  amount?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
};

export type InvestmentsAggregatorMin = {
  __typename?: 'InvestmentsAggregatorMin';
  amount?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
};

export type InvestmentsAggregatorMax = {
  __typename?: 'InvestmentsAggregatorMax';
  amount?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
};

export type InvestmentsGroupBy = {
  __typename?: 'InvestmentsGroupBy';
  id?: Maybe<Array<Maybe<InvestmentsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<InvestmentsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<InvestmentsConnectionUpdated_At>>>;
  amount?: Maybe<Array<Maybe<InvestmentsConnectionAmount>>>;
  commercialPaper?: Maybe<Array<Maybe<InvestmentsConnectionCommercialPaper>>>;
  status?: Maybe<Array<Maybe<InvestmentsConnectionStatus>>>;
  company?: Maybe<Array<Maybe<InvestmentsConnectionCompany>>>;
  user?: Maybe<Array<Maybe<InvestmentsConnectionUser>>>;
  approvedAt?: Maybe<Array<Maybe<InvestmentsConnectionApprovedAt>>>;
  totalReturn?: Maybe<Array<Maybe<InvestmentsConnectionTotalReturn>>>;
  lastPayInterestDate?: Maybe<Array<Maybe<InvestmentsConnectionLastPayInterestDate>>>;
  currency?: Maybe<Array<Maybe<InvestmentsConnectionCurrency>>>;
};

export type InvestmentsConnectionId = {
  __typename?: 'InvestmentsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionCreated_At = {
  __typename?: 'InvestmentsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionUpdated_At = {
  __typename?: 'InvestmentsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionAmount = {
  __typename?: 'InvestmentsConnectionAmount';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionCommercialPaper = {
  __typename?: 'InvestmentsConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionStatus = {
  __typename?: 'InvestmentsConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionCompany = {
  __typename?: 'InvestmentsConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionUser = {
  __typename?: 'InvestmentsConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionApprovedAt = {
  __typename?: 'InvestmentsConnectionApprovedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionTotalReturn = {
  __typename?: 'InvestmentsConnectionTotalReturn';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionLastPayInterestDate = {
  __typename?: 'InvestmentsConnectionLastPayInterestDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentsConnectionCurrency = {
  __typename?: 'InvestmentsConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<InvestmentsConnection>;
};

export type InvestmentInput = {
  amount?: Maybe<Scalars['Int']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Investments_Status>;
  company?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  totalReturn?: Maybe<Scalars['Int']>;
  lastPayInterestDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Investments_Currency>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditInvestmentInput = {
  amount?: Maybe<Scalars['Int']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Investments_Status>;
  company?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  totalReturn?: Maybe<Scalars['Int']>;
  lastPayInterestDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Investments_Currency>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateInvestmentInput = {
  data?: Maybe<InvestmentInput>;
};

export type CreateInvestmentPayload = {
  __typename?: 'createInvestmentPayload';
  investment?: Maybe<Investments>;
};

export type UpdateInvestmentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditInvestmentInput>;
};

export type UpdateInvestmentPayload = {
  __typename?: 'updateInvestmentPayload';
  investment?: Maybe<Investments>;
};

export type DeleteInvestmentInput = {
  where?: Maybe<InputId>;
};

export type DeleteInvestmentPayload = {
  __typename?: 'deleteInvestmentPayload';
  investment?: Maybe<Investments>;
};

export type Jamiipesa = {
  __typename?: 'Jamiipesa';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  privacyPolicy: Scalars['String'];
  termsAndConditions: Scalars['String'];
  adminSupportEmail?: Maybe<Scalars['String']>;
  bankAccountNumberUSD?: Maybe<Scalars['String']>;
  bankAccountNameUSD?: Maybe<Scalars['String']>;
  bankNameUSD?: Maybe<Scalars['String']>;
  bankCodeUSD?: Maybe<Scalars['String']>;
  swiftCodeUSD?: Maybe<Scalars['String']>;
  branchCodeKES?: Maybe<Scalars['String']>;
  bankAccountNumberKES?: Maybe<Scalars['String']>;
  bankAccountNameKES?: Maybe<Scalars['String']>;
  bankNameKES?: Maybe<Scalars['String']>;
  swiftCodeKES?: Maybe<Scalars['String']>;
};

export type JamiipesaInput = {
  privacyPolicy: Scalars['String'];
  termsAndConditions: Scalars['String'];
  adminSupportEmail?: Maybe<Scalars['String']>;
  bankAccountNumberUSD?: Maybe<Scalars['String']>;
  bankAccountNameUSD?: Maybe<Scalars['String']>;
  bankNameUSD?: Maybe<Scalars['String']>;
  bankCodeUSD?: Maybe<Scalars['String']>;
  swiftCodeUSD?: Maybe<Scalars['String']>;
  branchCodeKES?: Maybe<Scalars['String']>;
  bankAccountNumberKES?: Maybe<Scalars['String']>;
  bankAccountNameKES?: Maybe<Scalars['String']>;
  bankNameKES?: Maybe<Scalars['String']>;
  swiftCodeKES?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditJamiipesaInput = {
  privacyPolicy?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  adminSupportEmail?: Maybe<Scalars['String']>;
  bankAccountNumberUSD?: Maybe<Scalars['String']>;
  bankAccountNameUSD?: Maybe<Scalars['String']>;
  bankNameUSD?: Maybe<Scalars['String']>;
  bankCodeUSD?: Maybe<Scalars['String']>;
  swiftCodeUSD?: Maybe<Scalars['String']>;
  branchCodeKES?: Maybe<Scalars['String']>;
  bankAccountNumberKES?: Maybe<Scalars['String']>;
  bankAccountNameKES?: Maybe<Scalars['String']>;
  bankNameKES?: Maybe<Scalars['String']>;
  swiftCodeKES?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateJamiipesaInput = {
  data?: Maybe<EditJamiipesaInput>;
};

export type UpdateJamiipesaPayload = {
  __typename?: 'updateJamiipesaPayload';
  jamiipesa?: Maybe<Jamiipesa>;
};

export type DeleteJamiipesaPayload = {
  __typename?: 'deleteJamiipesaPayload';
  jamiipesa?: Maybe<Jamiipesa>;
};

export enum Enum_Marketvaluelog_Status {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export type MarketValueLog = {
  __typename?: 'MarketValueLog';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  approvedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Marketvaluelog_Status>;
  commercialPaper?: Maybe<CommercialPapers>;
  masterNote?: Maybe<MasterNote>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type MarketValueLogConnection = {
  __typename?: 'MarketValueLogConnection';
  values?: Maybe<Array<Maybe<MarketValueLog>>>;
  groupBy?: Maybe<MarketValueLogGroupBy>;
  aggregate?: Maybe<MarketValueLogAggregator>;
};

export type MarketValueLogAggregator = {
  __typename?: 'MarketValueLogAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<MarketValueLogAggregatorSum>;
  avg?: Maybe<MarketValueLogAggregatorAvg>;
  min?: Maybe<MarketValueLogAggregatorMin>;
  max?: Maybe<MarketValueLogAggregatorMax>;
};

export type MarketValueLogAggregatorSum = {
  __typename?: 'MarketValueLogAggregatorSum';
  value?: Maybe<Scalars['Float']>;
};

export type MarketValueLogAggregatorAvg = {
  __typename?: 'MarketValueLogAggregatorAvg';
  value?: Maybe<Scalars['Float']>;
};

export type MarketValueLogAggregatorMin = {
  __typename?: 'MarketValueLogAggregatorMin';
  value?: Maybe<Scalars['Float']>;
};

export type MarketValueLogAggregatorMax = {
  __typename?: 'MarketValueLogAggregatorMax';
  value?: Maybe<Scalars['Float']>;
};

export type MarketValueLogGroupBy = {
  __typename?: 'MarketValueLogGroupBy';
  id?: Maybe<Array<Maybe<MarketValueLogConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MarketValueLogConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MarketValueLogConnectionUpdated_At>>>;
  approvedAt?: Maybe<Array<Maybe<MarketValueLogConnectionApprovedAt>>>;
  value?: Maybe<Array<Maybe<MarketValueLogConnectionValue>>>;
  status?: Maybe<Array<Maybe<MarketValueLogConnectionStatus>>>;
  commercialPaper?: Maybe<Array<Maybe<MarketValueLogConnectionCommercialPaper>>>;
  masterNote?: Maybe<Array<Maybe<MarketValueLogConnectionMasterNote>>>;
  published_at?: Maybe<Array<Maybe<MarketValueLogConnectionPublished_At>>>;
};

export type MarketValueLogConnectionId = {
  __typename?: 'MarketValueLogConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionCreated_At = {
  __typename?: 'MarketValueLogConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionUpdated_At = {
  __typename?: 'MarketValueLogConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionApprovedAt = {
  __typename?: 'MarketValueLogConnectionApprovedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionValue = {
  __typename?: 'MarketValueLogConnectionValue';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionStatus = {
  __typename?: 'MarketValueLogConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionCommercialPaper = {
  __typename?: 'MarketValueLogConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionMasterNote = {
  __typename?: 'MarketValueLogConnectionMasterNote';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogConnectionPublished_At = {
  __typename?: 'MarketValueLogConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MarketValueLogConnection>;
};

export type MarketValueLogInput = {
  approvedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Marketvaluelog_Status>;
  commercialPaper?: Maybe<Scalars['ID']>;
  masterNote?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditMarketValueLogInput = {
  approvedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Marketvaluelog_Status>;
  commercialPaper?: Maybe<Scalars['ID']>;
  masterNote?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateMarketValueLogInput = {
  data?: Maybe<MarketValueLogInput>;
};

export type CreateMarketValueLogPayload = {
  __typename?: 'createMarketValueLogPayload';
  marketValueLog?: Maybe<MarketValueLog>;
};

export type UpdateMarketValueLogInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMarketValueLogInput>;
};

export type UpdateMarketValueLogPayload = {
  __typename?: 'updateMarketValueLogPayload';
  marketValueLog?: Maybe<MarketValueLog>;
};

export type DeleteMarketValueLogInput = {
  where?: Maybe<InputId>;
};

export type DeleteMarketValueLogPayload = {
  __typename?: 'deleteMarketValueLogPayload';
  marketValueLog?: Maybe<MarketValueLog>;
};

export enum Enum_Masternote_Type {
  Bond = 'Bond',
  Fund = 'Fund'
}

export enum Enum_Masternote_Interestfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export enum Enum_Masternote_Currentstep {
  GeneralInformation = 'GENERAL_INFORMATION',
  AdditionalInformation = 'ADDITIONAL_INFORMATION'
}

export enum Enum_Masternote_Status {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Masternote_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export type MasterNote = {
  __typename?: 'MasterNote';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Masternote_Type>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Enum_Masternote_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  marketValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  status?: Maybe<Enum_Masternote_Status>;
  currency?: Maybe<Enum_Masternote_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  commercialPapers?: Maybe<Array<Maybe<CommercialPapers>>>;
  memorandum?: Maybe<Array<Maybe<UploadFile>>>;
  marketValueLogs?: Maybe<Array<Maybe<MarketValueLog>>>;
};


export type MasterNoteCommercialPapersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MasterNoteMemorandumArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type MasterNoteMarketValueLogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type MasterNoteConnection = {
  __typename?: 'MasterNoteConnection';
  values?: Maybe<Array<Maybe<MasterNote>>>;
  groupBy?: Maybe<MasterNoteGroupBy>;
  aggregate?: Maybe<MasterNoteAggregator>;
};

export type MasterNoteAggregator = {
  __typename?: 'MasterNoteAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<MasterNoteAggregatorSum>;
  avg?: Maybe<MasterNoteAggregatorAvg>;
  min?: Maybe<MasterNoteAggregatorMin>;
  max?: Maybe<MasterNoteAggregatorMax>;
};

export type MasterNoteAggregatorSum = {
  __typename?: 'MasterNoteAggregatorSum';
  interestRate?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
};

export type MasterNoteAggregatorAvg = {
  __typename?: 'MasterNoteAggregatorAvg';
  interestRate?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
};

export type MasterNoteAggregatorMin = {
  __typename?: 'MasterNoteAggregatorMin';
  interestRate?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
};

export type MasterNoteAggregatorMax = {
  __typename?: 'MasterNoteAggregatorMax';
  interestRate?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
};

export type MasterNoteGroupBy = {
  __typename?: 'MasterNoteGroupBy';
  id?: Maybe<Array<Maybe<MasterNoteConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MasterNoteConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MasterNoteConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<MasterNoteConnectionTitle>>>;
  type?: Maybe<Array<Maybe<MasterNoteConnectionType>>>;
  interestRate?: Maybe<Array<Maybe<MasterNoteConnectionInterestRate>>>;
  interestFrequency?: Maybe<Array<Maybe<MasterNoteConnectionInterestFrequency>>>;
  maturityDate?: Maybe<Array<Maybe<MasterNoteConnectionMaturityDate>>>;
  marketValue?: Maybe<Array<Maybe<MasterNoteConnectionMarketValue>>>;
  description?: Maybe<Array<Maybe<MasterNoteConnectionDescription>>>;
  potentialRisks?: Maybe<Array<Maybe<MasterNoteConnectionPotentialRisks>>>;
  user?: Maybe<Array<Maybe<MasterNoteConnectionUser>>>;
  currentStep?: Maybe<Array<Maybe<MasterNoteConnectionCurrentStep>>>;
  status?: Maybe<Array<Maybe<MasterNoteConnectionStatus>>>;
  currency?: Maybe<Array<Maybe<MasterNoteConnectionCurrency>>>;
  fundManager?: Maybe<Array<Maybe<MasterNoteConnectionFundManager>>>;
  assetType?: Maybe<Array<Maybe<MasterNoteConnectionAssetType>>>;
  published_at?: Maybe<Array<Maybe<MasterNoteConnectionPublished_At>>>;
};

export type MasterNoteConnectionId = {
  __typename?: 'MasterNoteConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionCreated_At = {
  __typename?: 'MasterNoteConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionUpdated_At = {
  __typename?: 'MasterNoteConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionTitle = {
  __typename?: 'MasterNoteConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionType = {
  __typename?: 'MasterNoteConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionInterestRate = {
  __typename?: 'MasterNoteConnectionInterestRate';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionInterestFrequency = {
  __typename?: 'MasterNoteConnectionInterestFrequency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionMaturityDate = {
  __typename?: 'MasterNoteConnectionMaturityDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionMarketValue = {
  __typename?: 'MasterNoteConnectionMarketValue';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionDescription = {
  __typename?: 'MasterNoteConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionPotentialRisks = {
  __typename?: 'MasterNoteConnectionPotentialRisks';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionUser = {
  __typename?: 'MasterNoteConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionCurrentStep = {
  __typename?: 'MasterNoteConnectionCurrentStep';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionStatus = {
  __typename?: 'MasterNoteConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionCurrency = {
  __typename?: 'MasterNoteConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionFundManager = {
  __typename?: 'MasterNoteConnectionFundManager';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionAssetType = {
  __typename?: 'MasterNoteConnectionAssetType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteConnectionPublished_At = {
  __typename?: 'MasterNoteConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MasterNoteConnection>;
};

export type MasterNoteInput = {
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Masternote_Type>;
  interestRate?: Maybe<Scalars['Float']>;
  commercialPapers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  interestFrequency?: Maybe<Enum_Masternote_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  marketValue?: Maybe<Scalars['Float']>;
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  status?: Maybe<Enum_Masternote_Status>;
  marketValueLogs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currency?: Maybe<Enum_Masternote_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditMasterNoteInput = {
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Masternote_Type>;
  interestRate?: Maybe<Scalars['Float']>;
  commercialPapers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  interestFrequency?: Maybe<Enum_Masternote_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  marketValue?: Maybe<Scalars['Float']>;
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  status?: Maybe<Enum_Masternote_Status>;
  marketValueLogs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currency?: Maybe<Enum_Masternote_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateMasterNoteInput = {
  data?: Maybe<MasterNoteInput>;
};

export type CreateMasterNotePayload = {
  __typename?: 'createMasterNotePayload';
  masterNote?: Maybe<MasterNote>;
};

export type UpdateMasterNoteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMasterNoteInput>;
};

export type UpdateMasterNotePayload = {
  __typename?: 'updateMasterNotePayload';
  masterNote?: Maybe<MasterNote>;
};

export type DeleteMasterNoteInput = {
  where?: Maybe<InputId>;
};

export type DeleteMasterNotePayload = {
  __typename?: 'deleteMasterNotePayload';
  masterNote?: Maybe<MasterNote>;
};

export enum Enum_Notes_Notetype {
  Internal = 'INTERNAL',
  InfoRequired = 'INFO_REQUIRED',
  Declined = 'DECLINED'
}

export type Notes = {
  __typename?: 'Notes';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
  message?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Notes_Notetype>;
  commercialPaper?: Maybe<CommercialPapers>;
};

export type NotesConnection = {
  __typename?: 'NotesConnection';
  values?: Maybe<Array<Maybe<Notes>>>;
  groupBy?: Maybe<NotesGroupBy>;
  aggregate?: Maybe<NotesAggregator>;
};

export type NotesAggregator = {
  __typename?: 'NotesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NotesGroupBy = {
  __typename?: 'NotesGroupBy';
  id?: Maybe<Array<Maybe<NotesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NotesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NotesConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<NotesConnectionUser>>>;
  message?: Maybe<Array<Maybe<NotesConnectionMessage>>>;
  noteType?: Maybe<Array<Maybe<NotesConnectionNoteType>>>;
  commercialPaper?: Maybe<Array<Maybe<NotesConnectionCommercialPaper>>>;
};

export type NotesConnectionId = {
  __typename?: 'NotesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionCreated_At = {
  __typename?: 'NotesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionUpdated_At = {
  __typename?: 'NotesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionUser = {
  __typename?: 'NotesConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionMessage = {
  __typename?: 'NotesConnectionMessage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionNoteType = {
  __typename?: 'NotesConnectionNoteType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionCommercialPaper = {
  __typename?: 'NotesConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NoteInput = {
  user?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Notes_Notetype>;
  commercialPaper?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditNoteInput = {
  user?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Notes_Notetype>;
  commercialPaper?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateNoteInput = {
  data?: Maybe<NoteInput>;
};

export type CreateNotePayload = {
  __typename?: 'createNotePayload';
  note?: Maybe<Notes>;
};

export type UpdateNoteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNoteInput>;
};

export type UpdateNotePayload = {
  __typename?: 'updateNotePayload';
  note?: Maybe<Notes>;
};

export type DeleteNoteInput = {
  where?: Maybe<InputId>;
};

export type DeleteNotePayload = {
  __typename?: 'deleteNotePayload';
  note?: Maybe<Notes>;
};

export enum Enum_Notifications_Category {
  CpApproved = 'CP_APPROVED',
  RolloverAccepted = 'ROLLOVER_ACCEPTED',
  RolloverDeclined = 'ROLLOVER_DECLINED',
  RolloverRequested = 'ROLLOVER_REQUESTED',
  InfoRequired = 'INFO_REQUIRED',
  CpFundedLive = 'CP_FUNDED_LIVE',
  Submitted = 'SUBMITTED',
  Declined = 'DECLINED',
  NoteAdded = 'NOTE_ADDED',
  PayoutRequest = 'PAYOUT_REQUEST',
  UpdateRequest = 'UPDATE_REQUEST',
  Interest = 'INTEREST',
  Topup = 'TOPUP',
  SellRequest = 'SELL_REQUEST',
  WithdrawRequest = 'WITHDRAW_REQUEST'
}

export type Notifications = {
  __typename?: 'Notifications';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  message?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Notifications_Category>;
  user?: Maybe<UsersPermissionsUser>;
  additionalInformation?: Maybe<Scalars['JSON']>;
};

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  values?: Maybe<Array<Maybe<Notifications>>>;
  groupBy?: Maybe<NotificationsGroupBy>;
  aggregate?: Maybe<NotificationsAggregator>;
};

export type NotificationsAggregator = {
  __typename?: 'NotificationsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NotificationsGroupBy = {
  __typename?: 'NotificationsGroupBy';
  id?: Maybe<Array<Maybe<NotificationsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NotificationsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NotificationsConnectionUpdated_At>>>;
  message?: Maybe<Array<Maybe<NotificationsConnectionMessage>>>;
  isRead?: Maybe<Array<Maybe<NotificationsConnectionIsRead>>>;
  title?: Maybe<Array<Maybe<NotificationsConnectionTitle>>>;
  category?: Maybe<Array<Maybe<NotificationsConnectionCategory>>>;
  user?: Maybe<Array<Maybe<NotificationsConnectionUser>>>;
  additionalInformation?: Maybe<Array<Maybe<NotificationsConnectionAdditionalInformation>>>;
};

export type NotificationsConnectionId = {
  __typename?: 'NotificationsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionCreated_At = {
  __typename?: 'NotificationsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionUpdated_At = {
  __typename?: 'NotificationsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionMessage = {
  __typename?: 'NotificationsConnectionMessage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionIsRead = {
  __typename?: 'NotificationsConnectionIsRead';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionTitle = {
  __typename?: 'NotificationsConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionCategory = {
  __typename?: 'NotificationsConnectionCategory';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionUser = {
  __typename?: 'NotificationsConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationsConnectionAdditionalInformation = {
  __typename?: 'NotificationsConnectionAdditionalInformation';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<NotificationsConnection>;
};

export type NotificationInput = {
  message?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Notifications_Category>;
  user?: Maybe<Scalars['ID']>;
  additionalInformation?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditNotificationInput = {
  message?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Notifications_Category>;
  user?: Maybe<Scalars['ID']>;
  additionalInformation?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateNotificationInput = {
  data?: Maybe<NotificationInput>;
};

export type CreateNotificationPayload = {
  __typename?: 'createNotificationPayload';
  notification?: Maybe<Notifications>;
};

export type UpdateNotificationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNotificationInput>;
};

export type UpdateNotificationPayload = {
  __typename?: 'updateNotificationPayload';
  notification?: Maybe<Notifications>;
};

export type DeleteNotificationInput = {
  where?: Maybe<InputId>;
};

export type DeleteNotificationPayload = {
  __typename?: 'deleteNotificationPayload';
  notification?: Maybe<Notifications>;
};

export enum Enum_Payoutrequest_Status {
  Pending = 'PENDING',
  Approved = 'APPROVED'
}

export enum Enum_Payoutrequest_Type {
  Interest = 'INTEREST',
  Principal = 'PRINCIPAL'
}

export enum Enum_Payoutrequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export type PayoutRequest = {
  __typename?: 'PayoutRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  amount?: Maybe<Scalars['Long']>;
  status?: Maybe<Enum_Payoutrequest_Status>;
  commercialPaper?: Maybe<CommercialPapers>;
  type?: Maybe<Enum_Payoutrequest_Type>;
  interestMetric?: Maybe<Scalars['String']>;
  corporateAmount?: Maybe<Scalars['Long']>;
  currency?: Maybe<Enum_Payoutrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type PayoutRequestConnection = {
  __typename?: 'PayoutRequestConnection';
  values?: Maybe<Array<Maybe<PayoutRequest>>>;
  groupBy?: Maybe<PayoutRequestGroupBy>;
  aggregate?: Maybe<PayoutRequestAggregator>;
};

export type PayoutRequestAggregator = {
  __typename?: 'PayoutRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PayoutRequestGroupBy = {
  __typename?: 'PayoutRequestGroupBy';
  id?: Maybe<Array<Maybe<PayoutRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PayoutRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PayoutRequestConnectionUpdated_At>>>;
  amount?: Maybe<Array<Maybe<PayoutRequestConnectionAmount>>>;
  status?: Maybe<Array<Maybe<PayoutRequestConnectionStatus>>>;
  commercialPaper?: Maybe<Array<Maybe<PayoutRequestConnectionCommercialPaper>>>;
  type?: Maybe<Array<Maybe<PayoutRequestConnectionType>>>;
  interestMetric?: Maybe<Array<Maybe<PayoutRequestConnectionInterestMetric>>>;
  corporateAmount?: Maybe<Array<Maybe<PayoutRequestConnectionCorporateAmount>>>;
  currency?: Maybe<Array<Maybe<PayoutRequestConnectionCurrency>>>;
  published_at?: Maybe<Array<Maybe<PayoutRequestConnectionPublished_At>>>;
};

export type PayoutRequestConnectionId = {
  __typename?: 'PayoutRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionCreated_At = {
  __typename?: 'PayoutRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionUpdated_At = {
  __typename?: 'PayoutRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionAmount = {
  __typename?: 'PayoutRequestConnectionAmount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionStatus = {
  __typename?: 'PayoutRequestConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionCommercialPaper = {
  __typename?: 'PayoutRequestConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionType = {
  __typename?: 'PayoutRequestConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionInterestMetric = {
  __typename?: 'PayoutRequestConnectionInterestMetric';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionCorporateAmount = {
  __typename?: 'PayoutRequestConnectionCorporateAmount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionCurrency = {
  __typename?: 'PayoutRequestConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestConnectionPublished_At = {
  __typename?: 'PayoutRequestConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PayoutRequestConnection>;
};

export type PayoutRequestInput = {
  amount?: Maybe<Scalars['Long']>;
  status?: Maybe<Enum_Payoutrequest_Status>;
  commercialPaper?: Maybe<Scalars['ID']>;
  type?: Maybe<Enum_Payoutrequest_Type>;
  interestMetric?: Maybe<Scalars['String']>;
  corporateAmount?: Maybe<Scalars['Long']>;
  currency?: Maybe<Enum_Payoutrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPayoutRequestInput = {
  amount?: Maybe<Scalars['Long']>;
  status?: Maybe<Enum_Payoutrequest_Status>;
  commercialPaper?: Maybe<Scalars['ID']>;
  type?: Maybe<Enum_Payoutrequest_Type>;
  interestMetric?: Maybe<Scalars['String']>;
  corporateAmount?: Maybe<Scalars['Long']>;
  currency?: Maybe<Enum_Payoutrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreatePayoutRequestInput = {
  data?: Maybe<PayoutRequestInput>;
};

export type CreatePayoutRequestPayload = {
  __typename?: 'createPayoutRequestPayload';
  payoutRequest?: Maybe<PayoutRequest>;
};

export type UpdatePayoutRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPayoutRequestInput>;
};

export type UpdatePayoutRequestPayload = {
  __typename?: 'updatePayoutRequestPayload';
  payoutRequest?: Maybe<PayoutRequest>;
};

export type DeletePayoutRequestInput = {
  where?: Maybe<InputId>;
};

export type DeletePayoutRequestPayload = {
  __typename?: 'deletePayoutRequestPayload';
  payoutRequest?: Maybe<PayoutRequest>;
};

export enum Enum_Purchaserequest_Status {
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Purchaserequest_Investmenttermtype {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS'
}

export type PurchaseRequest = {
  __typename?: 'PurchaseRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  status?: Maybe<Enum_Purchaserequest_Status>;
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  investmentTerm?: Maybe<Scalars['Int']>;
  investmentTermType?: Maybe<Enum_Purchaserequest_Investmenttermtype>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  faceValue?: Maybe<Scalars['Int']>;
  withHoldingTax?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['Date']>;
  signedBy?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<CommercialPapers>;
  user?: Maybe<UsersPermissionsUser>;
};

export type PurchaseRequestConnection = {
  __typename?: 'PurchaseRequestConnection';
  values?: Maybe<Array<Maybe<PurchaseRequest>>>;
  groupBy?: Maybe<PurchaseRequestGroupBy>;
  aggregate?: Maybe<PurchaseRequestAggregator>;
};

export type PurchaseRequestAggregator = {
  __typename?: 'PurchaseRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<PurchaseRequestAggregatorSum>;
  avg?: Maybe<PurchaseRequestAggregatorAvg>;
  min?: Maybe<PurchaseRequestAggregatorMin>;
  max?: Maybe<PurchaseRequestAggregatorMax>;
};

export type PurchaseRequestAggregatorSum = {
  __typename?: 'PurchaseRequestAggregatorSum';
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  faceValue?: Maybe<Scalars['Float']>;
  withHoldingTax?: Maybe<Scalars['Float']>;
};

export type PurchaseRequestAggregatorAvg = {
  __typename?: 'PurchaseRequestAggregatorAvg';
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  faceValue?: Maybe<Scalars['Float']>;
  withHoldingTax?: Maybe<Scalars['Float']>;
};

export type PurchaseRequestAggregatorMin = {
  __typename?: 'PurchaseRequestAggregatorMin';
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  faceValue?: Maybe<Scalars['Float']>;
  withHoldingTax?: Maybe<Scalars['Float']>;
};

export type PurchaseRequestAggregatorMax = {
  __typename?: 'PurchaseRequestAggregatorMax';
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  investmentTerm?: Maybe<Scalars['Float']>;
  faceValue?: Maybe<Scalars['Float']>;
  withHoldingTax?: Maybe<Scalars['Float']>;
};

export type PurchaseRequestGroupBy = {
  __typename?: 'PurchaseRequestGroupBy';
  id?: Maybe<Array<Maybe<PurchaseRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PurchaseRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PurchaseRequestConnectionUpdated_At>>>;
  status?: Maybe<Array<Maybe<PurchaseRequestConnectionStatus>>>;
  interestRate?: Maybe<Array<Maybe<PurchaseRequestConnectionInterestRate>>>;
  totalReturn?: Maybe<Array<Maybe<PurchaseRequestConnectionTotalReturn>>>;
  purchasePrice?: Maybe<Array<Maybe<PurchaseRequestConnectionPurchasePrice>>>;
  investmentTerm?: Maybe<Array<Maybe<PurchaseRequestConnectionInvestmentTerm>>>;
  investmentTermType?: Maybe<Array<Maybe<PurchaseRequestConnectionInvestmentTermType>>>;
  investmentDate?: Maybe<Array<Maybe<PurchaseRequestConnectionInvestmentDate>>>;
  faceValue?: Maybe<Array<Maybe<PurchaseRequestConnectionFaceValue>>>;
  withHoldingTax?: Maybe<Array<Maybe<PurchaseRequestConnectionWithHoldingTax>>>;
  signedAt?: Maybe<Array<Maybe<PurchaseRequestConnectionSignedAt>>>;
  dueDate?: Maybe<Array<Maybe<PurchaseRequestConnectionDueDate>>>;
  signedBy?: Maybe<Array<Maybe<PurchaseRequestConnectionSignedBy>>>;
  commercialPaper?: Maybe<Array<Maybe<PurchaseRequestConnectionCommercialPaper>>>;
  user?: Maybe<Array<Maybe<PurchaseRequestConnectionUser>>>;
};

export type PurchaseRequestConnectionId = {
  __typename?: 'PurchaseRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionCreated_At = {
  __typename?: 'PurchaseRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionUpdated_At = {
  __typename?: 'PurchaseRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionStatus = {
  __typename?: 'PurchaseRequestConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionInterestRate = {
  __typename?: 'PurchaseRequestConnectionInterestRate';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionTotalReturn = {
  __typename?: 'PurchaseRequestConnectionTotalReturn';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionPurchasePrice = {
  __typename?: 'PurchaseRequestConnectionPurchasePrice';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionInvestmentTerm = {
  __typename?: 'PurchaseRequestConnectionInvestmentTerm';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionInvestmentTermType = {
  __typename?: 'PurchaseRequestConnectionInvestmentTermType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionInvestmentDate = {
  __typename?: 'PurchaseRequestConnectionInvestmentDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionFaceValue = {
  __typename?: 'PurchaseRequestConnectionFaceValue';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionWithHoldingTax = {
  __typename?: 'PurchaseRequestConnectionWithHoldingTax';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionSignedAt = {
  __typename?: 'PurchaseRequestConnectionSignedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionDueDate = {
  __typename?: 'PurchaseRequestConnectionDueDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionSignedBy = {
  __typename?: 'PurchaseRequestConnectionSignedBy';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionCommercialPaper = {
  __typename?: 'PurchaseRequestConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestConnectionUser = {
  __typename?: 'PurchaseRequestConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PurchaseRequestConnection>;
};

export type PurchaseRequestInput = {
  status?: Maybe<Enum_Purchaserequest_Status>;
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  investmentTerm?: Maybe<Scalars['Int']>;
  investmentTermType?: Maybe<Enum_Purchaserequest_Investmenttermtype>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  faceValue?: Maybe<Scalars['Int']>;
  withHoldingTax?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['Date']>;
  signedBy?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPurchaseRequestInput = {
  status?: Maybe<Enum_Purchaserequest_Status>;
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  investmentTerm?: Maybe<Scalars['Int']>;
  investmentTermType?: Maybe<Enum_Purchaserequest_Investmenttermtype>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  faceValue?: Maybe<Scalars['Int']>;
  withHoldingTax?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['Date']>;
  signedBy?: Maybe<Scalars['String']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreatePurchaseRequestInput = {
  data?: Maybe<PurchaseRequestInput>;
};

export type CreatePurchaseRequestPayload = {
  __typename?: 'createPurchaseRequestPayload';
  purchaseRequest?: Maybe<PurchaseRequest>;
};

export type UpdatePurchaseRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPurchaseRequestInput>;
};

export type UpdatePurchaseRequestPayload = {
  __typename?: 'updatePurchaseRequestPayload';
  purchaseRequest?: Maybe<PurchaseRequest>;
};

export type DeletePurchaseRequestInput = {
  where?: Maybe<InputId>;
};

export type DeletePurchaseRequestPayload = {
  __typename?: 'deletePurchaseRequestPayload';
  purchaseRequest?: Maybe<PurchaseRequest>;
};

export type RolloverRequests = {
  __typename?: 'RolloverRequests';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  proposedMaturityDate?: Maybe<Scalars['Date']>;
  rolloverPeriod?: Maybe<Scalars['Int']>;
  commercialPaper?: Maybe<CommercialPapers>;
  reason?: Maybe<Scalars['String']>;
  rolloverResponses?: Maybe<Array<Maybe<RolloverResponse>>>;
};


export type RolloverRequestsRolloverResponsesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RolloverRequestsConnection = {
  __typename?: 'RolloverRequestsConnection';
  values?: Maybe<Array<Maybe<RolloverRequests>>>;
  groupBy?: Maybe<RolloverRequestsGroupBy>;
  aggregate?: Maybe<RolloverRequestsAggregator>;
};

export type RolloverRequestsAggregator = {
  __typename?: 'RolloverRequestsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<RolloverRequestsAggregatorSum>;
  avg?: Maybe<RolloverRequestsAggregatorAvg>;
  min?: Maybe<RolloverRequestsAggregatorMin>;
  max?: Maybe<RolloverRequestsAggregatorMax>;
};

export type RolloverRequestsAggregatorSum = {
  __typename?: 'RolloverRequestsAggregatorSum';
  rolloverPeriod?: Maybe<Scalars['Float']>;
};

export type RolloverRequestsAggregatorAvg = {
  __typename?: 'RolloverRequestsAggregatorAvg';
  rolloverPeriod?: Maybe<Scalars['Float']>;
};

export type RolloverRequestsAggregatorMin = {
  __typename?: 'RolloverRequestsAggregatorMin';
  rolloverPeriod?: Maybe<Scalars['Float']>;
};

export type RolloverRequestsAggregatorMax = {
  __typename?: 'RolloverRequestsAggregatorMax';
  rolloverPeriod?: Maybe<Scalars['Float']>;
};

export type RolloverRequestsGroupBy = {
  __typename?: 'RolloverRequestsGroupBy';
  id?: Maybe<Array<Maybe<RolloverRequestsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RolloverRequestsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RolloverRequestsConnectionUpdated_At>>>;
  proposedMaturityDate?: Maybe<Array<Maybe<RolloverRequestsConnectionProposedMaturityDate>>>;
  rolloverPeriod?: Maybe<Array<Maybe<RolloverRequestsConnectionRolloverPeriod>>>;
  commercialPaper?: Maybe<Array<Maybe<RolloverRequestsConnectionCommercialPaper>>>;
  reason?: Maybe<Array<Maybe<RolloverRequestsConnectionReason>>>;
};

export type RolloverRequestsConnectionId = {
  __typename?: 'RolloverRequestsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestsConnectionCreated_At = {
  __typename?: 'RolloverRequestsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestsConnectionUpdated_At = {
  __typename?: 'RolloverRequestsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestsConnectionProposedMaturityDate = {
  __typename?: 'RolloverRequestsConnectionProposedMaturityDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestsConnectionRolloverPeriod = {
  __typename?: 'RolloverRequestsConnectionRolloverPeriod';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestsConnectionCommercialPaper = {
  __typename?: 'RolloverRequestsConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestsConnectionReason = {
  __typename?: 'RolloverRequestsConnectionReason';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RolloverRequestsConnection>;
};

export type RolloverRequestInput = {
  proposedMaturityDate?: Maybe<Scalars['Date']>;
  rolloverPeriod?: Maybe<Scalars['Int']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  rolloverResponses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reason?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRolloverRequestInput = {
  proposedMaturityDate?: Maybe<Scalars['Date']>;
  rolloverPeriod?: Maybe<Scalars['Int']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  rolloverResponses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reason?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateRolloverRequestInput = {
  data?: Maybe<RolloverRequestInput>;
};

export type CreateRolloverRequestPayload = {
  __typename?: 'createRolloverRequestPayload';
  rolloverRequest?: Maybe<RolloverRequests>;
};

export type UpdateRolloverRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRolloverRequestInput>;
};

export type UpdateRolloverRequestPayload = {
  __typename?: 'updateRolloverRequestPayload';
  rolloverRequest?: Maybe<RolloverRequests>;
};

export type DeleteRolloverRequestInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolloverRequestPayload = {
  __typename?: 'deleteRolloverRequestPayload';
  rolloverRequest?: Maybe<RolloverRequests>;
};

export enum Enum_Rolloverresponse_Status {
  Declined = 'DECLINED',
  Accepted = 'ACCEPTED'
}

export type RolloverResponse = {
  __typename?: 'RolloverResponse';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  status?: Maybe<Enum_Rolloverresponse_Status>;
  user?: Maybe<UsersPermissionsUser>;
  rolloverRequest?: Maybe<RolloverRequests>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type RolloverResponseConnection = {
  __typename?: 'RolloverResponseConnection';
  values?: Maybe<Array<Maybe<RolloverResponse>>>;
  groupBy?: Maybe<RolloverResponseGroupBy>;
  aggregate?: Maybe<RolloverResponseAggregator>;
};

export type RolloverResponseAggregator = {
  __typename?: 'RolloverResponseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RolloverResponseGroupBy = {
  __typename?: 'RolloverResponseGroupBy';
  id?: Maybe<Array<Maybe<RolloverResponseConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RolloverResponseConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RolloverResponseConnectionUpdated_At>>>;
  status?: Maybe<Array<Maybe<RolloverResponseConnectionStatus>>>;
  user?: Maybe<Array<Maybe<RolloverResponseConnectionUser>>>;
  rolloverRequest?: Maybe<Array<Maybe<RolloverResponseConnectionRolloverRequest>>>;
  published_at?: Maybe<Array<Maybe<RolloverResponseConnectionPublished_At>>>;
};

export type RolloverResponseConnectionId = {
  __typename?: 'RolloverResponseConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseConnectionCreated_At = {
  __typename?: 'RolloverResponseConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseConnectionUpdated_At = {
  __typename?: 'RolloverResponseConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseConnectionStatus = {
  __typename?: 'RolloverResponseConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseConnectionUser = {
  __typename?: 'RolloverResponseConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseConnectionRolloverRequest = {
  __typename?: 'RolloverResponseConnectionRolloverRequest';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseConnectionPublished_At = {
  __typename?: 'RolloverResponseConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RolloverResponseConnection>;
};

export type RolloverResponseInput = {
  status?: Maybe<Enum_Rolloverresponse_Status>;
  user?: Maybe<Scalars['ID']>;
  rolloverRequest?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRolloverResponseInput = {
  status?: Maybe<Enum_Rolloverresponse_Status>;
  user?: Maybe<Scalars['ID']>;
  rolloverRequest?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateRolloverResponseInput = {
  data?: Maybe<RolloverResponseInput>;
};

export type CreateRolloverResponsePayload = {
  __typename?: 'createRolloverResponsePayload';
  rolloverResponse?: Maybe<RolloverResponse>;
};

export type UpdateRolloverResponseInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRolloverResponseInput>;
};

export type UpdateRolloverResponsePayload = {
  __typename?: 'updateRolloverResponsePayload';
  rolloverResponse?: Maybe<RolloverResponse>;
};

export type DeleteRolloverResponseInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolloverResponsePayload = {
  __typename?: 'deleteRolloverResponsePayload';
  rolloverResponse?: Maybe<RolloverResponse>;
};

export enum Enum_Sellrequest_Status {
  Declined = 'DECLINED',
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export enum Enum_Sellrequest_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export type SellRequest = {
  __typename?: 'SellRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  customerValue?: Maybe<Scalars['Long']>;
  sellAmount?: Maybe<Scalars['Long']>;
  commercialPaper?: Maybe<CommercialPapers>;
  investment?: Maybe<Investments>;
  status?: Maybe<Enum_Sellrequest_Status>;
  shortHoldFeeAmount?: Maybe<Scalars['Long']>;
  sellFeeAmount?: Maybe<Scalars['Long']>;
  user?: Maybe<UsersPermissionsUser>;
  check?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Sellrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type SellRequestConnection = {
  __typename?: 'SellRequestConnection';
  values?: Maybe<Array<Maybe<SellRequest>>>;
  groupBy?: Maybe<SellRequestGroupBy>;
  aggregate?: Maybe<SellRequestAggregator>;
};

export type SellRequestAggregator = {
  __typename?: 'SellRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SellRequestGroupBy = {
  __typename?: 'SellRequestGroupBy';
  id?: Maybe<Array<Maybe<SellRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SellRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SellRequestConnectionUpdated_At>>>;
  customerValue?: Maybe<Array<Maybe<SellRequestConnectionCustomerValue>>>;
  sellAmount?: Maybe<Array<Maybe<SellRequestConnectionSellAmount>>>;
  commercialPaper?: Maybe<Array<Maybe<SellRequestConnectionCommercialPaper>>>;
  investment?: Maybe<Array<Maybe<SellRequestConnectionInvestment>>>;
  status?: Maybe<Array<Maybe<SellRequestConnectionStatus>>>;
  shortHoldFeeAmount?: Maybe<Array<Maybe<SellRequestConnectionShortHoldFeeAmount>>>;
  sellFeeAmount?: Maybe<Array<Maybe<SellRequestConnectionSellFeeAmount>>>;
  user?: Maybe<Array<Maybe<SellRequestConnectionUser>>>;
  check?: Maybe<Array<Maybe<SellRequestConnectionCheck>>>;
  currency?: Maybe<Array<Maybe<SellRequestConnectionCurrency>>>;
  published_at?: Maybe<Array<Maybe<SellRequestConnectionPublished_At>>>;
};

export type SellRequestConnectionId = {
  __typename?: 'SellRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionCreated_At = {
  __typename?: 'SellRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionUpdated_At = {
  __typename?: 'SellRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionCustomerValue = {
  __typename?: 'SellRequestConnectionCustomerValue';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionSellAmount = {
  __typename?: 'SellRequestConnectionSellAmount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionCommercialPaper = {
  __typename?: 'SellRequestConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionInvestment = {
  __typename?: 'SellRequestConnectionInvestment';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionStatus = {
  __typename?: 'SellRequestConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionShortHoldFeeAmount = {
  __typename?: 'SellRequestConnectionShortHoldFeeAmount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionSellFeeAmount = {
  __typename?: 'SellRequestConnectionSellFeeAmount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionUser = {
  __typename?: 'SellRequestConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionCheck = {
  __typename?: 'SellRequestConnectionCheck';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionCurrency = {
  __typename?: 'SellRequestConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestConnectionPublished_At = {
  __typename?: 'SellRequestConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SellRequestConnection>;
};

export type SellRequestInput = {
  customerValue?: Maybe<Scalars['Long']>;
  sellAmount?: Maybe<Scalars['Long']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  investment?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Sellrequest_Status>;
  shortHoldFeeAmount?: Maybe<Scalars['Long']>;
  sellFeeAmount?: Maybe<Scalars['Long']>;
  user?: Maybe<Scalars['ID']>;
  check?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Sellrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditSellRequestInput = {
  customerValue?: Maybe<Scalars['Long']>;
  sellAmount?: Maybe<Scalars['Long']>;
  commercialPaper?: Maybe<Scalars['ID']>;
  investment?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Sellrequest_Status>;
  shortHoldFeeAmount?: Maybe<Scalars['Long']>;
  sellFeeAmount?: Maybe<Scalars['Long']>;
  user?: Maybe<Scalars['ID']>;
  check?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Sellrequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateSellRequestInput = {
  data?: Maybe<SellRequestInput>;
};

export type CreateSellRequestPayload = {
  __typename?: 'createSellRequestPayload';
  sellRequest?: Maybe<SellRequest>;
};

export type UpdateSellRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSellRequestInput>;
};

export type UpdateSellRequestPayload = {
  __typename?: 'updateSellRequestPayload';
  sellRequest?: Maybe<SellRequest>;
};

export type DeleteSellRequestInput = {
  where?: Maybe<InputId>;
};

export type DeleteSellRequestPayload = {
  __typename?: 'deleteSellRequestPayload';
  sellRequest?: Maybe<SellRequest>;
};

export enum Enum_Topuprequest_Status {
  Pending = 'PENDING',
  Completed = 'COMPLETED'
}

export enum Enum_Topuprequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export type TopupRequest = {
  __typename?: 'TopupRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  intendedAmount?: Maybe<Scalars['Int']>;
  depositedAmount?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Topuprequest_Status>;
  completedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUser>;
  referenceNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Topuprequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type TopupRequestConnection = {
  __typename?: 'TopupRequestConnection';
  values?: Maybe<Array<Maybe<TopupRequest>>>;
  groupBy?: Maybe<TopupRequestGroupBy>;
  aggregate?: Maybe<TopupRequestAggregator>;
};

export type TopupRequestAggregator = {
  __typename?: 'TopupRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<TopupRequestAggregatorSum>;
  avg?: Maybe<TopupRequestAggregatorAvg>;
  min?: Maybe<TopupRequestAggregatorMin>;
  max?: Maybe<TopupRequestAggregatorMax>;
};

export type TopupRequestAggregatorSum = {
  __typename?: 'TopupRequestAggregatorSum';
  intendedAmount?: Maybe<Scalars['Float']>;
  depositedAmount?: Maybe<Scalars['Float']>;
};

export type TopupRequestAggregatorAvg = {
  __typename?: 'TopupRequestAggregatorAvg';
  intendedAmount?: Maybe<Scalars['Float']>;
  depositedAmount?: Maybe<Scalars['Float']>;
};

export type TopupRequestAggregatorMin = {
  __typename?: 'TopupRequestAggregatorMin';
  intendedAmount?: Maybe<Scalars['Float']>;
  depositedAmount?: Maybe<Scalars['Float']>;
};

export type TopupRequestAggregatorMax = {
  __typename?: 'TopupRequestAggregatorMax';
  intendedAmount?: Maybe<Scalars['Float']>;
  depositedAmount?: Maybe<Scalars['Float']>;
};

export type TopupRequestGroupBy = {
  __typename?: 'TopupRequestGroupBy';
  id?: Maybe<Array<Maybe<TopupRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TopupRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TopupRequestConnectionUpdated_At>>>;
  intendedAmount?: Maybe<Array<Maybe<TopupRequestConnectionIntendedAmount>>>;
  depositedAmount?: Maybe<Array<Maybe<TopupRequestConnectionDepositedAmount>>>;
  status?: Maybe<Array<Maybe<TopupRequestConnectionStatus>>>;
  completedAt?: Maybe<Array<Maybe<TopupRequestConnectionCompletedAt>>>;
  user?: Maybe<Array<Maybe<TopupRequestConnectionUser>>>;
  referenceNumber?: Maybe<Array<Maybe<TopupRequestConnectionReferenceNumber>>>;
  currency?: Maybe<Array<Maybe<TopupRequestConnectionCurrency>>>;
  published_at?: Maybe<Array<Maybe<TopupRequestConnectionPublished_At>>>;
};

export type TopupRequestConnectionId = {
  __typename?: 'TopupRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionCreated_At = {
  __typename?: 'TopupRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionUpdated_At = {
  __typename?: 'TopupRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionIntendedAmount = {
  __typename?: 'TopupRequestConnectionIntendedAmount';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionDepositedAmount = {
  __typename?: 'TopupRequestConnectionDepositedAmount';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionStatus = {
  __typename?: 'TopupRequestConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionCompletedAt = {
  __typename?: 'TopupRequestConnectionCompletedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionUser = {
  __typename?: 'TopupRequestConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionReferenceNumber = {
  __typename?: 'TopupRequestConnectionReferenceNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionCurrency = {
  __typename?: 'TopupRequestConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestConnectionPublished_At = {
  __typename?: 'TopupRequestConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TopupRequestConnection>;
};

export type TopupRequestInput = {
  intendedAmount?: Maybe<Scalars['Int']>;
  depositedAmount?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Topuprequest_Status>;
  completedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<Scalars['ID']>;
  referenceNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Topuprequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTopupRequestInput = {
  intendedAmount?: Maybe<Scalars['Int']>;
  depositedAmount?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Topuprequest_Status>;
  completedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<Scalars['ID']>;
  referenceNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Topuprequest_Currency>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateTopupRequestInput = {
  data?: Maybe<TopupRequestInput>;
};

export type CreateTopupRequestPayload = {
  __typename?: 'createTopupRequestPayload';
  topupRequest?: Maybe<TopupRequest>;
};

export type UpdateTopupRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTopupRequestInput>;
};

export type UpdateTopupRequestPayload = {
  __typename?: 'updateTopupRequestPayload';
  topupRequest?: Maybe<TopupRequest>;
};

export type DeleteTopupRequestInput = {
  where?: Maybe<InputId>;
};

export type DeleteTopupRequestPayload = {
  __typename?: 'deleteTopupRequestPayload';
  topupRequest?: Maybe<TopupRequest>;
};

export enum Enum_Transactions_Status {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Pending = 'PENDING',
  Declined = 'DECLINED'
}

export enum Enum_Transactions_Transactiontype {
  Investment = 'INVESTMENT',
  Topup = 'TOPUP',
  Withdraw = 'WITHDRAW',
  Payout = 'PAYOUT',
  Sell = 'SELL',
  Interest = 'INTEREST',
  PurchaseFee = 'PURCHASE_FEE',
  ManagementFee = 'MANAGEMENT_FEE',
  ShortHoldFee = 'SHORT_HOLD_FEE',
  SellFee = 'SELL_FEE'
}

export enum Enum_Transactions_Source {
  SalaryOrEmploymentIncome = 'SALARY_OR_EMPLOYMENT_INCOME',
  PersonalSavings = 'PERSONAL_SAVINGS',
  PensionIncome = 'PENSION_INCOME',
  InvestmentEarning = 'INVESTMENT_EARNING',
  PropertySale = 'PROPERTY_SALE',
  Inheritance = 'INHERITANCE',
  Gifts = 'GIFTS',
  BusinessIncomeOrDividends = 'BUSINESS_INCOME_OR_DIVIDENDS'
}

export enum Enum_Transactions_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export type Transactions = {
  __typename?: 'Transactions';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  commercialPaper?: Maybe<CommercialPapers>;
  payoutDate?: Maybe<Scalars['Date']>;
  transactionNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  invoice?: Maybe<UploadFile>;
  investment?: Maybe<Investments>;
  status?: Maybe<Enum_Transactions_Status>;
  description?: Maybe<Scalars['String']>;
  mpesaNumber?: Maybe<Scalars['Long']>;
  merchantRequestID?: Maybe<Scalars['String']>;
  checkoutRequestID?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  mpesaReceiptNumber?: Maybe<Scalars['String']>;
  wallet?: Maybe<Wallet>;
  transactionType?: Maybe<Enum_Transactions_Transactiontype>;
  bankWithdrawalRequest?: Maybe<BankWithdrawalRequest>;
  source?: Maybe<Enum_Transactions_Source>;
  currency?: Maybe<Enum_Transactions_Currency>;
};

export type TransactionsConnection = {
  __typename?: 'TransactionsConnection';
  values?: Maybe<Array<Maybe<Transactions>>>;
  groupBy?: Maybe<TransactionsGroupBy>;
  aggregate?: Maybe<TransactionsAggregator>;
};

export type TransactionsAggregator = {
  __typename?: 'TransactionsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<TransactionsAggregatorSum>;
  avg?: Maybe<TransactionsAggregatorAvg>;
  min?: Maybe<TransactionsAggregatorMin>;
  max?: Maybe<TransactionsAggregatorMax>;
};

export type TransactionsAggregatorSum = {
  __typename?: 'TransactionsAggregatorSum';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsAggregatorAvg = {
  __typename?: 'TransactionsAggregatorAvg';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsAggregatorMin = {
  __typename?: 'TransactionsAggregatorMin';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsAggregatorMax = {
  __typename?: 'TransactionsAggregatorMax';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionsGroupBy = {
  __typename?: 'TransactionsGroupBy';
  id?: Maybe<Array<Maybe<TransactionsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TransactionsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TransactionsConnectionUpdated_At>>>;
  commercialPaper?: Maybe<Array<Maybe<TransactionsConnectionCommercialPaper>>>;
  payoutDate?: Maybe<Array<Maybe<TransactionsConnectionPayoutDate>>>;
  transactionNumber?: Maybe<Array<Maybe<TransactionsConnectionTransactionNumber>>>;
  amount?: Maybe<Array<Maybe<TransactionsConnectionAmount>>>;
  invoice?: Maybe<Array<Maybe<TransactionsConnectionInvoice>>>;
  investment?: Maybe<Array<Maybe<TransactionsConnectionInvestment>>>;
  status?: Maybe<Array<Maybe<TransactionsConnectionStatus>>>;
  description?: Maybe<Array<Maybe<TransactionsConnectionDescription>>>;
  mpesaNumber?: Maybe<Array<Maybe<TransactionsConnectionMpesaNumber>>>;
  merchantRequestID?: Maybe<Array<Maybe<TransactionsConnectionMerchantRequestId>>>;
  checkoutRequestID?: Maybe<Array<Maybe<TransactionsConnectionCheckoutRequestId>>>;
  user?: Maybe<Array<Maybe<TransactionsConnectionUser>>>;
  mpesaReceiptNumber?: Maybe<Array<Maybe<TransactionsConnectionMpesaReceiptNumber>>>;
  wallet?: Maybe<Array<Maybe<TransactionsConnectionWallet>>>;
  transactionType?: Maybe<Array<Maybe<TransactionsConnectionTransactionType>>>;
  bankWithdrawalRequest?: Maybe<Array<Maybe<TransactionsConnectionBankWithdrawalRequest>>>;
  source?: Maybe<Array<Maybe<TransactionsConnectionSource>>>;
  currency?: Maybe<Array<Maybe<TransactionsConnectionCurrency>>>;
};

export type TransactionsConnectionId = {
  __typename?: 'TransactionsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionCreated_At = {
  __typename?: 'TransactionsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionUpdated_At = {
  __typename?: 'TransactionsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionCommercialPaper = {
  __typename?: 'TransactionsConnectionCommercialPaper';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionPayoutDate = {
  __typename?: 'TransactionsConnectionPayoutDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionTransactionNumber = {
  __typename?: 'TransactionsConnectionTransactionNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionAmount = {
  __typename?: 'TransactionsConnectionAmount';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionInvoice = {
  __typename?: 'TransactionsConnectionInvoice';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionInvestment = {
  __typename?: 'TransactionsConnectionInvestment';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionStatus = {
  __typename?: 'TransactionsConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionDescription = {
  __typename?: 'TransactionsConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionMpesaNumber = {
  __typename?: 'TransactionsConnectionMpesaNumber';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionMerchantRequestId = {
  __typename?: 'TransactionsConnectionMerchantRequestID';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionCheckoutRequestId = {
  __typename?: 'TransactionsConnectionCheckoutRequestID';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionUser = {
  __typename?: 'TransactionsConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionMpesaReceiptNumber = {
  __typename?: 'TransactionsConnectionMpesaReceiptNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionWallet = {
  __typename?: 'TransactionsConnectionWallet';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionTransactionType = {
  __typename?: 'TransactionsConnectionTransactionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionBankWithdrawalRequest = {
  __typename?: 'TransactionsConnectionBankWithdrawalRequest';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionSource = {
  __typename?: 'TransactionsConnectionSource';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionsConnectionCurrency = {
  __typename?: 'TransactionsConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TransactionsConnection>;
};

export type TransactionInput = {
  commercialPaper?: Maybe<Scalars['ID']>;
  payoutDate?: Maybe<Scalars['Date']>;
  transactionNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  invoice?: Maybe<Scalars['ID']>;
  investment?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Transactions_Status>;
  description?: Maybe<Scalars['String']>;
  mpesaNumber?: Maybe<Scalars['Long']>;
  merchantRequestID?: Maybe<Scalars['String']>;
  checkoutRequestID?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  mpesaReceiptNumber?: Maybe<Scalars['String']>;
  wallet?: Maybe<Scalars['ID']>;
  transactionType?: Maybe<Enum_Transactions_Transactiontype>;
  bankWithdrawalRequest?: Maybe<Scalars['ID']>;
  source?: Maybe<Enum_Transactions_Source>;
  currency?: Maybe<Enum_Transactions_Currency>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTransactionInput = {
  commercialPaper?: Maybe<Scalars['ID']>;
  payoutDate?: Maybe<Scalars['Date']>;
  transactionNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  invoice?: Maybe<Scalars['ID']>;
  investment?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Transactions_Status>;
  description?: Maybe<Scalars['String']>;
  mpesaNumber?: Maybe<Scalars['Long']>;
  merchantRequestID?: Maybe<Scalars['String']>;
  checkoutRequestID?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  mpesaReceiptNumber?: Maybe<Scalars['String']>;
  wallet?: Maybe<Scalars['ID']>;
  transactionType?: Maybe<Enum_Transactions_Transactiontype>;
  bankWithdrawalRequest?: Maybe<Scalars['ID']>;
  source?: Maybe<Enum_Transactions_Source>;
  currency?: Maybe<Enum_Transactions_Currency>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateTransactionInput = {
  data?: Maybe<TransactionInput>;
};

export type CreateTransactionPayload = {
  __typename?: 'createTransactionPayload';
  transaction?: Maybe<Transactions>;
};

export type UpdateTransactionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTransactionInput>;
};

export type UpdateTransactionPayload = {
  __typename?: 'updateTransactionPayload';
  transaction?: Maybe<Transactions>;
};

export type DeleteTransactionInput = {
  where?: Maybe<InputId>;
};

export type DeleteTransactionPayload = {
  __typename?: 'deleteTransactionPayload';
  transaction?: Maybe<Transactions>;
};

export enum Enum_Updaterequest_Updatetype {
  PersonalInformation = 'PERSONAL_INFORMATION',
  CompanyInformation = 'COMPANY_INFORMATION',
  MasterGeneral = 'MASTER_GENERAL',
  MasterAdditional = 'MASTER_ADDITIONAL'
}

export enum Enum_Updaterequest_Status {
  PendingReview = 'PENDING_REVIEW',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export type UpdateRequest = {
  __typename?: 'UpdateRequest';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  updateType: Enum_Updaterequest_Updatetype;
  newData?: Maybe<Scalars['JSON']>;
  user?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Enum_Updaterequest_Status>;
  oldData?: Maybe<Scalars['JSON']>;
};

export type UpdateRequestConnection = {
  __typename?: 'UpdateRequestConnection';
  values?: Maybe<Array<Maybe<UpdateRequest>>>;
  groupBy?: Maybe<UpdateRequestGroupBy>;
  aggregate?: Maybe<UpdateRequestAggregator>;
};

export type UpdateRequestAggregator = {
  __typename?: 'UpdateRequestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UpdateRequestGroupBy = {
  __typename?: 'UpdateRequestGroupBy';
  id?: Maybe<Array<Maybe<UpdateRequestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UpdateRequestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UpdateRequestConnectionUpdated_At>>>;
  updateType?: Maybe<Array<Maybe<UpdateRequestConnectionUpdateType>>>;
  newData?: Maybe<Array<Maybe<UpdateRequestConnectionNewData>>>;
  user?: Maybe<Array<Maybe<UpdateRequestConnectionUser>>>;
  status?: Maybe<Array<Maybe<UpdateRequestConnectionStatus>>>;
  oldData?: Maybe<Array<Maybe<UpdateRequestConnectionOldData>>>;
};

export type UpdateRequestConnectionId = {
  __typename?: 'UpdateRequestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionCreated_At = {
  __typename?: 'UpdateRequestConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionUpdated_At = {
  __typename?: 'UpdateRequestConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionUpdateType = {
  __typename?: 'UpdateRequestConnectionUpdateType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionNewData = {
  __typename?: 'UpdateRequestConnectionNewData';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionUser = {
  __typename?: 'UpdateRequestConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionStatus = {
  __typename?: 'UpdateRequestConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestConnectionOldData = {
  __typename?: 'UpdateRequestConnectionOldData';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UpdateRequestConnection>;
};

export type UpdateRequestInput = {
  updateType: Enum_Updaterequest_Updatetype;
  newData?: Maybe<Scalars['JSON']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Updaterequest_Status>;
  oldData?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUpdateRequestInput = {
  updateType?: Maybe<Enum_Updaterequest_Updatetype>;
  newData?: Maybe<Scalars['JSON']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Updaterequest_Status>;
  oldData?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateUpdateRequestInput = {
  data?: Maybe<UpdateRequestInput>;
};

export type CreateUpdateRequestPayload = {
  __typename?: 'createUpdateRequestPayload';
  updateRequest?: Maybe<UpdateRequest>;
};

export type UpdateUpdateRequestInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUpdateRequestInput>;
};

export type UpdateUpdateRequestPayload = {
  __typename?: 'updateUpdateRequestPayload';
  updateRequest?: Maybe<UpdateRequest>;
};

export type DeleteUpdateRequestInput = {
  where?: Maybe<InputId>;
};

export type DeleteUpdateRequestPayload = {
  __typename?: 'deleteUpdateRequestPayload';
  updateRequest?: Maybe<UpdateRequest>;
};

export type Wallet = {
  __typename?: 'Wallet';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  balance?: Maybe<Scalars['Int']>;
  user?: Maybe<UsersPermissionsUser>;
  kesBalance?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
};


export type WalletTransactionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type WalletConnection = {
  __typename?: 'WalletConnection';
  values?: Maybe<Array<Maybe<Wallet>>>;
  groupBy?: Maybe<WalletGroupBy>;
  aggregate?: Maybe<WalletAggregator>;
};

export type WalletAggregator = {
  __typename?: 'WalletAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<WalletAggregatorSum>;
  avg?: Maybe<WalletAggregatorAvg>;
  min?: Maybe<WalletAggregatorMin>;
  max?: Maybe<WalletAggregatorMax>;
};

export type WalletAggregatorSum = {
  __typename?: 'WalletAggregatorSum';
  balance?: Maybe<Scalars['Float']>;
  kesBalance?: Maybe<Scalars['Float']>;
};

export type WalletAggregatorAvg = {
  __typename?: 'WalletAggregatorAvg';
  balance?: Maybe<Scalars['Float']>;
  kesBalance?: Maybe<Scalars['Float']>;
};

export type WalletAggregatorMin = {
  __typename?: 'WalletAggregatorMin';
  balance?: Maybe<Scalars['Float']>;
  kesBalance?: Maybe<Scalars['Float']>;
};

export type WalletAggregatorMax = {
  __typename?: 'WalletAggregatorMax';
  balance?: Maybe<Scalars['Float']>;
  kesBalance?: Maybe<Scalars['Float']>;
};

export type WalletGroupBy = {
  __typename?: 'WalletGroupBy';
  id?: Maybe<Array<Maybe<WalletConnectionId>>>;
  created_at?: Maybe<Array<Maybe<WalletConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<WalletConnectionUpdated_At>>>;
  balance?: Maybe<Array<Maybe<WalletConnectionBalance>>>;
  user?: Maybe<Array<Maybe<WalletConnectionUser>>>;
  kesBalance?: Maybe<Array<Maybe<WalletConnectionKesBalance>>>;
  published_at?: Maybe<Array<Maybe<WalletConnectionPublished_At>>>;
};

export type WalletConnectionId = {
  __typename?: 'WalletConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletConnectionCreated_At = {
  __typename?: 'WalletConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletConnectionUpdated_At = {
  __typename?: 'WalletConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletConnectionBalance = {
  __typename?: 'WalletConnectionBalance';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletConnectionUser = {
  __typename?: 'WalletConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletConnectionKesBalance = {
  __typename?: 'WalletConnectionKesBalance';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletConnectionPublished_At = {
  __typename?: 'WalletConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WalletConnection>;
};

export type WalletInput = {
  balance?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  kesBalance?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditWalletInput = {
  balance?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  kesBalance?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateWalletInput = {
  data?: Maybe<WalletInput>;
};

export type CreateWalletPayload = {
  __typename?: 'createWalletPayload';
  wallet?: Maybe<Wallet>;
};

export type UpdateWalletInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditWalletInput>;
};

export type UpdateWalletPayload = {
  __typename?: 'updateWalletPayload';
  wallet?: Maybe<Wallet>;
};

export type DeleteWalletInput = {
  where?: Maybe<InputId>;
};

export type DeleteWalletPayload = {
  __typename?: 'deleteWalletPayload';
  wallet?: Maybe<Wallet>;
};

export type WelcomeSlides = {
  __typename?: 'WelcomeSlides';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  welcomeSlides?: Maybe<Array<Maybe<ComponentWelcomeSlidesWelcomeSlides>>>;
};

export type WelcomeSlideInput = {
  welcomeSlides?: Maybe<Array<Maybe<ComponentWelcomeSlidesWelcomeSlideInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditWelcomeSlideInput = {
  welcomeSlides?: Maybe<Array<Maybe<EditComponentWelcomeSlidesWelcomeSlideInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateWelcomeSlideInput = {
  data?: Maybe<EditWelcomeSlideInput>;
};

export type UpdateWelcomeSlidePayload = {
  __typename?: 'updateWelcomeSlidePayload';
  welcomeSlide?: Maybe<WelcomeSlides>;
};

export type DeleteWelcomeSlidePayload = {
  __typename?: 'deleteWelcomeSlidePayload';
  welcomeSlide?: Maybe<WelcomeSlides>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export enum Enum_Userspermissionsuser_Onboardingstatus {
  SelectRole = 'SELECT_ROLE',
  BasicInformation = 'BASIC_INFORMATION',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  CompanyInformation = 'COMPANY_INFORMATION',
  ReasonForInvesting = 'REASON_FOR_INVESTING',
  CompanyDetails = 'COMPANY_DETAILS',
  Agreement = 'AGREEMENT',
  PendingApproval = 'PENDING_APPROVAL',
  Completed = 'COMPLETED'
}

export enum Enum_Userspermissionsuser_Investoronboardingsteps {
  BasicInformation = 'BASIC_INFORMATION',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  ReasonForInvesting = 'REASON_FOR_INVESTING',
  Agreement = 'AGREEMENT',
  PendingApproval = 'PENDING_APPROVAL',
  Completed = 'COMPLETED'
}

export enum Enum_Userspermissionsuser_Smileverificationstatus {
  Pending = 'PENDING',
  ProvisionallyApproved = 'PROVISIONALLY_APPROVED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export enum Enum_Userspermissionsuser_Type {
  Sophisticated = 'Sophisticated',
  Ordinary = 'Ordinary'
}

export enum Enum_Userspermissionsuser_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<UploadFile>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  idNumber?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  officeNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  certifiedId?: Maybe<UploadFile>;
  reasonForInvesting?: Maybe<Scalars['String']>;
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Companies>;
  onboardingStatus: Enum_Userspermissionsuser_Onboardingstatus;
  investorOnboardingSteps?: Maybe<Enum_Userspermissionsuser_Investoronboardingsteps>;
  wallet?: Maybe<Wallet>;
  smileJobId?: Maybe<Scalars['String']>;
  smileVerificationStatus?: Maybe<Enum_Userspermissionsuser_Smileverificationstatus>;
  selfie?: Maybe<UploadFile>;
  type?: Maybe<Enum_Userspermissionsuser_Type>;
  currency?: Maybe<Enum_Userspermissionsuser_Currency>;
  commercialPapers?: Maybe<Array<Maybe<CommercialPapers>>>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  purchaseRequests?: Maybe<Array<Maybe<PurchaseRequest>>>;
  updateRequests?: Maybe<Array<Maybe<UpdateRequest>>>;
  investments?: Maybe<Array<Maybe<Investments>>>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
  notifications?: Maybe<Array<Maybe<Notifications>>>;
  rollover_responses?: Maybe<Array<Maybe<RolloverResponse>>>;
  topup_request?: Maybe<Array<Maybe<TopupRequest>>>;
  bank_withdrawal_requests?: Maybe<Array<Maybe<BankWithdrawalRequest>>>;
  nationalId?: Maybe<Array<Maybe<UploadFile>>>;
};


export type UsersPermissionsUserCommercialPapersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserPurchaseRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserUpdateRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserInvestmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserTransactionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNotificationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserRollover_ResponsesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserTopup_RequestArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserBank_Withdrawal_RequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNationalIdArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  phoneNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoneNumber>>>;
  profilePicture?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProfilePicture>>>;
  firstName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLastName>>>;
  dateOfBirth?: Maybe<Array<Maybe<UsersPermissionsUserConnectionDateOfBirth>>>;
  idNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionIdNumber>>>;
  mobileNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionMobileNumber>>>;
  officeNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOfficeNumber>>>;
  taxNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionTaxNumber>>>;
  citizenship?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCitizenship>>>;
  residentialAddress?: Maybe<Array<Maybe<UsersPermissionsUserConnectionResidentialAddress>>>;
  certifiedId?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCertifiedId>>>;
  reasonForInvesting?: Maybe<Array<Maybe<UsersPermissionsUserConnectionReasonForInvesting>>>;
  agreedToInvestTerms?: Maybe<Array<Maybe<UsersPermissionsUserConnectionAgreedToInvestTerms>>>;
  company?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCompany>>>;
  onboardingStatus?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOnboardingStatus>>>;
  investorOnboardingSteps?: Maybe<Array<Maybe<UsersPermissionsUserConnectionInvestorOnboardingSteps>>>;
  wallet?: Maybe<Array<Maybe<UsersPermissionsUserConnectionWallet>>>;
  smileJobId?: Maybe<Array<Maybe<UsersPermissionsUserConnectionSmileJobId>>>;
  smileVerificationStatus?: Maybe<Array<Maybe<UsersPermissionsUserConnectionSmileVerificationStatus>>>;
  selfie?: Maybe<Array<Maybe<UsersPermissionsUserConnectionSelfie>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsUserConnectionType>>>;
  currency?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCurrency>>>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPhoneNumber = {
  __typename?: 'UsersPermissionsUserConnectionPhoneNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProfilePicture = {
  __typename?: 'UsersPermissionsUserConnectionProfilePicture';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionFirstName = {
  __typename?: 'UsersPermissionsUserConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLastName = {
  __typename?: 'UsersPermissionsUserConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionDateOfBirth = {
  __typename?: 'UsersPermissionsUserConnectionDateOfBirth';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionIdNumber = {
  __typename?: 'UsersPermissionsUserConnectionIdNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionMobileNumber = {
  __typename?: 'UsersPermissionsUserConnectionMobileNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionOfficeNumber = {
  __typename?: 'UsersPermissionsUserConnectionOfficeNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionTaxNumber = {
  __typename?: 'UsersPermissionsUserConnectionTaxNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCitizenship = {
  __typename?: 'UsersPermissionsUserConnectionCitizenship';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionResidentialAddress = {
  __typename?: 'UsersPermissionsUserConnectionResidentialAddress';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCertifiedId = {
  __typename?: 'UsersPermissionsUserConnectionCertifiedId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionReasonForInvesting = {
  __typename?: 'UsersPermissionsUserConnectionReasonForInvesting';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionAgreedToInvestTerms = {
  __typename?: 'UsersPermissionsUserConnectionAgreedToInvestTerms';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCompany = {
  __typename?: 'UsersPermissionsUserConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionOnboardingStatus = {
  __typename?: 'UsersPermissionsUserConnectionOnboardingStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionInvestorOnboardingSteps = {
  __typename?: 'UsersPermissionsUserConnectionInvestorOnboardingSteps';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionWallet = {
  __typename?: 'UsersPermissionsUserConnectionWallet';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionSmileJobId = {
  __typename?: 'UsersPermissionsUserConnectionSmileJobId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionSmileVerificationStatus = {
  __typename?: 'UsersPermissionsUserConnectionSmileVerificationStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionSelfie = {
  __typename?: 'UsersPermissionsUserConnectionSelfie';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionType = {
  __typename?: 'UsersPermissionsUserConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCurrency = {
  __typename?: 'UsersPermissionsUserConnectionCurrency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  idNumber?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  officeNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  certifiedId?: Maybe<Scalars['ID']>;
  reasonForInvesting?: Maybe<Scalars['String']>;
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Scalars['ID']>;
  commercialPapers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  purchaseRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboardingStatus?: Maybe<Enum_Userspermissionsuser_Onboardingstatus>;
  updateRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investorOnboardingSteps?: Maybe<Enum_Userspermissionsuser_Investoronboardingsteps>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rollover_responses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wallet?: Maybe<Scalars['ID']>;
  smileJobId?: Maybe<Scalars['String']>;
  smileVerificationStatus?: Maybe<Enum_Userspermissionsuser_Smileverificationstatus>;
  topup_request?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bank_withdrawal_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  selfie?: Maybe<Scalars['ID']>;
  nationalId?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<Enum_Userspermissionsuser_Type>;
  currency?: Maybe<Enum_Userspermissionsuser_Currency>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  idNumber?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  officeNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  certifiedId?: Maybe<Scalars['ID']>;
  reasonForInvesting?: Maybe<Scalars['String']>;
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Scalars['ID']>;
  commercialPapers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  purchaseRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboardingStatus?: Maybe<Enum_Userspermissionsuser_Onboardingstatus>;
  updateRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investorOnboardingSteps?: Maybe<Enum_Userspermissionsuser_Investoronboardingsteps>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rollover_responses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wallet?: Maybe<Scalars['ID']>;
  smileJobId?: Maybe<Scalars['String']>;
  smileVerificationStatus?: Maybe<Enum_Userspermissionsuser_Smileverificationstatus>;
  topup_request?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bank_withdrawal_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  selfie?: Maybe<Scalars['ID']>;
  nationalId?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<Enum_Userspermissionsuser_Type>;
  currency?: Maybe<Enum_Userspermissionsuser_Currency>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export enum Enum_Componentbankingdetailsbankingdetails_Accounttype {
  Cheque = 'CHEQUE',
  Savings = 'SAVINGS'
}

export type ComponentBankingDetailsBankingDetails = {
  __typename?: 'ComponentBankingDetailsBankingDetails';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountType?: Maybe<Enum_Componentbankingdetailsbankingdetails_Accounttype>;
  accountNumber?: Maybe<Scalars['String']>;
};

export type ComponentBankingDetailsBankingDetailInput = {
  name?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountType?: Maybe<Enum_Componentbankingdetailsbankingdetails_Accounttype>;
  accountNumber?: Maybe<Scalars['String']>;
};

export type EditComponentBankingDetailsBankingDetailInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountType?: Maybe<Enum_Componentbankingdetailsbankingdetails_Accounttype>;
  accountNumber?: Maybe<Scalars['String']>;
};

export type ComponentComplianceComplianceSection = {
  __typename?: 'ComponentComplianceComplianceSection';
  id: Scalars['ID'];
  statement?: Maybe<Scalars['String']>;
  agreed?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Scalars['String']>;
};

export type ComponentComplianceComplianceSectionInput = {
  statement?: Maybe<Scalars['String']>;
  agreed?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Scalars['String']>;
};

export type EditComponentComplianceComplianceSectionInput = {
  id?: Maybe<Scalars['ID']>;
  statement?: Maybe<Scalars['String']>;
  agreed?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Scalars['String']>;
};

export type ComponentTrancheTranche = {
  __typename?: 'ComponentTrancheTranche';
  id: Scalars['ID'];
  isin?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  payoutDate?: Maybe<Scalars['Date']>;
  cra?: Maybe<Scalars['String']>;
};

export type ComponentTrancheTrancheInput = {
  isin?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  payoutDate?: Maybe<Scalars['Date']>;
  cra?: Maybe<Scalars['String']>;
};

export type EditComponentTrancheTrancheInput = {
  id?: Maybe<Scalars['ID']>;
  isin?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  payoutDate?: Maybe<Scalars['Date']>;
  cra?: Maybe<Scalars['String']>;
};

export type ComponentWelcomeSlidesWelcomeSlides = {
  __typename?: 'ComponentWelcomeSlidesWelcomeSlides';
  id: Scalars['ID'];
  image?: Maybe<UploadFile>;
  text?: Maybe<Scalars['String']>;
};

export type ComponentWelcomeSlidesWelcomeSlideInput = {
  image?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};

export type EditComponentWelcomeSlidesWelcomeSlideInput = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};

export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | ChangeMyPasswordPayload | GetCommercialPapersPayload | AvailableCommercialPapersPayload | CommercialPaperForInvestorPayload | DownloadCommercialPaperSummaryPayload | CalculateInvestmentPayload | CalculateSellPayload | BuyInvestmentPayload | GetInvestmentsPayload | MpesaResponse | GetInvestmentsByNoteIdPayload | ManagerMetricsPayload | MarketValueLogPayload | GetAllMyMasterNotesPayload | SellRequestLoss | GetAcceptedSellRequestsResponse | DownloadReceiptPayload | OkResponse | SupportTopic | Ticket | BankWithdrawalRequest | BankWithdrawalRequestConnection | BankWithdrawalRequestAggregator | BankWithdrawalRequestAggregatorSum | BankWithdrawalRequestAggregatorAvg | BankWithdrawalRequestAggregatorMin | BankWithdrawalRequestAggregatorMax | BankWithdrawalRequestGroupBy | BankWithdrawalRequestConnectionId | BankWithdrawalRequestConnectionCreated_At | BankWithdrawalRequestConnectionUpdated_At | BankWithdrawalRequestConnectionBankName | BankWithdrawalRequestConnectionAccountName | BankWithdrawalRequestConnectionAccountNumber | BankWithdrawalRequestConnectionAmount | BankWithdrawalRequestConnectionUser | BankWithdrawalRequestConnectionStatus | BankWithdrawalRequestConnectionTransaction | BankWithdrawalRequestConnectionMpesaNumber | BankWithdrawalRequestConnectionWithdrawType | BankWithdrawalRequestConnectionCurrency | BankWithdrawalRequestConnectionPublished_At | CreateBankWithdrawalRequestPayload | UpdateBankWithdrawalRequestPayload | DeleteBankWithdrawalRequestPayload | BankingInformation | BankingInformationConnection | BankingInformationAggregator | BankingInformationGroupBy | BankingInformationConnectionId | BankingInformationConnectionCreated_At | BankingInformationConnectionUpdated_At | BankingInformationConnectionBankName | BankingInformationConnectionAccountHolder | BankingInformationConnectionTypeOfAccount | BankingInformationConnectionAccountNumber | BankingInformationConnectionCompany | CreateBankingInformationPayload | UpdateBankingInformationPayload | DeleteBankingInformationPayload | CommercialPapers | CommercialPapersConnection | CommercialPapersAggregator | CommercialPapersAggregatorSum | CommercialPapersAggregatorAvg | CommercialPapersAggregatorMin | CommercialPapersAggregatorMax | CommercialPapersGroupBy | CommercialPapersConnectionId | CommercialPapersConnectionCreated_At | CommercialPapersConnectionUpdated_At | CommercialPapersConnectionSubmittedAt | CommercialPapersConnectionCompany | CommercialPapersConnectionAmount | CommercialPapersConnectionAmountNeeded | CommercialPapersConnectionPayoutDate | CommercialPapersConnectionInterestRate | CommercialPapersConnectionStatus | CommercialPapersConnectionIndustryType | CommercialPapersConnectionProposedDateOfIssue | CommercialPapersConnectionConditions | CommercialPapersConnectionPurposeOfIssue | CommercialPapersConnectionCommercialPaperType | CommercialPapersConnectionCertOfIncorporation | CommercialPapersConnectionDirectorsApproval | CommercialPapersConnectionAccountsReport | CommercialPapersConnectionFinancialStatements | CommercialPapersConnectionTaxCertificate | CommercialPapersConnectionCompanyConsent | CommercialPapersConnectionSignature | CommercialPapersConnectionSignedBy | CommercialPapersConnectionSignedAt | CommercialPapersConnectionMaturesAt | CommercialPapersConnectionInvestmentTermType | CommercialPapersConnectionInvestmentTerm | CommercialPapersConnectionUser | CommercialPapersConnectionCurrentStep | CommercialPapersConnectionLengthOfCp | CommercialPapersConnectionEligibilityRequirement | CommercialPapersConnectionCorporateGovernanceRequirement | CommercialPapersConnectionApprovedAt | CommercialPapersConnectionServiceInterestRate | CommercialPapersConnectionPayout_Request | CommercialPapersConnectionDateFunded | CommercialPapersConnectionMinInvestment | CommercialPapersConnectionInterestFrequency | CommercialPapersConnectionPurchaseFee | CommercialPapersConnectionShortHoldFee | CommercialPapersConnectionShortHoldDescription | CommercialPapersConnectionInterestFrequencyDescription | CommercialPapersConnectionType | CommercialPapersConnectionDescription | CommercialPapersConnectionPotentialRisks | CommercialPapersConnectionTitle | CommercialPapersConnectionManagementFee | CommercialPapersConnectionShortHoldFeeDuration | CommercialPapersConnectionSellFee | CommercialPapersConnectionMasterNoteMarketValue | CommercialPapersConnectionNoteMarketValue | CommercialPapersConnectionNumberOfPaidInterest | CommercialPapersConnectionMasterNote | CommercialPapersConnectionPurchasePrice | CommercialPapersConnectionLockDown | CommercialPapersConnectionFaceValue | CommercialPapersConnectionNextInterestPayment | CommercialPapersConnectionCurrency | CommercialPapersConnectionFundManager | CommercialPapersConnectionAssetType | CommercialPapersConnectionFollowup | CreateCommercialPaperPayload | UpdateCommercialPaperPayload | DeleteCommercialPaperPayload | Companies | CompaniesConnection | CompaniesAggregator | CompaniesAggregatorSum | CompaniesAggregatorAvg | CompaniesAggregatorMin | CompaniesAggregatorMax | CompaniesGroupBy | CompaniesConnectionId | CompaniesConnectionCreated_At | CompaniesConnectionUpdated_At | CompaniesConnectionUser | CompaniesConnectionName | CompaniesConnectionCompanyType | CompaniesConnectionIndustryType | CompaniesConnectionLogo | CompaniesConnectionBriefDescription | CompaniesConnectionPlatformUseReason | CompaniesConnectionRegistrationNumber | CompaniesConnectionRegisteredAt | CompaniesConnectionCountryOfRegistration | CompaniesConnectionVatNumber | CompaniesConnectionTaxNumber | CompaniesConnectionFinancialSummary | CompaniesConnectionRegistrationStatus | CompaniesConnectionFormattedAddress | CompaniesConnectionNetWorth | CompaniesConnectionGrossIncome | CompaniesConnectionTotalDebt | CompaniesConnectionBankingInformation | CompaniesConnectionActiveSince | CreateCompanyPayload | UpdateCompanyPayload | DeleteCompanyPayload | CorporateGovernanceRequirements | CorporateGovernanceRequirementsConnection | CorporateGovernanceRequirementsAggregator | CorporateGovernanceRequirementsGroupBy | CorporateGovernanceRequirementsConnectionId | CorporateGovernanceRequirementsConnectionCreated_At | CorporateGovernanceRequirementsConnectionUpdated_At | CorporateGovernanceRequirementsConnectionReasonsForNonCompliance | CorporateGovernanceRequirementsConnectionStrategicGuidance | CorporateGovernanceRequirementsConnectionRelevantCommittees | CorporateGovernanceRequirementsConnectionAvailabilityAndReliabilityOfFinancialRecords | CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectors | CorporateGovernanceRequirementsConnectionDirectorCompliance | CorporateGovernanceRequirementsConnectionReasonsForNonComplianceComment | CorporateGovernanceRequirementsConnectionStrategicGuidanceComment | CorporateGovernanceRequirementsConnectionRelevantCommitteesComment | CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoardComment | CorporateGovernanceRequirementsConnectionBalanceOfExecutiveAndNonExecutiveDirectorsComment | CorporateGovernanceRequirementsConnectionDirectorComplianceComment | CorporateGovernanceRequirementsConnectionCommercialPaper | CorporateGovernanceRequirementsConnectionCommitteeSpecificationsBoard | CorporateGovernanceRequirementsConnectionRolesAndResponsibilities | CorporateGovernanceRequirementsConnectionRolesAndResponsibilitiesComment | CorporateGovernanceRequirementsConnectionChairpersonCompliance | CorporateGovernanceRequirementsConnectionChairpersonComplianceComment | CorporateGovernanceRequirementsConnectionNominatingCommittee | CorporateGovernanceRequirementsConnectionNominatingCommitteeComment | CorporateGovernanceRequirementsConnectionAuditCommittee | CorporateGovernanceRequirementsConnectionAuditCommitteeComment | CreateCorporateGovernanceRequirementPayload | UpdateCorporateGovernanceRequirementPayload | DeleteCorporateGovernanceRequirementPayload | EligibilityRequirement | EligibilityRequirementConnection | EligibilityRequirementAggregator | EligibilityRequirementGroupBy | EligibilityRequirementConnectionId | EligibilityRequirementConnectionCreated_At | EligibilityRequirementConnectionUpdated_At | EligibilityRequirementConnectionIncorporationWithLimitedLiability | EligibilityRequirementConnectionIncorporationWithLimitedLiabilityComment | EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuer | EligibilityRequirementConnectionShareCapitalAndNetAssetsOfIssuerComment | EligibilityRequirementConnectionListingAndTransferabilityOfSecurities | EligibilityRequirementConnectionListingAndTransferabilityOfSecuritiesComment | EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecords | EligibilityRequirementConnectionAvailabilityAndReliabilityOfFinancialRecordsComment | EligibilityRequirementConnectionDirectorsAndSeniorManagement | EligibilityRequirementConnectionDirectorsAndSeniorManagementComment | EligibilityRequirementConnectionCertificateOfComfort | EligibilityRequirementConnectionCertificateOfComfortComment | EligibilityRequirementConnectionCommercialPaper | EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspects | EligibilityRequirementConnectionProfitableHistoricTrackRecordAndFutureProspectsComment | EligibilityRequirementConnectionGuaranteeRequirements | EligibilityRequirementConnectionGuaranteeRequirementsComment | EligibilityRequirementConnectionDebtRatio | EligibilityRequirementConnectionDebtRatioComment | EligibilityRequirementConnectionSizeIssue | EligibilityRequirementConnectionSizeIssueComment | EligibilityRequirementConnectionMinimumSize | EligibilityRequirementConnectionMinimumSizeComment | EligibilityRequirementConnectionRenewalDate | EligibilityRequirementConnectionRenewalDateComment | CreateEligibilityRequirementPayload | UpdateEligibilityRequirementPayload | DeleteEligibilityRequirementPayload | FinancialSummaries | FinancialSummariesConnection | FinancialSummariesAggregator | FinancialSummariesGroupBy | FinancialSummariesConnectionId | FinancialSummariesConnectionCreated_At | FinancialSummariesConnectionUpdated_At | FinancialSummariesConnectionNetWorth | FinancialSummariesConnectionTotalDeptOutstanding | FinancialSummariesConnectionTotalDeptOutstandingOther | FinancialSummariesConnectionGrossIncome | FinancialSummariesConnectionGrossProfit | FinancialSummariesConnectionOperatingProfit | FinancialSummariesConnectionNetProfit | FinancialSummariesConnectionDetailsOfDefaultCp | FinancialSummariesConnectionDetailsOfDefaultDelay | FinancialSummariesConnectionCompany | CreateFinancialSummaryPayload | UpdateFinancialSummaryPayload | DeleteFinancialSummaryPayload | Investments | InvestmentsConnection | InvestmentsAggregator | InvestmentsAggregatorSum | InvestmentsAggregatorAvg | InvestmentsAggregatorMin | InvestmentsAggregatorMax | InvestmentsGroupBy | InvestmentsConnectionId | InvestmentsConnectionCreated_At | InvestmentsConnectionUpdated_At | InvestmentsConnectionAmount | InvestmentsConnectionCommercialPaper | InvestmentsConnectionStatus | InvestmentsConnectionCompany | InvestmentsConnectionUser | InvestmentsConnectionApprovedAt | InvestmentsConnectionTotalReturn | InvestmentsConnectionLastPayInterestDate | InvestmentsConnectionCurrency | CreateInvestmentPayload | UpdateInvestmentPayload | DeleteInvestmentPayload | Jamiipesa | UpdateJamiipesaPayload | DeleteJamiipesaPayload | MarketValueLog | MarketValueLogConnection | MarketValueLogAggregator | MarketValueLogAggregatorSum | MarketValueLogAggregatorAvg | MarketValueLogAggregatorMin | MarketValueLogAggregatorMax | MarketValueLogGroupBy | MarketValueLogConnectionId | MarketValueLogConnectionCreated_At | MarketValueLogConnectionUpdated_At | MarketValueLogConnectionApprovedAt | MarketValueLogConnectionValue | MarketValueLogConnectionStatus | MarketValueLogConnectionCommercialPaper | MarketValueLogConnectionMasterNote | MarketValueLogConnectionPublished_At | CreateMarketValueLogPayload | UpdateMarketValueLogPayload | DeleteMarketValueLogPayload | MasterNote | MasterNoteConnection | MasterNoteAggregator | MasterNoteAggregatorSum | MasterNoteAggregatorAvg | MasterNoteAggregatorMin | MasterNoteAggregatorMax | MasterNoteGroupBy | MasterNoteConnectionId | MasterNoteConnectionCreated_At | MasterNoteConnectionUpdated_At | MasterNoteConnectionTitle | MasterNoteConnectionType | MasterNoteConnectionInterestRate | MasterNoteConnectionInterestFrequency | MasterNoteConnectionMaturityDate | MasterNoteConnectionMarketValue | MasterNoteConnectionDescription | MasterNoteConnectionPotentialRisks | MasterNoteConnectionUser | MasterNoteConnectionCurrentStep | MasterNoteConnectionStatus | MasterNoteConnectionCurrency | MasterNoteConnectionFundManager | MasterNoteConnectionAssetType | MasterNoteConnectionPublished_At | CreateMasterNotePayload | UpdateMasterNotePayload | DeleteMasterNotePayload | Notes | NotesConnection | NotesAggregator | NotesGroupBy | NotesConnectionId | NotesConnectionCreated_At | NotesConnectionUpdated_At | NotesConnectionUser | NotesConnectionMessage | NotesConnectionNoteType | NotesConnectionCommercialPaper | CreateNotePayload | UpdateNotePayload | DeleteNotePayload | Notifications | NotificationsConnection | NotificationsAggregator | NotificationsGroupBy | NotificationsConnectionId | NotificationsConnectionCreated_At | NotificationsConnectionUpdated_At | NotificationsConnectionMessage | NotificationsConnectionIsRead | NotificationsConnectionTitle | NotificationsConnectionCategory | NotificationsConnectionUser | NotificationsConnectionAdditionalInformation | CreateNotificationPayload | UpdateNotificationPayload | DeleteNotificationPayload | PayoutRequest | PayoutRequestConnection | PayoutRequestAggregator | PayoutRequestGroupBy | PayoutRequestConnectionId | PayoutRequestConnectionCreated_At | PayoutRequestConnectionUpdated_At | PayoutRequestConnectionAmount | PayoutRequestConnectionStatus | PayoutRequestConnectionCommercialPaper | PayoutRequestConnectionType | PayoutRequestConnectionInterestMetric | PayoutRequestConnectionCorporateAmount | PayoutRequestConnectionCurrency | PayoutRequestConnectionPublished_At | CreatePayoutRequestPayload | UpdatePayoutRequestPayload | DeletePayoutRequestPayload | PurchaseRequest | PurchaseRequestConnection | PurchaseRequestAggregator | PurchaseRequestAggregatorSum | PurchaseRequestAggregatorAvg | PurchaseRequestAggregatorMin | PurchaseRequestAggregatorMax | PurchaseRequestGroupBy | PurchaseRequestConnectionId | PurchaseRequestConnectionCreated_At | PurchaseRequestConnectionUpdated_At | PurchaseRequestConnectionStatus | PurchaseRequestConnectionInterestRate | PurchaseRequestConnectionTotalReturn | PurchaseRequestConnectionPurchasePrice | PurchaseRequestConnectionInvestmentTerm | PurchaseRequestConnectionInvestmentTermType | PurchaseRequestConnectionInvestmentDate | PurchaseRequestConnectionFaceValue | PurchaseRequestConnectionWithHoldingTax | PurchaseRequestConnectionSignedAt | PurchaseRequestConnectionDueDate | PurchaseRequestConnectionSignedBy | PurchaseRequestConnectionCommercialPaper | PurchaseRequestConnectionUser | CreatePurchaseRequestPayload | UpdatePurchaseRequestPayload | DeletePurchaseRequestPayload | RolloverRequests | RolloverRequestsConnection | RolloverRequestsAggregator | RolloverRequestsAggregatorSum | RolloverRequestsAggregatorAvg | RolloverRequestsAggregatorMin | RolloverRequestsAggregatorMax | RolloverRequestsGroupBy | RolloverRequestsConnectionId | RolloverRequestsConnectionCreated_At | RolloverRequestsConnectionUpdated_At | RolloverRequestsConnectionProposedMaturityDate | RolloverRequestsConnectionRolloverPeriod | RolloverRequestsConnectionCommercialPaper | RolloverRequestsConnectionReason | CreateRolloverRequestPayload | UpdateRolloverRequestPayload | DeleteRolloverRequestPayload | RolloverResponse | RolloverResponseConnection | RolloverResponseAggregator | RolloverResponseGroupBy | RolloverResponseConnectionId | RolloverResponseConnectionCreated_At | RolloverResponseConnectionUpdated_At | RolloverResponseConnectionStatus | RolloverResponseConnectionUser | RolloverResponseConnectionRolloverRequest | RolloverResponseConnectionPublished_At | CreateRolloverResponsePayload | UpdateRolloverResponsePayload | DeleteRolloverResponsePayload | SellRequest | SellRequestConnection | SellRequestAggregator | SellRequestGroupBy | SellRequestConnectionId | SellRequestConnectionCreated_At | SellRequestConnectionUpdated_At | SellRequestConnectionCustomerValue | SellRequestConnectionSellAmount | SellRequestConnectionCommercialPaper | SellRequestConnectionInvestment | SellRequestConnectionStatus | SellRequestConnectionShortHoldFeeAmount | SellRequestConnectionSellFeeAmount | SellRequestConnectionUser | SellRequestConnectionCheck | SellRequestConnectionCurrency | SellRequestConnectionPublished_At | CreateSellRequestPayload | UpdateSellRequestPayload | DeleteSellRequestPayload | TopupRequest | TopupRequestConnection | TopupRequestAggregator | TopupRequestAggregatorSum | TopupRequestAggregatorAvg | TopupRequestAggregatorMin | TopupRequestAggregatorMax | TopupRequestGroupBy | TopupRequestConnectionId | TopupRequestConnectionCreated_At | TopupRequestConnectionUpdated_At | TopupRequestConnectionIntendedAmount | TopupRequestConnectionDepositedAmount | TopupRequestConnectionStatus | TopupRequestConnectionCompletedAt | TopupRequestConnectionUser | TopupRequestConnectionReferenceNumber | TopupRequestConnectionCurrency | TopupRequestConnectionPublished_At | CreateTopupRequestPayload | UpdateTopupRequestPayload | DeleteTopupRequestPayload | Transactions | TransactionsConnection | TransactionsAggregator | TransactionsAggregatorSum | TransactionsAggregatorAvg | TransactionsAggregatorMin | TransactionsAggregatorMax | TransactionsGroupBy | TransactionsConnectionId | TransactionsConnectionCreated_At | TransactionsConnectionUpdated_At | TransactionsConnectionCommercialPaper | TransactionsConnectionPayoutDate | TransactionsConnectionTransactionNumber | TransactionsConnectionAmount | TransactionsConnectionInvoice | TransactionsConnectionInvestment | TransactionsConnectionStatus | TransactionsConnectionDescription | TransactionsConnectionMpesaNumber | TransactionsConnectionMerchantRequestId | TransactionsConnectionCheckoutRequestId | TransactionsConnectionUser | TransactionsConnectionMpesaReceiptNumber | TransactionsConnectionWallet | TransactionsConnectionTransactionType | TransactionsConnectionBankWithdrawalRequest | TransactionsConnectionSource | TransactionsConnectionCurrency | CreateTransactionPayload | UpdateTransactionPayload | DeleteTransactionPayload | UpdateRequest | UpdateRequestConnection | UpdateRequestAggregator | UpdateRequestGroupBy | UpdateRequestConnectionId | UpdateRequestConnectionCreated_At | UpdateRequestConnectionUpdated_At | UpdateRequestConnectionUpdateType | UpdateRequestConnectionNewData | UpdateRequestConnectionUser | UpdateRequestConnectionStatus | UpdateRequestConnectionOldData | CreateUpdateRequestPayload | UpdateUpdateRequestPayload | DeleteUpdateRequestPayload | Wallet | WalletConnection | WalletAggregator | WalletAggregatorSum | WalletAggregatorAvg | WalletAggregatorMin | WalletAggregatorMax | WalletGroupBy | WalletConnectionId | WalletConnectionCreated_At | WalletConnectionUpdated_At | WalletConnectionBalance | WalletConnectionUser | WalletConnectionKesBalance | WalletConnectionPublished_At | CreateWalletPayload | UpdateWalletPayload | DeleteWalletPayload | WelcomeSlides | UpdateWelcomeSlidePayload | DeleteWelcomeSlidePayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | DeleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionPhoneNumber | UsersPermissionsUserConnectionProfilePicture | UsersPermissionsUserConnectionFirstName | UsersPermissionsUserConnectionLastName | UsersPermissionsUserConnectionDateOfBirth | UsersPermissionsUserConnectionIdNumber | UsersPermissionsUserConnectionMobileNumber | UsersPermissionsUserConnectionOfficeNumber | UsersPermissionsUserConnectionTaxNumber | UsersPermissionsUserConnectionCitizenship | UsersPermissionsUserConnectionResidentialAddress | UsersPermissionsUserConnectionCertifiedId | UsersPermissionsUserConnectionReasonForInvesting | UsersPermissionsUserConnectionAgreedToInvestTerms | UsersPermissionsUserConnectionCompany | UsersPermissionsUserConnectionOnboardingStatus | UsersPermissionsUserConnectionInvestorOnboardingSteps | UsersPermissionsUserConnectionWallet | UsersPermissionsUserConnectionSmileJobId | UsersPermissionsUserConnectionSmileVerificationStatus | UsersPermissionsUserConnectionSelfie | UsersPermissionsUserConnectionType | UsersPermissionsUserConnectionCurrency | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentBankingDetailsBankingDetails | ComponentComplianceComplianceSection | ComponentTrancheTranche | ComponentWelcomeSlidesWelcomeSlides;

export type InputId = {
  id: Scalars['ID'];
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  bankWithdrawalRequest?: Maybe<BankWithdrawalRequest>;
  bankWithdrawalRequests?: Maybe<Array<Maybe<BankWithdrawalRequest>>>;
  bankWithdrawalRequestsConnection?: Maybe<BankWithdrawalRequestConnection>;
  bankingInformation?: Maybe<BankingInformation>;
  bankingInformations?: Maybe<Array<Maybe<BankingInformation>>>;
  bankingInformationsConnection?: Maybe<BankingInformationConnection>;
  commercialPaper?: Maybe<CommercialPapers>;
  commercialPapers?: Maybe<Array<Maybe<CommercialPapers>>>;
  commercialPapersConnection?: Maybe<CommercialPapersConnection>;
  company?: Maybe<Companies>;
  companies?: Maybe<Array<Maybe<Companies>>>;
  companiesConnection?: Maybe<CompaniesConnection>;
  corporateGovernanceRequirement?: Maybe<CorporateGovernanceRequirements>;
  corporateGovernanceRequirements?: Maybe<Array<Maybe<CorporateGovernanceRequirements>>>;
  corporateGovernanceRequirementsConnection?: Maybe<CorporateGovernanceRequirementsConnection>;
  eligibilityRequirement?: Maybe<EligibilityRequirement>;
  eligibilityRequirements?: Maybe<Array<Maybe<EligibilityRequirement>>>;
  eligibilityRequirementsConnection?: Maybe<EligibilityRequirementConnection>;
  financialSummary?: Maybe<FinancialSummaries>;
  financialSummaries?: Maybe<Array<Maybe<FinancialSummaries>>>;
  financialSummariesConnection?: Maybe<FinancialSummariesConnection>;
  investment?: Maybe<Investments>;
  investments?: Maybe<Array<Maybe<Investments>>>;
  investmentsConnection?: Maybe<InvestmentsConnection>;
  jamiipesa?: Maybe<Jamiipesa>;
  marketValueLog?: Maybe<MarketValueLog>;
  marketValueLogs?: Maybe<Array<Maybe<MarketValueLog>>>;
  marketValueLogsConnection?: Maybe<MarketValueLogConnection>;
  masterNote?: Maybe<MasterNote>;
  masterNotes?: Maybe<Array<Maybe<MasterNote>>>;
  masterNotesConnection?: Maybe<MasterNoteConnection>;
  note?: Maybe<Notes>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  notesConnection?: Maybe<NotesConnection>;
  notification?: Maybe<Notifications>;
  notifications?: Maybe<Array<Maybe<Notifications>>>;
  notificationsConnection?: Maybe<NotificationsConnection>;
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequests?: Maybe<Array<Maybe<PayoutRequest>>>;
  payoutRequestsConnection?: Maybe<PayoutRequestConnection>;
  purchaseRequest?: Maybe<PurchaseRequest>;
  purchaseRequests?: Maybe<Array<Maybe<PurchaseRequest>>>;
  purchaseRequestsConnection?: Maybe<PurchaseRequestConnection>;
  rolloverRequest?: Maybe<RolloverRequests>;
  rolloverRequests?: Maybe<Array<Maybe<RolloverRequests>>>;
  rolloverRequestsConnection?: Maybe<RolloverRequestsConnection>;
  rolloverResponse?: Maybe<RolloverResponse>;
  rolloverResponses?: Maybe<Array<Maybe<RolloverResponse>>>;
  rolloverResponsesConnection?: Maybe<RolloverResponseConnection>;
  sellRequest?: Maybe<SellRequest>;
  sellRequests?: Maybe<Array<Maybe<SellRequest>>>;
  sellRequestsConnection?: Maybe<SellRequestConnection>;
  topupRequest?: Maybe<TopupRequest>;
  topupRequests?: Maybe<Array<Maybe<TopupRequest>>>;
  topupRequestsConnection?: Maybe<TopupRequestConnection>;
  transaction?: Maybe<Transactions>;
  transactions?: Maybe<Array<Maybe<Transactions>>>;
  transactionsConnection?: Maybe<TransactionsConnection>;
  updateRequest?: Maybe<UpdateRequest>;
  updateRequests?: Maybe<Array<Maybe<UpdateRequest>>>;
  updateRequestsConnection?: Maybe<UpdateRequestConnection>;
  wallet?: Maybe<Wallet>;
  wallets?: Maybe<Array<Maybe<Wallet>>>;
  walletsConnection?: Maybe<WalletConnection>;
  welcomeSlide?: Maybe<WelcomeSlides>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
  getMyProfile?: Maybe<UsersPermissionsUser>;
  getMyBankingInformation?: Maybe<BankingInformation>;
  getCommercialPapers?: Maybe<GetCommercialPapersPayload>;
  countMyActivePapers?: Maybe<Scalars['Int']>;
  getCommercialPapersCount?: Maybe<Scalars['Int']>;
  getCommercialPaperById?: Maybe<CommercialPapers>;
  getAvailableCommercialPapers?: Maybe<AvailableCommercialPapersPayload>;
  getCommercialPaperForInvestor?: Maybe<CommercialPaperForInvestorPayload>;
  downloadCommercialPaperSummary?: Maybe<DownloadCommercialPaperSummaryPayload>;
  getMyFinancialSummary?: Maybe<FinancialSummaries>;
  getInvestments?: Maybe<GetInvestmentsPayload>;
  myTotalInvestedAmountByCP?: Maybe<Scalars['Int']>;
  getInvestmentsByNoteId?: Maybe<GetInvestmentsByNoteIdPayload>;
  getManagerMetrics?: Maybe<ManagerMetricsPayload>;
  getMarketValueLog?: Maybe<MarketValueLogPayload>;
  getMyMasterNoteById?: Maybe<MasterNote>;
  getAllMyMasterNotes?: Maybe<GetAllMyMasterNotesPayload>;
  getMyNotifications?: Maybe<Array<Maybe<Notifications>>>;
  getNewRolloverRequests?: Maybe<Array<Maybe<RolloverRequests>>>;
  getAcceptedSellRequests?: Maybe<GetAcceptedSellRequestsResponse>;
  getTransactionById?: Maybe<Transactions>;
  getMyTransactions?: Maybe<Array<Maybe<Transactions>>>;
  downloadReceipt?: Maybe<DownloadReceiptPayload>;
  myWalletBalance?: Maybe<Scalars['Float']>;
  getAllSupportTopics?: Maybe<Array<Maybe<SupportTopic>>>;
};


export type QueryBankWithdrawalRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBankWithdrawalRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBankWithdrawalRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBankingInformationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBankingInformationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBankingInformationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCommercialPaperArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCommercialPapersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCommercialPapersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCompaniesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCorporateGovernanceRequirementArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporateGovernanceRequirementsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCorporateGovernanceRequirementsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEligibilityRequirementArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryEligibilityRequirementsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryEligibilityRequirementsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFinancialSummaryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryFinancialSummariesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFinancialSummariesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryInvestmentArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryInvestmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryInvestmentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryJamiipesaArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryMarketValueLogArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMarketValueLogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMarketValueLogsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryMasterNoteArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMasterNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMasterNotesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNoteArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotificationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotificationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPayoutRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPayoutRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPayoutRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPurchaseRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPurchaseRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPurchaseRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolloverRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolloverRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolloverRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolloverResponseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolloverResponsesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolloverResponsesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySellRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerySellRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerySellRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTopupRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTopupRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTopupRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTransactionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTransactionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTransactionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUpdateRequestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUpdateRequestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUpdateRequestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryWalletArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryWalletsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryWalletsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryWelcomeSlideArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetCommercialPapersArgs = {
  limit?: Maybe<Scalars['Int']>;
  filters?: Maybe<CpFilter>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<Cp_Sort_By>;
  showClosed?: Maybe<Scalars['Boolean']>;
};


export type QueryCountMyActivePapersArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type QueryGetCommercialPapersCountArgs = {
  filters?: Maybe<CpFilter>;
};


export type QueryGetCommercialPaperByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAvailableCommercialPapersArgs = {
  input?: Maybe<AvailableCommercialPapersInput>;
};


export type QueryGetCommercialPaperForInvestorArgs = {
  id: Scalars['ID'];
};


export type QueryDownloadCommercialPaperSummaryArgs = {
  id: Scalars['ID'];
};


export type QueryGetInvestmentsArgs = {
  filters?: Maybe<InvestmentFilter>;
  currency: Scalars['String'];
};


export type QueryMyTotalInvestedAmountByCpArgs = {
  commercialPaperId: Scalars['ID'];
};


export type QueryGetInvestmentsByNoteIdArgs = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  noteId: Scalars['ID'];
};


export type QueryGetManagerMetricsArgs = {
  filters?: Maybe<GetManagerMetricsFilters>;
  currency: Scalars['String'];
};


export type QueryGetMarketValueLogArgs = {
  masterNoteId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryGetMyMasterNoteByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAllMyMasterNotesArgs = {
  filters?: Maybe<MasterNoteFilter>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMyNotificationsArgs = {
  sort?: Maybe<Scalars['String']>;
};


export type QueryGetNewRolloverRequestsArgs = {
  commercialPaperId: Scalars['ID'];
};


export type QueryGetAcceptedSellRequestsArgs = {
  currency: Scalars['String'];
};


export type QueryGetTransactionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetMyTransactionsArgs = {
  currency: Scalars['String'];
};


export type QueryDownloadReceiptArgs = {
  id: Scalars['ID'];
};


export type QueryMyWalletBalanceArgs = {
  currency?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBankWithdrawalRequest?: Maybe<CreateBankWithdrawalRequestPayload>;
  updateBankWithdrawalRequest?: Maybe<UpdateBankWithdrawalRequestPayload>;
  deleteBankWithdrawalRequest?: Maybe<DeleteBankWithdrawalRequestPayload>;
  createBankingInformation?: Maybe<CreateBankingInformationPayload>;
  updateBankingInformation?: Maybe<UpdateBankingInformationPayload>;
  deleteBankingInformation?: Maybe<DeleteBankingInformationPayload>;
  createCommercialPaper?: Maybe<CreateCommercialPaperPayload>;
  updateCommercialPaper?: Maybe<UpdateCommercialPaperPayload>;
  deleteCommercialPaper?: Maybe<DeleteCommercialPaperPayload>;
  createCompany?: Maybe<CreateCompanyPayload>;
  updateCompany?: Maybe<UpdateCompanyPayload>;
  deleteCompany?: Maybe<DeleteCompanyPayload>;
  createCorporateGovernanceRequirement?: Maybe<CreateCorporateGovernanceRequirementPayload>;
  updateCorporateGovernanceRequirement?: Maybe<UpdateCorporateGovernanceRequirementPayload>;
  deleteCorporateGovernanceRequirement?: Maybe<DeleteCorporateGovernanceRequirementPayload>;
  createEligibilityRequirement?: Maybe<CreateEligibilityRequirementPayload>;
  updateEligibilityRequirement?: Maybe<UpdateEligibilityRequirementPayload>;
  deleteEligibilityRequirement?: Maybe<DeleteEligibilityRequirementPayload>;
  createFinancialSummary?: Maybe<CreateFinancialSummaryPayload>;
  updateFinancialSummary?: Maybe<UpdateFinancialSummaryPayload>;
  deleteFinancialSummary?: Maybe<DeleteFinancialSummaryPayload>;
  createInvestment?: Maybe<CreateInvestmentPayload>;
  updateInvestment?: Maybe<UpdateInvestmentPayload>;
  deleteInvestment?: Maybe<DeleteInvestmentPayload>;
  updateJamiipesa?: Maybe<UpdateJamiipesaPayload>;
  deleteJamiipesa?: Maybe<DeleteJamiipesaPayload>;
  createMarketValueLog?: Maybe<CreateMarketValueLogPayload>;
  updateMarketValueLog?: Maybe<UpdateMarketValueLogPayload>;
  deleteMarketValueLog?: Maybe<DeleteMarketValueLogPayload>;
  createMasterNote?: Maybe<CreateMasterNotePayload>;
  updateMasterNote?: Maybe<UpdateMasterNotePayload>;
  deleteMasterNote?: Maybe<DeleteMasterNotePayload>;
  createNote?: Maybe<CreateNotePayload>;
  updateNote?: Maybe<UpdateNotePayload>;
  deleteNote?: Maybe<DeleteNotePayload>;
  createNotification?: Maybe<CreateNotificationPayload>;
  updateNotification?: Maybe<UpdateNotificationPayload>;
  deleteNotification?: Maybe<DeleteNotificationPayload>;
  createPayoutRequest?: Maybe<CreatePayoutRequestPayload>;
  updatePayoutRequest?: Maybe<UpdatePayoutRequestPayload>;
  deletePayoutRequest?: Maybe<DeletePayoutRequestPayload>;
  createPurchaseRequest?: Maybe<CreatePurchaseRequestPayload>;
  updatePurchaseRequest?: Maybe<UpdatePurchaseRequestPayload>;
  deletePurchaseRequest?: Maybe<DeletePurchaseRequestPayload>;
  createRolloverRequest?: Maybe<CreateRolloverRequestPayload>;
  updateRolloverRequest?: Maybe<UpdateRolloverRequestPayload>;
  deleteRolloverRequest?: Maybe<DeleteRolloverRequestPayload>;
  createRolloverResponse?: Maybe<CreateRolloverResponsePayload>;
  updateRolloverResponse?: Maybe<UpdateRolloverResponsePayload>;
  deleteRolloverResponse?: Maybe<DeleteRolloverResponsePayload>;
  createSellRequest?: Maybe<CreateSellRequestPayload>;
  updateSellRequest?: Maybe<UpdateSellRequestPayload>;
  deleteSellRequest?: Maybe<DeleteSellRequestPayload>;
  createTopupRequest?: Maybe<CreateTopupRequestPayload>;
  updateTopupRequest?: Maybe<UpdateTopupRequestPayload>;
  deleteTopupRequest?: Maybe<DeleteTopupRequestPayload>;
  createTransaction?: Maybe<CreateTransactionPayload>;
  updateTransaction?: Maybe<UpdateTransactionPayload>;
  deleteTransaction?: Maybe<DeleteTransactionPayload>;
  createUpdateRequest?: Maybe<CreateUpdateRequestPayload>;
  updateUpdateRequest?: Maybe<UpdateUpdateRequestPayload>;
  deleteUpdateRequest?: Maybe<DeleteUpdateRequestPayload>;
  createWallet?: Maybe<CreateWalletPayload>;
  updateWallet?: Maybe<UpdateWalletPayload>;
  deleteWallet?: Maybe<DeleteWalletPayload>;
  updateWelcomeSlide?: Maybe<UpdateWelcomeSlidePayload>;
  deleteWelcomeSlide?: Maybe<DeleteWelcomeSlidePayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  changeAppUse?: Maybe<UsersPermissionsUser>;
  changeCurrency?: Maybe<UsersPermissionsUser>;
  onboarding?: Maybe<UsersPermissionsUser>;
  investorOnboarding?: Maybe<UsersPermissionsUser>;
  changeMyPassword?: Maybe<ChangeMyPasswordPayload>;
  updateRegulatoryProfile?: Maybe<UsersPermissionsUser>;
  submitBankWithdrawRequest?: Maybe<OkResponse>;
  updateOrCreateMyBankingInformation?: Maybe<BankingInformation>;
  createMyCommercialPaper?: Maybe<CommercialPapers>;
  updateMarketValue?: Maybe<OkResponse>;
  submitCommercialPaper?: Maybe<CommercialPapers>;
  approveCommercialPaper?: Maybe<CommercialPapers>;
  declineCommercialPaper?: Maybe<CommercialPapers>;
  requestMoreInfo?: Maybe<CommercialPapers>;
  createInternalNote?: Maybe<Notes>;
  updateCompanyDocuments?: Maybe<Companies>;
  updateOrCreateMyFinancialSummary?: Maybe<FinancialSummaries>;
  calculateSell?: Maybe<CalculateSellPayload>;
  createSell?: Maybe<OkResponse>;
  calculateInvestment?: Maybe<CalculateInvestmentPayload>;
  buyInvestment?: Maybe<BuyInvestmentPayload>;
  createMasterNoteByUser?: Maybe<MasterNote>;
  archiveNotification?: Maybe<OkResponse>;
  sendPayoutByUser?: Maybe<OkResponse>;
  sendInterest?: Maybe<OkResponse>;
  submitRolloverRequest?: Maybe<RolloverRequests>;
  acceptRollover?: Maybe<RolloverResponse>;
  declineRollover?: Maybe<RolloverResponse>;
  submitTopupRequest?: Maybe<OkResponse>;
  requestCompanyUpdate?: Maybe<OkResponse>;
  requestProfileUpdate?: Maybe<OkResponse>;
  requestMasterNoteUpdate?: Maybe<OkResponse>;
  topupMyWallet?: Maybe<Transactions>;
  createSupportTickets?: Maybe<Ticket>;
  helpAndSupport?: Maybe<OkResponse>;
};


export type MutationCreateBankWithdrawalRequestArgs = {
  input?: Maybe<CreateBankWithdrawalRequestInput>;
};


export type MutationUpdateBankWithdrawalRequestArgs = {
  input?: Maybe<UpdateBankWithdrawalRequestInput>;
};


export type MutationDeleteBankWithdrawalRequestArgs = {
  input?: Maybe<DeleteBankWithdrawalRequestInput>;
};


export type MutationCreateBankingInformationArgs = {
  input?: Maybe<CreateBankingInformationInput>;
};


export type MutationUpdateBankingInformationArgs = {
  input?: Maybe<UpdateBankingInformationInput>;
};


export type MutationDeleteBankingInformationArgs = {
  input?: Maybe<DeleteBankingInformationInput>;
};


export type MutationCreateCommercialPaperArgs = {
  input?: Maybe<CreateCommercialPaperInput>;
};


export type MutationUpdateCommercialPaperArgs = {
  input?: Maybe<UpdateCommercialPaperInput>;
};


export type MutationDeleteCommercialPaperArgs = {
  input?: Maybe<DeleteCommercialPaperInput>;
};


export type MutationCreateCompanyArgs = {
  input?: Maybe<CreateCompanyInput>;
};


export type MutationUpdateCompanyArgs = {
  input?: Maybe<UpdateCompanyInput>;
};


export type MutationDeleteCompanyArgs = {
  input?: Maybe<DeleteCompanyInput>;
};


export type MutationCreateCorporateGovernanceRequirementArgs = {
  input?: Maybe<CreateCorporateGovernanceRequirementInput>;
};


export type MutationUpdateCorporateGovernanceRequirementArgs = {
  input?: Maybe<UpdateCorporateGovernanceRequirementInput>;
};


export type MutationDeleteCorporateGovernanceRequirementArgs = {
  input?: Maybe<DeleteCorporateGovernanceRequirementInput>;
};


export type MutationCreateEligibilityRequirementArgs = {
  input?: Maybe<CreateEligibilityRequirementInput>;
};


export type MutationUpdateEligibilityRequirementArgs = {
  input?: Maybe<UpdateEligibilityRequirementInput>;
};


export type MutationDeleteEligibilityRequirementArgs = {
  input?: Maybe<DeleteEligibilityRequirementInput>;
};


export type MutationCreateFinancialSummaryArgs = {
  input?: Maybe<CreateFinancialSummaryInput>;
};


export type MutationUpdateFinancialSummaryArgs = {
  input?: Maybe<UpdateFinancialSummaryInput>;
};


export type MutationDeleteFinancialSummaryArgs = {
  input?: Maybe<DeleteFinancialSummaryInput>;
};


export type MutationCreateInvestmentArgs = {
  input?: Maybe<CreateInvestmentInput>;
};


export type MutationUpdateInvestmentArgs = {
  input?: Maybe<UpdateInvestmentInput>;
};


export type MutationDeleteInvestmentArgs = {
  input?: Maybe<DeleteInvestmentInput>;
};


export type MutationUpdateJamiipesaArgs = {
  input?: Maybe<UpdateJamiipesaInput>;
};


export type MutationCreateMarketValueLogArgs = {
  input?: Maybe<CreateMarketValueLogInput>;
};


export type MutationUpdateMarketValueLogArgs = {
  input?: Maybe<UpdateMarketValueLogInput>;
};


export type MutationDeleteMarketValueLogArgs = {
  input?: Maybe<DeleteMarketValueLogInput>;
};


export type MutationCreateMasterNoteArgs = {
  input?: Maybe<CreateMasterNoteInput>;
};


export type MutationUpdateMasterNoteArgs = {
  input?: Maybe<UpdateMasterNoteInput>;
};


export type MutationDeleteMasterNoteArgs = {
  input?: Maybe<DeleteMasterNoteInput>;
};


export type MutationCreateNoteArgs = {
  input?: Maybe<CreateNoteInput>;
};


export type MutationUpdateNoteArgs = {
  input?: Maybe<UpdateNoteInput>;
};


export type MutationDeleteNoteArgs = {
  input?: Maybe<DeleteNoteInput>;
};


export type MutationCreateNotificationArgs = {
  input?: Maybe<CreateNotificationInput>;
};


export type MutationUpdateNotificationArgs = {
  input?: Maybe<UpdateNotificationInput>;
};


export type MutationDeleteNotificationArgs = {
  input?: Maybe<DeleteNotificationInput>;
};


export type MutationCreatePayoutRequestArgs = {
  input?: Maybe<CreatePayoutRequestInput>;
};


export type MutationUpdatePayoutRequestArgs = {
  input?: Maybe<UpdatePayoutRequestInput>;
};


export type MutationDeletePayoutRequestArgs = {
  input?: Maybe<DeletePayoutRequestInput>;
};


export type MutationCreatePurchaseRequestArgs = {
  input?: Maybe<CreatePurchaseRequestInput>;
};


export type MutationUpdatePurchaseRequestArgs = {
  input?: Maybe<UpdatePurchaseRequestInput>;
};


export type MutationDeletePurchaseRequestArgs = {
  input?: Maybe<DeletePurchaseRequestInput>;
};


export type MutationCreateRolloverRequestArgs = {
  input?: Maybe<CreateRolloverRequestInput>;
};


export type MutationUpdateRolloverRequestArgs = {
  input?: Maybe<UpdateRolloverRequestInput>;
};


export type MutationDeleteRolloverRequestArgs = {
  input?: Maybe<DeleteRolloverRequestInput>;
};


export type MutationCreateRolloverResponseArgs = {
  input?: Maybe<CreateRolloverResponseInput>;
};


export type MutationUpdateRolloverResponseArgs = {
  input?: Maybe<UpdateRolloverResponseInput>;
};


export type MutationDeleteRolloverResponseArgs = {
  input?: Maybe<DeleteRolloverResponseInput>;
};


export type MutationCreateSellRequestArgs = {
  input?: Maybe<CreateSellRequestInput>;
};


export type MutationUpdateSellRequestArgs = {
  input?: Maybe<UpdateSellRequestInput>;
};


export type MutationDeleteSellRequestArgs = {
  input?: Maybe<DeleteSellRequestInput>;
};


export type MutationCreateTopupRequestArgs = {
  input?: Maybe<CreateTopupRequestInput>;
};


export type MutationUpdateTopupRequestArgs = {
  input?: Maybe<UpdateTopupRequestInput>;
};


export type MutationDeleteTopupRequestArgs = {
  input?: Maybe<DeleteTopupRequestInput>;
};


export type MutationCreateTransactionArgs = {
  input?: Maybe<CreateTransactionInput>;
};


export type MutationUpdateTransactionArgs = {
  input?: Maybe<UpdateTransactionInput>;
};


export type MutationDeleteTransactionArgs = {
  input?: Maybe<DeleteTransactionInput>;
};


export type MutationCreateUpdateRequestArgs = {
  input?: Maybe<CreateUpdateRequestInput>;
};


export type MutationUpdateUpdateRequestArgs = {
  input?: Maybe<UpdateUpdateRequestInput>;
};


export type MutationDeleteUpdateRequestArgs = {
  input?: Maybe<DeleteUpdateRequestInput>;
};


export type MutationCreateWalletArgs = {
  input?: Maybe<CreateWalletInput>;
};


export type MutationUpdateWalletArgs = {
  input?: Maybe<UpdateWalletInput>;
};


export type MutationDeleteWalletArgs = {
  input?: Maybe<DeleteWalletInput>;
};


export type MutationUpdateWelcomeSlideArgs = {
  input?: Maybe<UpdateWelcomeSlideInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationChangeAppUseArgs = {
  useType: AppUse;
};


export type MutationChangeCurrencyArgs = {
  input?: Maybe<ChangeCurrencyInput>;
};


export type MutationOnboardingArgs = {
  input?: Maybe<OnboardingInput>;
  companyInformation?: Maybe<OnboardingCompanyInput>;
};


export type MutationInvestorOnboardingArgs = {
  input?: Maybe<InvestorOnboardingInput>;
};


export type MutationChangeMyPasswordArgs = {
  password: Scalars['String'];
};


export type MutationUpdateRegulatoryProfileArgs = {
  input?: Maybe<UpdateRegulatoryProfileInput>;
};


export type MutationSubmitBankWithdrawRequestArgs = {
  input?: Maybe<SubmitBankWithdrawRequestInput>;
};


export type MutationUpdateOrCreateMyBankingInformationArgs = {
  input?: Maybe<UpdateOrCreateMyBankingInput>;
};


export type MutationCreateMyCommercialPaperArgs = {
  input?: Maybe<CreateMyCommercialPaperInput>;
};


export type MutationUpdateMarketValueArgs = {
  input?: Maybe<MarketValueInput>;
};


export type MutationSubmitCommercialPaperArgs = {
  input?: Maybe<SubmitCommercialPaperInput>;
};


export type MutationApproveCommercialPaperArgs = {
  input?: Maybe<ApproveCommercialPaperInput>;
};


export type MutationDeclineCommercialPaperArgs = {
  input?: Maybe<DeclineCommercialPaperInput>;
};


export type MutationRequestMoreInfoArgs = {
  input?: Maybe<RequestMoreInfoInput>;
};


export type MutationCreateInternalNoteArgs = {
  input?: Maybe<CreateInternalNoteInput>;
};


export type MutationUpdateCompanyDocumentsArgs = {
  input?: Maybe<UpdateCompanyDocumentsInput>;
};


export type MutationUpdateOrCreateMyFinancialSummaryArgs = {
  input?: Maybe<UpdateOrCreateMyFinancialSummaryInput>;
};


export type MutationCalculateSellArgs = {
  input?: Maybe<CalculateSellInput>;
};


export type MutationCreateSellArgs = {
  input?: Maybe<CreateSellInput>;
};


export type MutationCalculateInvestmentArgs = {
  input?: Maybe<CalculateInvestmentInput>;
};


export type MutationBuyInvestmentArgs = {
  input?: Maybe<BuyInvestmentInput>;
};


export type MutationCreateMasterNoteByUserArgs = {
  input?: Maybe<CreateMasterNoteByUserInput>;
};


export type MutationArchiveNotificationArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationSendPayoutByUserArgs = {
  input?: Maybe<SendPayoutByUserInput>;
};


export type MutationSendInterestArgs = {
  input?: Maybe<SendInterestInput>;
};


export type MutationSubmitRolloverRequestArgs = {
  input?: Maybe<SubmitRolloverRequestInput>;
};


export type MutationAcceptRolloverArgs = {
  input?: Maybe<CreateMyRolloverResponseInput>;
};


export type MutationDeclineRolloverArgs = {
  input?: Maybe<CreateMyRolloverResponseInput>;
};


export type MutationSubmitTopupRequestArgs = {
  input?: Maybe<SubmitTopupRequestInput>;
};


export type MutationRequestCompanyUpdateArgs = {
  input?: Maybe<RequestCompanyUpdateInput>;
};


export type MutationRequestProfileUpdateArgs = {
  input?: Maybe<RequestProfileUpdateInput>;
};


export type MutationRequestMasterNoteUpdateArgs = {
  input?: Maybe<RequestMasterNoteUpdateInput>;
  type?: Maybe<Scalars['String']>;
};


export type MutationTopupMyWalletArgs = {
  input?: Maybe<TopupMyWalletInput>;
};


export type MutationCreateSupportTicketsArgs = {
  input?: Maybe<SupportTicketInput>;
};


export type MutationHelpAndSupportArgs = {
  input?: Maybe<HelpAndSupportInput>;
};







export type CommercialPaperFragment = (
  { __typename?: 'CommercialPapers' }
  & Pick<CommercialPapers, 'id' | 'submittedAt' | 'title' | 'interestFrequency' | 'purchaseFee' | 'shortHoldFee' | 'shortHoldDescription' | 'assetType' | 'fundManager' | 'followup' | 'lockDown' | 'purchasePrice' | 'managementFee' | 'interestFrequencyDescription' | 'type' | 'numberOfPaidInterest' | 'potentialRisks' | 'masterNoteMarketValue' | 'noteMarketValue' | 'payoutDate' | 'nextInterestPayment' | 'sellFee' | 'shortHoldFeeDuration' | 'description' | 'amount' | 'amountNeeded' | 'interestRate' | 'minInvestment' | 'serviceInterestRate' | 'status' | 'currency' | 'industryType' | 'proposedDateOfIssue' | 'purposeOfIssue' | 'commercialPaperType' | 'currentStep'>
  & { company?: Maybe<(
    { __typename?: 'Companies' }
    & CompanyFragment
  )>, masterNote?: Maybe<(
    { __typename?: 'MasterNote' }
    & MasterNoteFragment
  )>, memorandum?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>>, notes?: Maybe<Array<Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'id' | 'created_at' | 'message' | 'noteType'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'firstName' | 'lastName'>
      & { profilePicture?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )> }
  )>>>, investments?: Maybe<Array<Maybe<(
    { __typename?: 'Investments' }
    & Pick<Investments, 'amount' | 'status'>
  )>>> }
);

export type CompanyFragment = (
  { __typename?: 'Companies' }
  & Pick<Companies, 'id' | 'name' | 'companyType' | 'industryType' | 'activeSince' | 'briefDescription' | 'platformUseReason' | 'registrationNumber' | 'registeredAt' | 'countryOfRegistration' | 'vatNumber' | 'taxNumber' | 'formattedAddress' | 'netWorth' | 'grossIncome' | 'totalDebt'>
  & { logo?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>, bankingInformation?: Maybe<(
    { __typename?: 'BankingInformation' }
    & Pick<BankingInformation, 'id' | 'bankName' | 'accountHolder' | 'typeOfAccount' | 'accountNumber'>
  )>, financialSummary?: Maybe<(
    { __typename?: 'FinancialSummaries' }
    & FinancialSummaryFragment
  )>, informationMemorandum?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, certificateOfIncorporation?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, memorandumAndArticlesOfAssociation?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, boardOfDirectorsApproval?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, reportingAccountsReport?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, financialStatements?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, companyTAXCertificate?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, relevantCompanyDocuments?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, companyConsent?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>> }
);

export type CorporateGovernanceRequirementFragment = (
  { __typename?: 'CorporateGovernanceRequirements' }
  & Pick<CorporateGovernanceRequirements, 'id' | 'reasonsForNonCompliance' | 'strategicGuidance' | 'relevantCommittees' | 'availabilityAndReliabilityOfFinancialRecords' | 'balanceOfExecutiveAndNonExecutiveDirectors' | 'directorCompliance' | 'reasonsForNonComplianceComment' | 'strategicGuidanceComment' | 'relevantCommitteesComment' | 'committeeSpecificationsBoardComment' | 'committeeSpecificationsBoard' | 'balanceOfExecutiveAndNonExecutiveDirectorsComment' | 'directorComplianceComment' | 'rolesAndResponsibilities' | 'rolesAndResponsibilitiesComment' | 'chairpersonCompliance' | 'chairpersonComplianceComment' | 'nominatingCommittee' | 'nominatingCommitteeComment' | 'auditCommittee' | 'auditCommitteeComment'>
);

export type EligibilityRequirementFragment = (
  { __typename?: 'EligibilityRequirement' }
  & Pick<EligibilityRequirement, 'id' | 'created_at' | 'updated_at' | 'incorporationWithLimitedLiability' | 'incorporationWithLimitedLiabilityComment' | 'shareCapitalAndNetAssetsOfIssuer' | 'shareCapitalAndNetAssetsOfIssuerComment' | 'listingAndTransferabilityOfSecurities' | 'listingAndTransferabilityOfSecuritiesComment' | 'availabilityAndReliabilityOfFinancialRecords' | 'availabilityAndReliabilityOfFinancialRecordsComment' | 'directorsAndSeniorManagement' | 'directorsAndSeniorManagementComment' | 'certificateOfComfort' | 'certificateOfComfortComment' | 'profitableHistoricTrackRecordAndFutureProspects' | 'profitableHistoricTrackRecordAndFutureProspectsComment' | 'guaranteeRequirements' | 'guaranteeRequirementsComment' | 'debtRatio' | 'debtRatioComment' | 'sizeIssue' | 'sizeIssueComment' | 'minimumSize' | 'minimumSizeComment' | 'renewalDate' | 'renewalDateComment'>
);

export type FinancialSummaryFragment = (
  { __typename?: 'FinancialSummaries' }
  & Pick<FinancialSummaries, 'id' | 'netWorth' | 'totalDeptOutstanding' | 'totalDeptOutstandingOther' | 'grossIncome' | 'grossProfit' | 'operatingProfit' | 'netProfit' | 'detailsOfDefaultCP' | 'detailsOfDefaultDelay'>
);

export type MasterNoteFragment = (
  { __typename?: 'MasterNote' }
  & Pick<MasterNote, 'id' | 'title' | 'type' | 'interestFrequency' | 'interestRate' | 'currentStep' | 'currency' | 'maturityDate' | 'description' | 'potentialRisks' | 'marketValue' | 'status'>
  & { memorandum?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>> }
);

export type TransactionFragment = (
  { __typename?: 'Transactions' }
  & Pick<Transactions, 'id' | 'created_at' | 'updated_at' | 'payoutDate' | 'transactionNumber' | 'amount' | 'status' | 'description' | 'mpesaNumber' | 'merchantRequestID' | 'checkoutRequestID' | 'mpesaReceiptNumber' | 'transactionType'>
  & { invoice?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )> }
);

export type UploadFileFragment = (
  { __typename?: 'UploadFile' }
  & Pick<UploadFile, 'id' | 'name' | 'alternativeText' | 'caption' | 'width' | 'height' | 'formats' | 'hash' | 'ext' | 'mime' | 'size' | 'url' | 'previewUrl' | 'provider' | 'provider_metadata'>
);

export type UserFragment = (
  { __typename?: 'UsersPermissionsUser' }
  & Pick<UsersPermissionsUser, 'id' | 'email' | 'confirmed' | 'blocked' | 'phoneNumber' | 'firstName' | 'lastName' | 'type' | 'dateOfBirth' | 'idNumber' | 'mobileNumber' | 'officeNumber' | 'currency' | 'taxNumber' | 'citizenship' | 'residentialAddress' | 'reasonForInvesting' | 'agreedToInvestTerms' | 'onboardingStatus' | 'investorOnboardingSteps' | 'smileVerificationStatus'>
  & { role?: Maybe<(
    { __typename?: 'UsersPermissionsRole' }
    & Pick<UsersPermissionsRole, 'type'>
  )>, profilePicture?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, nationalId?: Maybe<Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>>, selfie?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, company?: Maybe<(
    { __typename?: 'Companies' }
    & CompanyFragment
  )>, certifiedId?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )> }
);

export type SubmitBankWithdrawRequestMutationVariables = Exact<{
  input?: Maybe<SubmitBankWithdrawRequestInput>;
}>;


export type SubmitBankWithdrawRequestMutation = (
  { __typename?: 'Mutation' }
  & { submitBankWithdrawRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CalculateInvestmentMutationVariables = Exact<{
  input?: Maybe<CalculateInvestmentInput>;
}>;


export type CalculateInvestmentMutation = (
  { __typename?: 'Mutation' }
  & { calculateInvestment?: Maybe<(
    { __typename?: 'CalculateInvestmentPayload' }
    & Pick<CalculateInvestmentPayload, 'interestRate' | 'investmentTerm' | 'investmentDate' | 'dueDate' | 'purchasePrice' | 'investorTotalReturn'>
  )> }
);

export type ChangeAppUseMutationVariables = Exact<{
  useType: AppUse;
}>;


export type ChangeAppUseMutation = (
  { __typename?: 'Mutation' }
  & { changeAppUse?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type ChangeCurrencyMutationVariables = Exact<{
  input?: Maybe<ChangeCurrencyInput>;
}>;


export type ChangeCurrencyMutation = (
  { __typename?: 'Mutation' }
  & { changeCurrency?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'currency'>
  )> }
);

export type ChangeMyPasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type ChangeMyPasswordMutation = (
  { __typename?: 'Mutation' }
  & { changeMyPassword?: Maybe<(
    { __typename?: 'ChangeMyPasswordPayload' }
    & Pick<ChangeMyPasswordPayload, 'ok'>
  )> }
);

export type ApproveCommercialPaperMutationVariables = Exact<{
  input?: Maybe<ApproveCommercialPaperInput>;
}>;


export type ApproveCommercialPaperMutation = (
  { __typename?: 'Mutation' }
  & { approveCommercialPaper?: Maybe<(
    { __typename?: 'CommercialPapers' }
    & CommercialPaperFragment
  )> }
);

export type DeclineCommercialPaperMutationVariables = Exact<{
  input?: Maybe<DeclineCommercialPaperInput>;
}>;


export type DeclineCommercialPaperMutation = (
  { __typename?: 'Mutation' }
  & { declineCommercialPaper?: Maybe<(
    { __typename?: 'CommercialPapers' }
    & CommercialPaperFragment
  )> }
);

export type RequestMoreInfoMutationVariables = Exact<{
  input?: Maybe<RequestMoreInfoInput>;
}>;


export type RequestMoreInfoMutation = (
  { __typename?: 'Mutation' }
  & { requestMoreInfo?: Maybe<(
    { __typename?: 'CommercialPapers' }
    & CommercialPaperFragment
  )> }
);

export type CreateInternalNoteMutationVariables = Exact<{
  input?: Maybe<CreateInternalNoteInput>;
}>;


export type CreateInternalNoteMutation = (
  { __typename?: 'Mutation' }
  & { createInternalNote?: Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'id' | 'message'>
  )> }
);

export type UpdateMarketValueMutationVariables = Exact<{
  input?: Maybe<MarketValueInput>;
}>;


export type UpdateMarketValueMutation = (
  { __typename?: 'Mutation' }
  & { updateMarketValue?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateMyCommercialPaperMutationVariables = Exact<{
  input?: Maybe<CreateMyCommercialPaperInput>;
}>;


export type CreateMyCommercialPaperMutation = (
  { __typename?: 'Mutation' }
  & { createMyCommercialPaper?: Maybe<(
    { __typename?: 'CommercialPapers' }
    & CommercialPaperFragment
  )> }
);

export type CreateSupportTicketMutationVariables = Exact<{
  input?: Maybe<SupportTicketInput>;
}>;


export type CreateSupportTicketMutation = (
  { __typename?: 'Mutation' }
  & { createSupportTickets?: Maybe<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id'>
  )> }
);

export type HelpAndSupportMutationVariables = Exact<{
  input?: Maybe<HelpAndSupportInput>;
}>;


export type HelpAndSupportMutation = (
  { __typename?: 'Mutation' }
  & { helpAndSupport?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateUserMutationVariables = Exact<{
  input?: Maybe<CreateUserInput>;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'createUserPayload' }
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'username' | 'email' | 'confirmed' | 'blocked'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
      )> }
    )> }
  )> }
);

export type BuyInvestmentMutationVariables = Exact<{
  input?: Maybe<BuyInvestmentInput>;
}>;


export type BuyInvestmentMutation = (
  { __typename?: 'Mutation' }
  & { buyInvestment?: Maybe<(
    { __typename?: 'BuyInvestmentPayload' }
    & Pick<BuyInvestmentPayload, 'id' | 'amount' | 'company' | 'merchantRequestID'>
  )> }
);

export type CalculateSellMutationVariables = Exact<{
  input?: Maybe<CalculateSellInput>;
}>;


export type CalculateSellMutation = (
  { __typename?: 'Mutation' }
  & { calculateSell?: Maybe<(
    { __typename?: 'CalculateSellPayload' }
    & Pick<CalculateSellPayload, 'customerAmount' | 'deadline' | 'sellAmount' | 'shortHoldFeeAmount' | 'sellFeeAmount'>
  )> }
);

export type CreateSellMutationVariables = Exact<{
  input?: Maybe<CreateSellInput>;
}>;


export type CreateSellMutation = (
  { __typename?: 'Mutation' }
  & { createSell?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type InvestorOnboardingMutationVariables = Exact<{
  input?: Maybe<InvestorOnboardingInput>;
}>;


export type InvestorOnboardingMutation = (
  { __typename?: 'Mutation' }
  & { investorOnboarding?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id'>
  )> }
);

export type CreateMasterNoteByUserMutationVariables = Exact<{
  input?: Maybe<CreateMasterNoteByUserInput>;
}>;


export type CreateMasterNoteByUserMutation = (
  { __typename?: 'Mutation' }
  & { createMasterNoteByUser?: Maybe<(
    { __typename?: 'MasterNote' }
    & MasterNoteFragment
  )> }
);

export type ArchiveNotificationMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type ArchiveNotificationMutation = (
  { __typename?: 'Mutation' }
  & { archiveNotification?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type OnboardingMutationVariables = Exact<{
  input?: Maybe<OnboardingInput>;
  companyInformation?: Maybe<OnboardingCompanyInput>;
}>;


export type OnboardingMutation = (
  { __typename?: 'Mutation' }
  & { onboarding?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type SendPayoutByUserMutationVariables = Exact<{
  input?: Maybe<SendPayoutByUserInput>;
}>;


export type SendPayoutByUserMutation = (
  { __typename?: 'Mutation' }
  & { sendPayoutByUser?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type SendInterestMutationVariables = Exact<{
  input?: Maybe<SendInterestInput>;
}>;


export type SendInterestMutation = (
  { __typename?: 'Mutation' }
  & { sendInterest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type RequestCompanyUpdateMutationVariables = Exact<{
  input?: Maybe<RequestCompanyUpdateInput>;
}>;


export type RequestCompanyUpdateMutation = (
  { __typename?: 'Mutation' }
  & { requestCompanyUpdate?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type RequestMasterNoteUpdateMutationVariables = Exact<{
  input?: Maybe<RequestMasterNoteUpdateInput>;
  type?: Maybe<Scalars['String']>;
}>;


export type RequestMasterNoteUpdateMutation = (
  { __typename?: 'Mutation' }
  & { requestMasterNoteUpdate?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type RequestProfileUpdateMutationVariables = Exact<{
  input?: Maybe<RequestProfileUpdateInput>;
}>;


export type RequestProfileUpdateMutation = (
  { __typename?: 'Mutation' }
  & { requestProfileUpdate?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type SubmitRolloverRequestMutationVariables = Exact<{
  input?: Maybe<SubmitRolloverRequestInput>;
}>;


export type SubmitRolloverRequestMutation = (
  { __typename?: 'Mutation' }
  & { submitRolloverRequest?: Maybe<(
    { __typename?: 'RolloverRequests' }
    & Pick<RolloverRequests, 'id' | 'reason'>
  )> }
);

export type AcceptRolloverMutationVariables = Exact<{
  input?: Maybe<CreateMyRolloverResponseInput>;
}>;


export type AcceptRolloverMutation = (
  { __typename?: 'Mutation' }
  & { acceptRollover?: Maybe<(
    { __typename?: 'RolloverResponse' }
    & Pick<RolloverResponse, 'id' | 'status'>
  )> }
);

export type DeclineRolloverMutationVariables = Exact<{
  input?: Maybe<CreateMyRolloverResponseInput>;
}>;


export type DeclineRolloverMutation = (
  { __typename?: 'Mutation' }
  & { declineRollover?: Maybe<(
    { __typename?: 'RolloverResponse' }
    & Pick<RolloverResponse, 'id' | 'status'>
  )> }
);

export type SubmitCommercialPaperMutationVariables = Exact<{
  input?: Maybe<SubmitCommercialPaperInput>;
}>;


export type SubmitCommercialPaperMutation = (
  { __typename?: 'Mutation' }
  & { submitCommercialPaper?: Maybe<(
    { __typename?: 'CommercialPapers' }
    & CommercialPaperFragment
  )> }
);

export type UpdateCompanyDocumentsMutationVariables = Exact<{
  input?: Maybe<UpdateCompanyDocumentsInput>;
}>;


export type UpdateCompanyDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyDocuments?: Maybe<(
    { __typename?: 'Companies' }
    & CompanyFragment
  )> }
);

export type UpdateOfcreateBankingDetailsMutationVariables = Exact<{
  input?: Maybe<UpdateOrCreateMyBankingInput>;
}>;


export type UpdateOfcreateBankingDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateOrCreateMyBankingInformation?: Maybe<(
    { __typename?: 'BankingInformation' }
    & Pick<BankingInformation, 'id' | 'bankName' | 'accountHolder' | 'typeOfAccount' | 'accountNumber'>
  )> }
);

export type UpdateOrCreateMyFinancialSummaryMutationVariables = Exact<{
  input?: Maybe<UpdateOrCreateMyFinancialSummaryInput>;
}>;


export type UpdateOrCreateMyFinancialSummaryMutation = (
  { __typename?: 'Mutation' }
  & { updateOrCreateMyFinancialSummary?: Maybe<(
    { __typename?: 'FinancialSummaries' }
    & FinancialSummaryFragment
  )> }
);

export type UpdateRegulatoryProfileMutationVariables = Exact<{
  input?: Maybe<UpdateRegulatoryProfileInput>;
}>;


export type UpdateRegulatoryProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateRegulatoryProfile?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type TopupMyWalletMutationVariables = Exact<{
  input?: Maybe<TopupMyWalletInput>;
}>;


export type TopupMyWalletMutation = (
  { __typename?: 'Mutation' }
  & { topupMyWallet?: Maybe<(
    { __typename?: 'Transactions' }
    & Pick<Transactions, 'id' | 'merchantRequestID'>
  )> }
);

export type SubmitTopupRequestMutationVariables = Exact<{
  input?: Maybe<SubmitTopupRequestInput>;
}>;


export type SubmitTopupRequestMutation = (
  { __typename?: 'Mutation' }
  & { submitTopupRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type GetCommercialPapersQueryVariables = Exact<{
  filters?: Maybe<CpFilter>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<Cp_Sort_By>;
  limit?: Maybe<Scalars['Int']>;
  showClosed?: Maybe<Scalars['Boolean']>;
}>;


export type GetCommercialPapersQuery = (
  { __typename?: 'Query' }
  & { getCommercialPapers?: Maybe<(
    { __typename?: 'GetCommercialPapersPayload' }
    & Pick<GetCommercialPapersPayload, 'pages' | 'page'>
    & { commercialPapers?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialPapers' }
      & CommercialPaperFragment
    )>>> }
  )> }
);

export type GetCommercialPapersCountQueryVariables = Exact<{
  filters?: Maybe<CpFilter>;
}>;


export type GetCommercialPapersCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getCommercialPapersCount'>
);

export type GetCommercialPaperByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCommercialPaperByIdQuery = (
  { __typename?: 'Query' }
  & { getCommercialPaperById?: Maybe<(
    { __typename?: 'CommercialPapers' }
    & Pick<CommercialPapers, 'id' | 'submittedAt' | 'amount' | 'amountNeeded' | 'noteMarketValue' | 'masterNoteMarketValue' | 'purchasePrice' | 'lockDown' | 'title' | 'sellFee' | 'shortHoldFeeDuration' | 'interestFrequency' | 'purchaseFee' | 'shortHoldFee' | 'shortHoldDescription' | 'managementFee' | 'interestFrequencyDescription' | 'type' | 'numberOfPaidInterest' | 'potentialRisks' | 'description' | 'payoutDate' | 'interestRate' | 'status' | 'industryType' | 'proposedDateOfIssue' | 'conditions' | 'purposeOfIssue' | 'commercialPaperType' | 'maturesAt' | 'investmentTermType' | 'investmentTerm' | 'lengthOfCP'>
    & { company?: Maybe<(
      { __typename?: 'Companies' }
      & CompanyFragment
    )>, certOfIncorporation?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, memorandum?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )>>>, directorsApproval?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, accountsReport?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, financialStatements?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, taxCertificate?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, companyConsent?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, relevantDocuments?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>>>, eligibilityRequirement?: Maybe<(
      { __typename?: 'EligibilityRequirement' }
      & EligibilityRequirementFragment
    )>, corporateGovernanceRequirement?: Maybe<(
      { __typename?: 'CorporateGovernanceRequirements' }
      & CorporateGovernanceRequirementFragment
    )>, notes?: Maybe<Array<Maybe<(
      { __typename?: 'Notes' }
      & Pick<Notes, 'id' | 'message' | 'noteType' | 'created_at'>
      & { user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'firstName'>
        & { profilePicture?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )> }
    )>>> }
  )> }
);

export type DownloadCommercialPaperSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadCommercialPaperSummaryQuery = (
  { __typename?: 'Query' }
  & { downloadCommercialPaperSummary?: Maybe<(
    { __typename?: 'DownloadCommercialPaperSummaryPayload' }
    & Pick<DownloadCommercialPaperSummaryPayload, 'url'>
  )> }
);

export type CountMyActiveCommercialPapersQueryVariables = Exact<{
  currency?: Maybe<Scalars['String']>;
}>;


export type CountMyActiveCommercialPapersQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'countMyActivePapers'>
);

export type GetAllSupportTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSupportTopicsQuery = (
  { __typename?: 'Query' }
  & { getAllSupportTopics?: Maybe<Array<Maybe<(
    { __typename?: 'SupportTopic' }
    & Pick<SupportTopic, 'id' | 'displayName'>
  )>>> }
);

export type GetAvailableCommercialPapersQueryVariables = Exact<{
  input?: Maybe<AvailableCommercialPapersInput>;
}>;


export type GetAvailableCommercialPapersQuery = (
  { __typename?: 'Query' }
  & { getAvailableCommercialPapers?: Maybe<(
    { __typename?: 'AvailableCommercialPapersPayload' }
    & Pick<AvailableCommercialPapersPayload, 'page' | 'pages'>
    & { commercialPapers?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialPapers' }
      & Pick<CommercialPapers, 'lengthOfCP'>
      & CommercialPaperFragment
    )>>> }
  )> }
);

export type GetCommercialPaperForInvestorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCommercialPaperForInvestorQuery = (
  { __typename?: 'Query' }
  & { getCommercialPaperForInvestor?: Maybe<(
    { __typename?: 'CommercialPaperForInvestorPayload' }
    & Pick<CommercialPaperForInvestorPayload, 'isAnInvestorOfCP' | 'amountInvested'>
    & { commercialPaper?: Maybe<(
      { __typename?: 'CommercialPapers' }
      & Pick<CommercialPapers, 'lengthOfCP'>
      & { rolloverRequests?: Maybe<Array<Maybe<(
        { __typename?: 'RolloverRequests' }
        & Pick<RolloverRequests, 'proposedMaturityDate' | 'reason'>
      )>>> }
      & CommercialPaperFragment
    )> }
  )> }
);

export type GetManagerMetricsQueryVariables = Exact<{
  filters?: Maybe<GetManagerMetricsFilters>;
  currency: Scalars['String'];
}>;


export type GetManagerMetricsQuery = (
  { __typename?: 'Query' }
  & { getManagerMetrics?: Maybe<(
    { __typename?: 'ManagerMetricsPayload' }
    & { investors?: Maybe<Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'created_at'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'type'>
      )> }
    )>>>, transactions?: Maybe<Array<Maybe<(
      { __typename?: 'Transactions' }
      & TransactionFragment
    )>>>, closedNotes?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialPapers' }
      & CommercialPaperFragment
    )>>>, createdNotes?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialPapers' }
      & CommercialPaperFragment
    )>>>, fundingNotes?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialPapers' }
      & CommercialPaperFragment
    )>>>, fundedNotes?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialPapers' }
      & CommercialPaperFragment
    )>>> }
  )> }
);

export type GetMyBankingInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyBankingInformationQuery = (
  { __typename?: 'Query' }
  & { getMyBankingInformation?: Maybe<(
    { __typename?: 'BankingInformation' }
    & Pick<BankingInformation, 'id' | 'bankName' | 'accountHolder' | 'typeOfAccount' | 'accountNumber'>
  )> }
);

export type GetMyFinancialSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFinancialSummaryQuery = (
  { __typename?: 'Query' }
  & { getMyFinancialSummary?: Maybe<(
    { __typename?: 'FinancialSummaries' }
    & FinancialSummaryFragment
  )> }
);

export type GetMyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProfileQuery = (
  { __typename?: 'Query' }
  & { getMyProfile?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type MyWalletBalanceQueryVariables = Exact<{
  currency?: Maybe<Scalars['String']>;
}>;


export type MyWalletBalanceQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'myWalletBalance'>
);

export type FindNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications?: Maybe<Array<Maybe<(
    { __typename?: 'Notifications' }
    & Pick<Notifications, 'id' | 'message' | 'isRead' | 'title' | 'category'>
  )>>> }
);

export type GetSiteDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteDataQuery = (
  { __typename?: 'Query' }
  & { jamiipesa?: Maybe<(
    { __typename?: 'Jamiipesa' }
    & Pick<Jamiipesa, 'privacyPolicy' | 'termsAndConditions'>
  )> }
);

export type GetInvestmentsQueryVariables = Exact<{
  filters?: Maybe<InvestmentFilter>;
  currency: Scalars['String'];
}>;


export type GetInvestmentsQuery = (
  { __typename?: 'Query' }
  & { getInvestments?: Maybe<(
    { __typename?: 'GetInvestmentsPayload' }
    & { investments?: Maybe<Array<Maybe<(
      { __typename?: 'Investments' }
      & Pick<Investments, 'id' | 'amount' | 'totalReturn' | 'lastPayInterestDate' | 'approvedAt' | 'status'>
      & { commercialPaper?: Maybe<(
        { __typename?: 'CommercialPapers' }
        & Pick<CommercialPapers, 'id' | 'title' | 'interestFrequency' | 'proposedDateOfIssue' | 'nextInterestPayment' | 'serviceInterestRate' | 'type' | 'payoutDate'>
        & { masterNote?: Maybe<(
          { __typename?: 'MasterNote' }
          & Pick<MasterNote, 'title'>
        )> }
      )>, company?: Maybe<(
        { __typename?: 'Companies' }
        & Pick<Companies, 'name' | 'industryType'>
        & { logo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )> }
    )>>> }
  )> }
);

export type MyTotalInvestedAmountByCpQueryVariables = Exact<{
  commercialPaperId: Scalars['ID'];
}>;


export type MyTotalInvestedAmountByCpQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'myTotalInvestedAmountByCP'>
);

export type GetAcceptedSellRequestsQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type GetAcceptedSellRequestsQuery = (
  { __typename?: 'Query' }
  & { getAcceptedSellRequests?: Maybe<(
    { __typename?: 'GetAcceptedSellRequestsResponse' }
    & { sellRequestLosses?: Maybe<Array<Maybe<(
      { __typename?: 'SellRequestLoss' }
      & Pick<SellRequestLoss, 'loss' | 'time'>
    )>>> }
  )> }
);

export type GetInvestmentsByNoteIdQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  noteId: Scalars['ID'];
}>;


export type GetInvestmentsByNoteIdQuery = (
  { __typename?: 'Query' }
  & { getInvestmentsByNoteId?: Maybe<(
    { __typename?: 'GetInvestmentsByNoteIdPayload' }
    & Pick<GetInvestmentsByNoteIdPayload, 'pages' | 'page'>
    & { investments?: Maybe<Array<Maybe<(
      { __typename?: 'Investments' }
      & Pick<Investments, 'amount'>
      & { user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'firstName' | 'lastName'>
      )> }
    )>>> }
  )> }
);

export type GetMarketValueLogQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  masterNoteId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMarketValueLogQuery = (
  { __typename?: 'Query' }
  & { getMarketValueLog?: Maybe<(
    { __typename?: 'MarketValueLogPayload' }
    & Pick<MarketValueLogPayload, 'page' | 'pages'>
    & { marketValueLog?: Maybe<Array<Maybe<(
      { __typename?: 'MarketValueLog' }
      & Pick<MarketValueLog, 'approvedAt' | 'value'>
    )>>> }
  )> }
);

export type GetMyMasterNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMyMasterNoteByIdQuery = (
  { __typename?: 'Query' }
  & { getMyMasterNoteById?: Maybe<(
    { __typename?: 'MasterNote' }
    & MasterNoteFragment
  )> }
);

export type GetAllMyMasterNotesQueryVariables = Exact<{
  filters?: Maybe<MasterNoteFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
}>;


export type GetAllMyMasterNotesQuery = (
  { __typename?: 'Query' }
  & { getAllMyMasterNotes?: Maybe<(
    { __typename?: 'GetAllMyMasterNotesPayload' }
    & Pick<GetAllMyMasterNotesPayload, 'page' | 'pages' | 'count'>
    & { masterNotes?: Maybe<Array<Maybe<(
      { __typename?: 'MasterNote' }
      & MasterNoteFragment
    )>>> }
  )> }
);

export type GetMyNotificationsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
}>;


export type GetMyNotificationsQuery = (
  { __typename?: 'Query' }
  & { getMyNotifications?: Maybe<Array<Maybe<(
    { __typename?: 'Notifications' }
    & Pick<Notifications, 'id' | 'title' | 'message' | 'category' | 'additionalInformation'>
  )>>> }
);

export type GetNewRolloverRequestsQueryVariables = Exact<{
  commercialPaperId: Scalars['ID'];
}>;


export type GetNewRolloverRequestsQuery = (
  { __typename?: 'Query' }
  & { getNewRolloverRequests?: Maybe<Array<Maybe<(
    { __typename?: 'RolloverRequests' }
    & Pick<RolloverRequests, 'id' | 'proposedMaturityDate' | 'reason'>
  )>>> }
);

export type GetTransactionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTransactionByIdQuery = (
  { __typename?: 'Query' }
  & { getTransactionById?: Maybe<(
    { __typename?: 'Transactions' }
    & TransactionFragment
  )> }
);

export type GetMyTransactionsQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type GetMyTransactionsQuery = (
  { __typename?: 'Query' }
  & { getMyTransactions?: Maybe<Array<Maybe<(
    { __typename?: 'Transactions' }
    & { commercialPaper?: Maybe<(
      { __typename?: 'CommercialPapers' }
      & Pick<CommercialPapers, 'title'>
      & { company?: Maybe<(
        { __typename?: 'Companies' }
        & Pick<Companies, 'name'>
        & { logo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )> }
    )> }
    & TransactionFragment
  )>>> }
);

export type DownloadReceiptQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadReceiptQuery = (
  { __typename?: 'Query' }
  & { downloadReceipt?: Maybe<(
    { __typename?: 'DownloadReceiptPayload' }
    & Pick<DownloadReceiptPayload, 'url'>
  )> }
);

export type UsersQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<Array<Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'created_at' | 'updated_at' | 'username' | 'email' | 'provider' | 'confirmed' | 'blocked'>
    & { role?: Maybe<(
      { __typename?: 'UsersPermissionsRole' }
      & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
    )> }
  )>>> }
);

export const FinancialSummaryFragmentDoc = gql`
    fragment financialSummary on FinancialSummaries {
  id
  netWorth
  totalDeptOutstanding
  totalDeptOutstandingOther
  grossIncome
  grossProfit
  operatingProfit
  netProfit
  detailsOfDefaultCP
  detailsOfDefaultDelay
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFile {
  id
  name
  alternativeText
  caption
  width
  height
  formats
  hash
  ext
  mime
  size
  url
  previewUrl
  provider
  provider_metadata
}
    `;
export const CompanyFragmentDoc = gql`
    fragment company on Companies {
  id
  name
  companyType
  industryType
  logo {
    url
  }
  activeSince
  briefDescription
  platformUseReason
  registrationNumber
  registeredAt
  countryOfRegistration
  vatNumber
  taxNumber
  formattedAddress
  netWorth
  grossIncome
  totalDebt
  bankingInformation {
    id
    bankName
    accountHolder
    typeOfAccount
    accountNumber
  }
  financialSummary {
    ...financialSummary
  }
  informationMemorandum {
    ...uploadFile
  }
  certificateOfIncorporation {
    ...uploadFile
  }
  memorandumAndArticlesOfAssociation {
    ...uploadFile
  }
  boardOfDirectorsApproval {
    ...uploadFile
  }
  reportingAccountsReport {
    ...uploadFile
  }
  financialStatements {
    ...uploadFile
  }
  companyTAXCertificate {
    ...uploadFile
  }
  relevantCompanyDocuments {
    ...uploadFile
  }
  companyConsent {
    ...uploadFile
  }
}
    ${FinancialSummaryFragmentDoc}
${UploadFileFragmentDoc}`;
export const MasterNoteFragmentDoc = gql`
    fragment masterNote on MasterNote {
  id
  title
  type
  interestFrequency
  interestRate
  currentStep
  currency
  maturityDate
  description
  potentialRisks
  marketValue
  status
  memorandum {
    ...uploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const CommercialPaperFragmentDoc = gql`
    fragment commercialPaper on CommercialPapers {
  id
  submittedAt
  company {
    ...company
  }
  title
  interestFrequency
  masterNote {
    ...masterNote
  }
  purchaseFee
  shortHoldFee
  shortHoldDescription
  assetType
  fundManager
  followup
  lockDown
  purchasePrice
  managementFee
  interestFrequencyDescription
  memorandum {
    url
  }
  type
  numberOfPaidInterest
  potentialRisks
  masterNoteMarketValue
  noteMarketValue
  payoutDate
  nextInterestPayment
  sellFee
  shortHoldFeeDuration
  description
  amount
  amountNeeded
  payoutDate
  interestRate
  minInvestment
  serviceInterestRate
  status
  currency
  industryType
  proposedDateOfIssue
  purposeOfIssue
  commercialPaperType
  currentStep
  notes {
    id
    user {
      firstName
      lastName
      profilePicture {
        url
      }
    }
    created_at
    message
    noteType
  }
  investments {
    amount
    status
  }
}
    ${CompanyFragmentDoc}
${MasterNoteFragmentDoc}`;
export const CorporateGovernanceRequirementFragmentDoc = gql`
    fragment corporateGovernanceRequirement on CorporateGovernanceRequirements {
  id
  reasonsForNonCompliance
  strategicGuidance
  relevantCommittees
  availabilityAndReliabilityOfFinancialRecords
  balanceOfExecutiveAndNonExecutiveDirectors
  directorCompliance
  reasonsForNonComplianceComment
  strategicGuidanceComment
  relevantCommitteesComment
  committeeSpecificationsBoardComment
  committeeSpecificationsBoard
  balanceOfExecutiveAndNonExecutiveDirectorsComment
  directorComplianceComment
  rolesAndResponsibilities
  rolesAndResponsibilitiesComment
  chairpersonCompliance
  chairpersonComplianceComment
  nominatingCommittee
  nominatingCommitteeComment
  auditCommittee
  auditCommitteeComment
}
    `;
export const EligibilityRequirementFragmentDoc = gql`
    fragment eligibilityRequirement on EligibilityRequirement {
  id
  created_at
  updated_at
  incorporationWithLimitedLiability
  incorporationWithLimitedLiabilityComment
  shareCapitalAndNetAssetsOfIssuer
  shareCapitalAndNetAssetsOfIssuerComment
  listingAndTransferabilityOfSecurities
  listingAndTransferabilityOfSecuritiesComment
  availabilityAndReliabilityOfFinancialRecords
  availabilityAndReliabilityOfFinancialRecordsComment
  directorsAndSeniorManagement
  directorsAndSeniorManagementComment
  certificateOfComfort
  certificateOfComfortComment
  profitableHistoricTrackRecordAndFutureProspects
  profitableHistoricTrackRecordAndFutureProspectsComment
  guaranteeRequirements
  guaranteeRequirementsComment
  debtRatio
  debtRatioComment
  sizeIssue
  sizeIssueComment
  minimumSize
  minimumSizeComment
  renewalDate
  renewalDateComment
}
    `;
export const TransactionFragmentDoc = gql`
    fragment transaction on Transactions {
  id
  created_at
  updated_at
  payoutDate
  transactionNumber
  amount
  invoice {
    url
  }
  status
  description
  mpesaNumber
  merchantRequestID
  checkoutRequestID
  mpesaReceiptNumber
  transactionType
}
    `;
export const UserFragmentDoc = gql`
    fragment user on UsersPermissionsUser {
  id
  email
  confirmed
  blocked
  phoneNumber
  role {
    type
  }
  phoneNumber
  profilePicture {
    ...uploadFile
  }
  firstName
  lastName
  type
  dateOfBirth
  idNumber
  nationalId {
    ...uploadFile
  }
  selfie {
    ...uploadFile
  }
  mobileNumber
  officeNumber
  currency
  taxNumber
  citizenship
  company {
    ...company
  }
  residentialAddress
  certifiedId {
    ...uploadFile
  }
  reasonForInvesting
  agreedToInvestTerms
  onboardingStatus
  investorOnboardingSteps
  smileVerificationStatus
}
    ${UploadFileFragmentDoc}
${CompanyFragmentDoc}`;
export const SubmitBankWithdrawRequestDocument = gql`
    mutation submitBankWithdrawRequest($input: SubmitBankWithdrawRequestInput) {
  submitBankWithdrawRequest(input: $input) {
    ok
  }
}
    `;
export type SubmitBankWithdrawRequestMutationFn = Apollo.MutationFunction<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>;

/**
 * __useSubmitBankWithdrawRequestMutation__
 *
 * To run a mutation, you first call `useSubmitBankWithdrawRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBankWithdrawRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBankWithdrawRequestMutation, { data, loading, error }] = useSubmitBankWithdrawRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitBankWithdrawRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>) {
        return Apollo.useMutation<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>(SubmitBankWithdrawRequestDocument, baseOptions);
      }
export type SubmitBankWithdrawRequestMutationHookResult = ReturnType<typeof useSubmitBankWithdrawRequestMutation>;
export type SubmitBankWithdrawRequestMutationResult = Apollo.MutationResult<SubmitBankWithdrawRequestMutation>;
export type SubmitBankWithdrawRequestMutationOptions = Apollo.BaseMutationOptions<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>;
export const CalculateInvestmentDocument = gql`
    mutation calculateInvestment($input: CalculateInvestmentInput) {
  calculateInvestment(input: $input) {
    interestRate
    investmentTerm
    investmentDate
    dueDate
    purchasePrice
    investorTotalReturn
  }
}
    `;
export type CalculateInvestmentMutationFn = Apollo.MutationFunction<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>;

/**
 * __useCalculateInvestmentMutation__
 *
 * To run a mutation, you first call `useCalculateInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateInvestmentMutation, { data, loading, error }] = useCalculateInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>) {
        return Apollo.useMutation<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>(CalculateInvestmentDocument, baseOptions);
      }
export type CalculateInvestmentMutationHookResult = ReturnType<typeof useCalculateInvestmentMutation>;
export type CalculateInvestmentMutationResult = Apollo.MutationResult<CalculateInvestmentMutation>;
export type CalculateInvestmentMutationOptions = Apollo.BaseMutationOptions<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>;
export const ChangeAppUseDocument = gql`
    mutation changeAppUse($useType: AppUse!) {
  changeAppUse(useType: $useType) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type ChangeAppUseMutationFn = Apollo.MutationFunction<ChangeAppUseMutation, ChangeAppUseMutationVariables>;

/**
 * __useChangeAppUseMutation__
 *
 * To run a mutation, you first call `useChangeAppUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAppUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAppUseMutation, { data, loading, error }] = useChangeAppUseMutation({
 *   variables: {
 *      useType: // value for 'useType'
 *   },
 * });
 */
export function useChangeAppUseMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAppUseMutation, ChangeAppUseMutationVariables>) {
        return Apollo.useMutation<ChangeAppUseMutation, ChangeAppUseMutationVariables>(ChangeAppUseDocument, baseOptions);
      }
export type ChangeAppUseMutationHookResult = ReturnType<typeof useChangeAppUseMutation>;
export type ChangeAppUseMutationResult = Apollo.MutationResult<ChangeAppUseMutation>;
export type ChangeAppUseMutationOptions = Apollo.BaseMutationOptions<ChangeAppUseMutation, ChangeAppUseMutationVariables>;
export const ChangeCurrencyDocument = gql`
    mutation changeCurrency($input: ChangeCurrencyInput) {
  changeCurrency(input: $input) {
    currency
  }
}
    `;
export type ChangeCurrencyMutationFn = Apollo.MutationFunction<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>;

/**
 * __useChangeCurrencyMutation__
 *
 * To run a mutation, you first call `useChangeCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCurrencyMutation, { data, loading, error }] = useChangeCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>) {
        return Apollo.useMutation<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>(ChangeCurrencyDocument, baseOptions);
      }
export type ChangeCurrencyMutationHookResult = ReturnType<typeof useChangeCurrencyMutation>;
export type ChangeCurrencyMutationResult = Apollo.MutationResult<ChangeCurrencyMutation>;
export type ChangeCurrencyMutationOptions = Apollo.BaseMutationOptions<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>;
export const ChangeMyPasswordDocument = gql`
    mutation changeMyPassword($password: String!) {
  changeMyPassword(password: $password) {
    ok
  }
}
    `;
export type ChangeMyPasswordMutationFn = Apollo.MutationFunction<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;

/**
 * __useChangeMyPasswordMutation__
 *
 * To run a mutation, you first call `useChangeMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyPasswordMutation, { data, loading, error }] = useChangeMyPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangeMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>) {
        return Apollo.useMutation<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>(ChangeMyPasswordDocument, baseOptions);
      }
export type ChangeMyPasswordMutationHookResult = ReturnType<typeof useChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationResult = Apollo.MutationResult<ChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;
export const ApproveCommercialPaperDocument = gql`
    mutation approveCommercialPaper($input: ApproveCommercialPaperInput) {
  approveCommercialPaper(input: $input) {
    ...commercialPaper
  }
}
    ${CommercialPaperFragmentDoc}`;
export type ApproveCommercialPaperMutationFn = Apollo.MutationFunction<ApproveCommercialPaperMutation, ApproveCommercialPaperMutationVariables>;

/**
 * __useApproveCommercialPaperMutation__
 *
 * To run a mutation, you first call `useApproveCommercialPaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCommercialPaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCommercialPaperMutation, { data, loading, error }] = useApproveCommercialPaperMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveCommercialPaperMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCommercialPaperMutation, ApproveCommercialPaperMutationVariables>) {
        return Apollo.useMutation<ApproveCommercialPaperMutation, ApproveCommercialPaperMutationVariables>(ApproveCommercialPaperDocument, baseOptions);
      }
export type ApproveCommercialPaperMutationHookResult = ReturnType<typeof useApproveCommercialPaperMutation>;
export type ApproveCommercialPaperMutationResult = Apollo.MutationResult<ApproveCommercialPaperMutation>;
export type ApproveCommercialPaperMutationOptions = Apollo.BaseMutationOptions<ApproveCommercialPaperMutation, ApproveCommercialPaperMutationVariables>;
export const DeclineCommercialPaperDocument = gql`
    mutation declineCommercialPaper($input: DeclineCommercialPaperInput) {
  declineCommercialPaper(input: $input) {
    ...commercialPaper
  }
}
    ${CommercialPaperFragmentDoc}`;
export type DeclineCommercialPaperMutationFn = Apollo.MutationFunction<DeclineCommercialPaperMutation, DeclineCommercialPaperMutationVariables>;

/**
 * __useDeclineCommercialPaperMutation__
 *
 * To run a mutation, you first call `useDeclineCommercialPaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineCommercialPaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineCommercialPaperMutation, { data, loading, error }] = useDeclineCommercialPaperMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineCommercialPaperMutation(baseOptions?: Apollo.MutationHookOptions<DeclineCommercialPaperMutation, DeclineCommercialPaperMutationVariables>) {
        return Apollo.useMutation<DeclineCommercialPaperMutation, DeclineCommercialPaperMutationVariables>(DeclineCommercialPaperDocument, baseOptions);
      }
export type DeclineCommercialPaperMutationHookResult = ReturnType<typeof useDeclineCommercialPaperMutation>;
export type DeclineCommercialPaperMutationResult = Apollo.MutationResult<DeclineCommercialPaperMutation>;
export type DeclineCommercialPaperMutationOptions = Apollo.BaseMutationOptions<DeclineCommercialPaperMutation, DeclineCommercialPaperMutationVariables>;
export const RequestMoreInfoDocument = gql`
    mutation requestMoreInfo($input: RequestMoreInfoInput) {
  requestMoreInfo(input: $input) {
    ...commercialPaper
  }
}
    ${CommercialPaperFragmentDoc}`;
export type RequestMoreInfoMutationFn = Apollo.MutationFunction<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>;

/**
 * __useRequestMoreInfoMutation__
 *
 * To run a mutation, you first call `useRequestMoreInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMoreInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMoreInfoMutation, { data, loading, error }] = useRequestMoreInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMoreInfoMutation(baseOptions?: Apollo.MutationHookOptions<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>) {
        return Apollo.useMutation<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>(RequestMoreInfoDocument, baseOptions);
      }
export type RequestMoreInfoMutationHookResult = ReturnType<typeof useRequestMoreInfoMutation>;
export type RequestMoreInfoMutationResult = Apollo.MutationResult<RequestMoreInfoMutation>;
export type RequestMoreInfoMutationOptions = Apollo.BaseMutationOptions<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>;
export const CreateInternalNoteDocument = gql`
    mutation createInternalNote($input: CreateInternalNoteInput) {
  createInternalNote(input: $input) {
    id
    message
  }
}
    `;
export type CreateInternalNoteMutationFn = Apollo.MutationFunction<CreateInternalNoteMutation, CreateInternalNoteMutationVariables>;

/**
 * __useCreateInternalNoteMutation__
 *
 * To run a mutation, you first call `useCreateInternalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalNoteMutation, { data, loading, error }] = useCreateInternalNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalNoteMutation, CreateInternalNoteMutationVariables>) {
        return Apollo.useMutation<CreateInternalNoteMutation, CreateInternalNoteMutationVariables>(CreateInternalNoteDocument, baseOptions);
      }
export type CreateInternalNoteMutationHookResult = ReturnType<typeof useCreateInternalNoteMutation>;
export type CreateInternalNoteMutationResult = Apollo.MutationResult<CreateInternalNoteMutation>;
export type CreateInternalNoteMutationOptions = Apollo.BaseMutationOptions<CreateInternalNoteMutation, CreateInternalNoteMutationVariables>;
export const UpdateMarketValueDocument = gql`
    mutation updateMarketValue($input: MarketValueInput) {
  updateMarketValue(input: $input) {
    ok
  }
}
    `;
export type UpdateMarketValueMutationFn = Apollo.MutationFunction<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>;

/**
 * __useUpdateMarketValueMutation__
 *
 * To run a mutation, you first call `useUpdateMarketValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketValueMutation, { data, loading, error }] = useUpdateMarketValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>) {
        return Apollo.useMutation<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>(UpdateMarketValueDocument, baseOptions);
      }
export type UpdateMarketValueMutationHookResult = ReturnType<typeof useUpdateMarketValueMutation>;
export type UpdateMarketValueMutationResult = Apollo.MutationResult<UpdateMarketValueMutation>;
export type UpdateMarketValueMutationOptions = Apollo.BaseMutationOptions<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>;
export const CreateMyCommercialPaperDocument = gql`
    mutation createMyCommercialPaper($input: CreateMyCommercialPaperInput) {
  createMyCommercialPaper(input: $input) {
    ...commercialPaper
  }
}
    ${CommercialPaperFragmentDoc}`;
export type CreateMyCommercialPaperMutationFn = Apollo.MutationFunction<CreateMyCommercialPaperMutation, CreateMyCommercialPaperMutationVariables>;

/**
 * __useCreateMyCommercialPaperMutation__
 *
 * To run a mutation, you first call `useCreateMyCommercialPaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyCommercialPaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyCommercialPaperMutation, { data, loading, error }] = useCreateMyCommercialPaperMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyCommercialPaperMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyCommercialPaperMutation, CreateMyCommercialPaperMutationVariables>) {
        return Apollo.useMutation<CreateMyCommercialPaperMutation, CreateMyCommercialPaperMutationVariables>(CreateMyCommercialPaperDocument, baseOptions);
      }
export type CreateMyCommercialPaperMutationHookResult = ReturnType<typeof useCreateMyCommercialPaperMutation>;
export type CreateMyCommercialPaperMutationResult = Apollo.MutationResult<CreateMyCommercialPaperMutation>;
export type CreateMyCommercialPaperMutationOptions = Apollo.BaseMutationOptions<CreateMyCommercialPaperMutation, CreateMyCommercialPaperMutationVariables>;
export const CreateSupportTicketDocument = gql`
    mutation createSupportTicket($input: SupportTicketInput) {
  createSupportTickets(input: $input) {
    id
  }
}
    `;
export type CreateSupportTicketMutationFn = Apollo.MutationFunction<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;

/**
 * __useCreateSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketMutation, { data, loading, error }] = useCreateSupportTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupportTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>) {
        return Apollo.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(CreateSupportTicketDocument, baseOptions);
      }
export type CreateSupportTicketMutationHookResult = ReturnType<typeof useCreateSupportTicketMutation>;
export type CreateSupportTicketMutationResult = Apollo.MutationResult<CreateSupportTicketMutation>;
export type CreateSupportTicketMutationOptions = Apollo.BaseMutationOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;
export const HelpAndSupportDocument = gql`
    mutation helpAndSupport($input: helpAndSupportInput) {
  helpAndSupport(input: $input) {
    ok
  }
}
    `;
export type HelpAndSupportMutationFn = Apollo.MutationFunction<HelpAndSupportMutation, HelpAndSupportMutationVariables>;

/**
 * __useHelpAndSupportMutation__
 *
 * To run a mutation, you first call `useHelpAndSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpAndSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpAndSupportMutation, { data, loading, error }] = useHelpAndSupportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHelpAndSupportMutation(baseOptions?: Apollo.MutationHookOptions<HelpAndSupportMutation, HelpAndSupportMutationVariables>) {
        return Apollo.useMutation<HelpAndSupportMutation, HelpAndSupportMutationVariables>(HelpAndSupportDocument, baseOptions);
      }
export type HelpAndSupportMutationHookResult = ReturnType<typeof useHelpAndSupportMutation>;
export type HelpAndSupportMutationResult = Apollo.MutationResult<HelpAndSupportMutation>;
export type HelpAndSupportMutationOptions = Apollo.BaseMutationOptions<HelpAndSupportMutation, HelpAndSupportMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: createUserInput) {
  createUser(input: $input) {
    user {
      id
      username
      email
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const BuyInvestmentDocument = gql`
    mutation buyInvestment($input: BuyInvestmentInput) {
  buyInvestment(input: $input) {
    id
    amount
    company
    merchantRequestID
  }
}
    `;
export type BuyInvestmentMutationFn = Apollo.MutationFunction<BuyInvestmentMutation, BuyInvestmentMutationVariables>;

/**
 * __useBuyInvestmentMutation__
 *
 * To run a mutation, you first call `useBuyInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyInvestmentMutation, { data, loading, error }] = useBuyInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuyInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<BuyInvestmentMutation, BuyInvestmentMutationVariables>) {
        return Apollo.useMutation<BuyInvestmentMutation, BuyInvestmentMutationVariables>(BuyInvestmentDocument, baseOptions);
      }
export type BuyInvestmentMutationHookResult = ReturnType<typeof useBuyInvestmentMutation>;
export type BuyInvestmentMutationResult = Apollo.MutationResult<BuyInvestmentMutation>;
export type BuyInvestmentMutationOptions = Apollo.BaseMutationOptions<BuyInvestmentMutation, BuyInvestmentMutationVariables>;
export const CalculateSellDocument = gql`
    mutation calculateSell($input: CalculateSellInput) {
  calculateSell(input: $input) {
    customerAmount
    deadline
    sellAmount
    shortHoldFeeAmount
    sellFeeAmount
  }
}
    `;
export type CalculateSellMutationFn = Apollo.MutationFunction<CalculateSellMutation, CalculateSellMutationVariables>;

/**
 * __useCalculateSellMutation__
 *
 * To run a mutation, you first call `useCalculateSellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateSellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateSellMutation, { data, loading, error }] = useCalculateSellMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateSellMutation(baseOptions?: Apollo.MutationHookOptions<CalculateSellMutation, CalculateSellMutationVariables>) {
        return Apollo.useMutation<CalculateSellMutation, CalculateSellMutationVariables>(CalculateSellDocument, baseOptions);
      }
export type CalculateSellMutationHookResult = ReturnType<typeof useCalculateSellMutation>;
export type CalculateSellMutationResult = Apollo.MutationResult<CalculateSellMutation>;
export type CalculateSellMutationOptions = Apollo.BaseMutationOptions<CalculateSellMutation, CalculateSellMutationVariables>;
export const CreateSellDocument = gql`
    mutation createSell($input: CreateSellInput) {
  createSell(input: $input) {
    ok
  }
}
    `;
export type CreateSellMutationFn = Apollo.MutationFunction<CreateSellMutation, CreateSellMutationVariables>;

/**
 * __useCreateSellMutation__
 *
 * To run a mutation, you first call `useCreateSellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellMutation, { data, loading, error }] = useCreateSellMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSellMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellMutation, CreateSellMutationVariables>) {
        return Apollo.useMutation<CreateSellMutation, CreateSellMutationVariables>(CreateSellDocument, baseOptions);
      }
export type CreateSellMutationHookResult = ReturnType<typeof useCreateSellMutation>;
export type CreateSellMutationResult = Apollo.MutationResult<CreateSellMutation>;
export type CreateSellMutationOptions = Apollo.BaseMutationOptions<CreateSellMutation, CreateSellMutationVariables>;
export const InvestorOnboardingDocument = gql`
    mutation investorOnboarding($input: InvestorOnboardingInput) {
  investorOnboarding(input: $input) {
    id
  }
}
    `;
export type InvestorOnboardingMutationFn = Apollo.MutationFunction<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>;

/**
 * __useInvestorOnboardingMutation__
 *
 * To run a mutation, you first call `useInvestorOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorOnboardingMutation, { data, loading, error }] = useInvestorOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>) {
        return Apollo.useMutation<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>(InvestorOnboardingDocument, baseOptions);
      }
export type InvestorOnboardingMutationHookResult = ReturnType<typeof useInvestorOnboardingMutation>;
export type InvestorOnboardingMutationResult = Apollo.MutationResult<InvestorOnboardingMutation>;
export type InvestorOnboardingMutationOptions = Apollo.BaseMutationOptions<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>;
export const CreateMasterNoteByUserDocument = gql`
    mutation createMasterNoteByUser($input: createMasterNoteByUserInput) {
  createMasterNoteByUser(input: $input) {
    ...masterNote
  }
}
    ${MasterNoteFragmentDoc}`;
export type CreateMasterNoteByUserMutationFn = Apollo.MutationFunction<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>;

/**
 * __useCreateMasterNoteByUserMutation__
 *
 * To run a mutation, you first call `useCreateMasterNoteByUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterNoteByUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterNoteByUserMutation, { data, loading, error }] = useCreateMasterNoteByUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterNoteByUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>) {
        return Apollo.useMutation<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>(CreateMasterNoteByUserDocument, baseOptions);
      }
export type CreateMasterNoteByUserMutationHookResult = ReturnType<typeof useCreateMasterNoteByUserMutation>;
export type CreateMasterNoteByUserMutationResult = Apollo.MutationResult<CreateMasterNoteByUserMutation>;
export type CreateMasterNoteByUserMutationOptions = Apollo.BaseMutationOptions<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>;
export const ArchiveNotificationDocument = gql`
    mutation archiveNotification($id: ID) {
  archiveNotification(id: $id) {
    ok
  }
}
    `;
export type ArchiveNotificationMutationFn = Apollo.MutationFunction<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;

/**
 * __useArchiveNotificationMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationMutation, { data, loading, error }] = useArchiveNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>) {
        return Apollo.useMutation<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>(ArchiveNotificationDocument, baseOptions);
      }
export type ArchiveNotificationMutationHookResult = ReturnType<typeof useArchiveNotificationMutation>;
export type ArchiveNotificationMutationResult = Apollo.MutationResult<ArchiveNotificationMutation>;
export type ArchiveNotificationMutationOptions = Apollo.BaseMutationOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;
export const OnboardingDocument = gql`
    mutation onboarding($input: OnboardingInput, $companyInformation: OnboardingCompanyInput) {
  onboarding(input: $input, companyInformation: $companyInformation) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type OnboardingMutationFn = Apollo.MutationFunction<OnboardingMutation, OnboardingMutationVariables>;

/**
 * __useOnboardingMutation__
 *
 * To run a mutation, you first call `useOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingMutation, { data, loading, error }] = useOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyInformation: // value for 'companyInformation'
 *   },
 * });
 */
export function useOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingMutation, OnboardingMutationVariables>) {
        return Apollo.useMutation<OnboardingMutation, OnboardingMutationVariables>(OnboardingDocument, baseOptions);
      }
export type OnboardingMutationHookResult = ReturnType<typeof useOnboardingMutation>;
export type OnboardingMutationResult = Apollo.MutationResult<OnboardingMutation>;
export type OnboardingMutationOptions = Apollo.BaseMutationOptions<OnboardingMutation, OnboardingMutationVariables>;
export const SendPayoutByUserDocument = gql`
    mutation sendPayoutByUser($input: SendPayoutByUserInput) {
  sendPayoutByUser(input: $input) {
    ok
  }
}
    `;
export type SendPayoutByUserMutationFn = Apollo.MutationFunction<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>;

/**
 * __useSendPayoutByUserMutation__
 *
 * To run a mutation, you first call `useSendPayoutByUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPayoutByUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPayoutByUserMutation, { data, loading, error }] = useSendPayoutByUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPayoutByUserMutation(baseOptions?: Apollo.MutationHookOptions<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>) {
        return Apollo.useMutation<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>(SendPayoutByUserDocument, baseOptions);
      }
export type SendPayoutByUserMutationHookResult = ReturnType<typeof useSendPayoutByUserMutation>;
export type SendPayoutByUserMutationResult = Apollo.MutationResult<SendPayoutByUserMutation>;
export type SendPayoutByUserMutationOptions = Apollo.BaseMutationOptions<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>;
export const SendInterestDocument = gql`
    mutation sendInterest($input: SendInterestInput) {
  sendInterest(input: $input) {
    ok
  }
}
    `;
export type SendInterestMutationFn = Apollo.MutationFunction<SendInterestMutation, SendInterestMutationVariables>;

/**
 * __useSendInterestMutation__
 *
 * To run a mutation, you first call `useSendInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInterestMutation, { data, loading, error }] = useSendInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInterestMutation(baseOptions?: Apollo.MutationHookOptions<SendInterestMutation, SendInterestMutationVariables>) {
        return Apollo.useMutation<SendInterestMutation, SendInterestMutationVariables>(SendInterestDocument, baseOptions);
      }
export type SendInterestMutationHookResult = ReturnType<typeof useSendInterestMutation>;
export type SendInterestMutationResult = Apollo.MutationResult<SendInterestMutation>;
export type SendInterestMutationOptions = Apollo.BaseMutationOptions<SendInterestMutation, SendInterestMutationVariables>;
export const RequestCompanyUpdateDocument = gql`
    mutation requestCompanyUpdate($input: RequestCompanyUpdateInput) {
  requestCompanyUpdate(input: $input) {
    ok
  }
}
    `;
export type RequestCompanyUpdateMutationFn = Apollo.MutationFunction<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>;

/**
 * __useRequestCompanyUpdateMutation__
 *
 * To run a mutation, you first call `useRequestCompanyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCompanyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCompanyUpdateMutation, { data, loading, error }] = useRequestCompanyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCompanyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>) {
        return Apollo.useMutation<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>(RequestCompanyUpdateDocument, baseOptions);
      }
export type RequestCompanyUpdateMutationHookResult = ReturnType<typeof useRequestCompanyUpdateMutation>;
export type RequestCompanyUpdateMutationResult = Apollo.MutationResult<RequestCompanyUpdateMutation>;
export type RequestCompanyUpdateMutationOptions = Apollo.BaseMutationOptions<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>;
export const RequestMasterNoteUpdateDocument = gql`
    mutation requestMasterNoteUpdate($input: RequestMasterNoteUpdateInput, $type: String) {
  requestMasterNoteUpdate(input: $input, type: $type) {
    ok
  }
}
    `;
export type RequestMasterNoteUpdateMutationFn = Apollo.MutationFunction<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>;

/**
 * __useRequestMasterNoteUpdateMutation__
 *
 * To run a mutation, you first call `useRequestMasterNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMasterNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMasterNoteUpdateMutation, { data, loading, error }] = useRequestMasterNoteUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRequestMasterNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>) {
        return Apollo.useMutation<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>(RequestMasterNoteUpdateDocument, baseOptions);
      }
export type RequestMasterNoteUpdateMutationHookResult = ReturnType<typeof useRequestMasterNoteUpdateMutation>;
export type RequestMasterNoteUpdateMutationResult = Apollo.MutationResult<RequestMasterNoteUpdateMutation>;
export type RequestMasterNoteUpdateMutationOptions = Apollo.BaseMutationOptions<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>;
export const RequestProfileUpdateDocument = gql`
    mutation requestProfileUpdate($input: RequestProfileUpdateInput) {
  requestProfileUpdate(input: $input) {
    ok
  }
}
    `;
export type RequestProfileUpdateMutationFn = Apollo.MutationFunction<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>;

/**
 * __useRequestProfileUpdateMutation__
 *
 * To run a mutation, you first call `useRequestProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestProfileUpdateMutation, { data, loading, error }] = useRequestProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>) {
        return Apollo.useMutation<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>(RequestProfileUpdateDocument, baseOptions);
      }
export type RequestProfileUpdateMutationHookResult = ReturnType<typeof useRequestProfileUpdateMutation>;
export type RequestProfileUpdateMutationResult = Apollo.MutationResult<RequestProfileUpdateMutation>;
export type RequestProfileUpdateMutationOptions = Apollo.BaseMutationOptions<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>;
export const SubmitRolloverRequestDocument = gql`
    mutation submitRolloverRequest($input: SubmitRolloverRequestInput) {
  submitRolloverRequest(input: $input) {
    id
    reason
  }
}
    `;
export type SubmitRolloverRequestMutationFn = Apollo.MutationFunction<SubmitRolloverRequestMutation, SubmitRolloverRequestMutationVariables>;

/**
 * __useSubmitRolloverRequestMutation__
 *
 * To run a mutation, you first call `useSubmitRolloverRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRolloverRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRolloverRequestMutation, { data, loading, error }] = useSubmitRolloverRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRolloverRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRolloverRequestMutation, SubmitRolloverRequestMutationVariables>) {
        return Apollo.useMutation<SubmitRolloverRequestMutation, SubmitRolloverRequestMutationVariables>(SubmitRolloverRequestDocument, baseOptions);
      }
export type SubmitRolloverRequestMutationHookResult = ReturnType<typeof useSubmitRolloverRequestMutation>;
export type SubmitRolloverRequestMutationResult = Apollo.MutationResult<SubmitRolloverRequestMutation>;
export type SubmitRolloverRequestMutationOptions = Apollo.BaseMutationOptions<SubmitRolloverRequestMutation, SubmitRolloverRequestMutationVariables>;
export const AcceptRolloverDocument = gql`
    mutation acceptRollover($input: CreateMyRolloverResponseInput) {
  acceptRollover(input: $input) {
    id
    status
  }
}
    `;
export type AcceptRolloverMutationFn = Apollo.MutationFunction<AcceptRolloverMutation, AcceptRolloverMutationVariables>;

/**
 * __useAcceptRolloverMutation__
 *
 * To run a mutation, you first call `useAcceptRolloverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRolloverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRolloverMutation, { data, loading, error }] = useAcceptRolloverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptRolloverMutation(baseOptions?: Apollo.MutationHookOptions<AcceptRolloverMutation, AcceptRolloverMutationVariables>) {
        return Apollo.useMutation<AcceptRolloverMutation, AcceptRolloverMutationVariables>(AcceptRolloverDocument, baseOptions);
      }
export type AcceptRolloverMutationHookResult = ReturnType<typeof useAcceptRolloverMutation>;
export type AcceptRolloverMutationResult = Apollo.MutationResult<AcceptRolloverMutation>;
export type AcceptRolloverMutationOptions = Apollo.BaseMutationOptions<AcceptRolloverMutation, AcceptRolloverMutationVariables>;
export const DeclineRolloverDocument = gql`
    mutation declineRollover($input: CreateMyRolloverResponseInput) {
  declineRollover(input: $input) {
    id
    status
  }
}
    `;
export type DeclineRolloverMutationFn = Apollo.MutationFunction<DeclineRolloverMutation, DeclineRolloverMutationVariables>;

/**
 * __useDeclineRolloverMutation__
 *
 * To run a mutation, you first call `useDeclineRolloverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineRolloverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineRolloverMutation, { data, loading, error }] = useDeclineRolloverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineRolloverMutation(baseOptions?: Apollo.MutationHookOptions<DeclineRolloverMutation, DeclineRolloverMutationVariables>) {
        return Apollo.useMutation<DeclineRolloverMutation, DeclineRolloverMutationVariables>(DeclineRolloverDocument, baseOptions);
      }
export type DeclineRolloverMutationHookResult = ReturnType<typeof useDeclineRolloverMutation>;
export type DeclineRolloverMutationResult = Apollo.MutationResult<DeclineRolloverMutation>;
export type DeclineRolloverMutationOptions = Apollo.BaseMutationOptions<DeclineRolloverMutation, DeclineRolloverMutationVariables>;
export const SubmitCommercialPaperDocument = gql`
    mutation submitCommercialPaper($input: SubmitCommercialPaperInput) {
  submitCommercialPaper(input: $input) {
    ...commercialPaper
  }
}
    ${CommercialPaperFragmentDoc}`;
export type SubmitCommercialPaperMutationFn = Apollo.MutationFunction<SubmitCommercialPaperMutation, SubmitCommercialPaperMutationVariables>;

/**
 * __useSubmitCommercialPaperMutation__
 *
 * To run a mutation, you first call `useSubmitCommercialPaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCommercialPaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCommercialPaperMutation, { data, loading, error }] = useSubmitCommercialPaperMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCommercialPaperMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCommercialPaperMutation, SubmitCommercialPaperMutationVariables>) {
        return Apollo.useMutation<SubmitCommercialPaperMutation, SubmitCommercialPaperMutationVariables>(SubmitCommercialPaperDocument, baseOptions);
      }
export type SubmitCommercialPaperMutationHookResult = ReturnType<typeof useSubmitCommercialPaperMutation>;
export type SubmitCommercialPaperMutationResult = Apollo.MutationResult<SubmitCommercialPaperMutation>;
export type SubmitCommercialPaperMutationOptions = Apollo.BaseMutationOptions<SubmitCommercialPaperMutation, SubmitCommercialPaperMutationVariables>;
export const UpdateCompanyDocumentsDocument = gql`
    mutation updateCompanyDocuments($input: UpdateCompanyDocumentsInput) {
  updateCompanyDocuments(input: $input) {
    ...company
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyDocumentsMutationFn = Apollo.MutationFunction<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>;

/**
 * __useUpdateCompanyDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDocumentsMutation, { data, loading, error }] = useUpdateCompanyDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>(UpdateCompanyDocumentsDocument, baseOptions);
      }
export type UpdateCompanyDocumentsMutationHookResult = ReturnType<typeof useUpdateCompanyDocumentsMutation>;
export type UpdateCompanyDocumentsMutationResult = Apollo.MutationResult<UpdateCompanyDocumentsMutation>;
export type UpdateCompanyDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>;
export const UpdateOfcreateBankingDetailsDocument = gql`
    mutation updateOfcreateBankingDetails($input: UpdateOrCreateMyBankingInput) {
  updateOrCreateMyBankingInformation(input: $input) {
    id
    bankName
    accountHolder
    typeOfAccount
    accountNumber
  }
}
    `;
export type UpdateOfcreateBankingDetailsMutationFn = Apollo.MutationFunction<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>;

/**
 * __useUpdateOfcreateBankingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOfcreateBankingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfcreateBankingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfcreateBankingDetailsMutation, { data, loading, error }] = useUpdateOfcreateBankingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfcreateBankingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>) {
        return Apollo.useMutation<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>(UpdateOfcreateBankingDetailsDocument, baseOptions);
      }
export type UpdateOfcreateBankingDetailsMutationHookResult = ReturnType<typeof useUpdateOfcreateBankingDetailsMutation>;
export type UpdateOfcreateBankingDetailsMutationResult = Apollo.MutationResult<UpdateOfcreateBankingDetailsMutation>;
export type UpdateOfcreateBankingDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>;
export const UpdateOrCreateMyFinancialSummaryDocument = gql`
    mutation updateOrCreateMyFinancialSummary($input: UpdateOrCreateMyFinancialSummaryInput) {
  updateOrCreateMyFinancialSummary(input: $input) {
    ...financialSummary
  }
}
    ${FinancialSummaryFragmentDoc}`;
export type UpdateOrCreateMyFinancialSummaryMutationFn = Apollo.MutationFunction<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>;

/**
 * __useUpdateOrCreateMyFinancialSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateMyFinancialSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateMyFinancialSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateMyFinancialSummaryMutation, { data, loading, error }] = useUpdateOrCreateMyFinancialSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateMyFinancialSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>) {
        return Apollo.useMutation<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>(UpdateOrCreateMyFinancialSummaryDocument, baseOptions);
      }
export type UpdateOrCreateMyFinancialSummaryMutationHookResult = ReturnType<typeof useUpdateOrCreateMyFinancialSummaryMutation>;
export type UpdateOrCreateMyFinancialSummaryMutationResult = Apollo.MutationResult<UpdateOrCreateMyFinancialSummaryMutation>;
export type UpdateOrCreateMyFinancialSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>;
export const UpdateRegulatoryProfileDocument = gql`
    mutation updateRegulatoryProfile($input: UpdateRegulatoryProfileInput) {
  updateRegulatoryProfile(input: $input) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UpdateRegulatoryProfileMutationFn = Apollo.MutationFunction<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>;

/**
 * __useUpdateRegulatoryProfileMutation__
 *
 * To run a mutation, you first call `useUpdateRegulatoryProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulatoryProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulatoryProfileMutation, { data, loading, error }] = useUpdateRegulatoryProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegulatoryProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>) {
        return Apollo.useMutation<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>(UpdateRegulatoryProfileDocument, baseOptions);
      }
export type UpdateRegulatoryProfileMutationHookResult = ReturnType<typeof useUpdateRegulatoryProfileMutation>;
export type UpdateRegulatoryProfileMutationResult = Apollo.MutationResult<UpdateRegulatoryProfileMutation>;
export type UpdateRegulatoryProfileMutationOptions = Apollo.BaseMutationOptions<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>;
export const TopupMyWalletDocument = gql`
    mutation topupMyWallet($input: TopupMyWalletInput) {
  topupMyWallet(input: $input) {
    id
    merchantRequestID
  }
}
    `;
export type TopupMyWalletMutationFn = Apollo.MutationFunction<TopupMyWalletMutation, TopupMyWalletMutationVariables>;

/**
 * __useTopupMyWalletMutation__
 *
 * To run a mutation, you first call `useTopupMyWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopupMyWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topupMyWalletMutation, { data, loading, error }] = useTopupMyWalletMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTopupMyWalletMutation(baseOptions?: Apollo.MutationHookOptions<TopupMyWalletMutation, TopupMyWalletMutationVariables>) {
        return Apollo.useMutation<TopupMyWalletMutation, TopupMyWalletMutationVariables>(TopupMyWalletDocument, baseOptions);
      }
export type TopupMyWalletMutationHookResult = ReturnType<typeof useTopupMyWalletMutation>;
export type TopupMyWalletMutationResult = Apollo.MutationResult<TopupMyWalletMutation>;
export type TopupMyWalletMutationOptions = Apollo.BaseMutationOptions<TopupMyWalletMutation, TopupMyWalletMutationVariables>;
export const SubmitTopupRequestDocument = gql`
    mutation submitTopupRequest($input: SubmitTopupRequestInput) {
  submitTopupRequest(input: $input) {
    ok
  }
}
    `;
export type SubmitTopupRequestMutationFn = Apollo.MutationFunction<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>;

/**
 * __useSubmitTopupRequestMutation__
 *
 * To run a mutation, you first call `useSubmitTopupRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTopupRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTopupRequestMutation, { data, loading, error }] = useSubmitTopupRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTopupRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>) {
        return Apollo.useMutation<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>(SubmitTopupRequestDocument, baseOptions);
      }
export type SubmitTopupRequestMutationHookResult = ReturnType<typeof useSubmitTopupRequestMutation>;
export type SubmitTopupRequestMutationResult = Apollo.MutationResult<SubmitTopupRequestMutation>;
export type SubmitTopupRequestMutationOptions = Apollo.BaseMutationOptions<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>;
export const GetCommercialPapersDocument = gql`
    query getCommercialPapers($filters: CPFilter, $page: Int, $sort: CP_SORT_BY, $limit: Int, $showClosed: Boolean) {
  getCommercialPapers(filters: $filters, page: $page, sort: $sort, limit: $limit, showClosed: $showClosed) {
    commercialPapers {
      ...commercialPaper
    }
    pages
    page
  }
}
    ${CommercialPaperFragmentDoc}`;

/**
 * __useGetCommercialPapersQuery__
 *
 * To run a query within a React component, call `useGetCommercialPapersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommercialPapersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommercialPapersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      showClosed: // value for 'showClosed'
 *   },
 * });
 */
export function useGetCommercialPapersQuery(baseOptions?: Apollo.QueryHookOptions<GetCommercialPapersQuery, GetCommercialPapersQueryVariables>) {
        return Apollo.useQuery<GetCommercialPapersQuery, GetCommercialPapersQueryVariables>(GetCommercialPapersDocument, baseOptions);
      }
export function useGetCommercialPapersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommercialPapersQuery, GetCommercialPapersQueryVariables>) {
          return Apollo.useLazyQuery<GetCommercialPapersQuery, GetCommercialPapersQueryVariables>(GetCommercialPapersDocument, baseOptions);
        }
export type GetCommercialPapersQueryHookResult = ReturnType<typeof useGetCommercialPapersQuery>;
export type GetCommercialPapersLazyQueryHookResult = ReturnType<typeof useGetCommercialPapersLazyQuery>;
export type GetCommercialPapersQueryResult = Apollo.QueryResult<GetCommercialPapersQuery, GetCommercialPapersQueryVariables>;
export const GetCommercialPapersCountDocument = gql`
    query getCommercialPapersCount($filters: CPFilter) {
  getCommercialPapersCount(filters: $filters)
}
    `;

/**
 * __useGetCommercialPapersCountQuery__
 *
 * To run a query within a React component, call `useGetCommercialPapersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommercialPapersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommercialPapersCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCommercialPapersCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCommercialPapersCountQuery, GetCommercialPapersCountQueryVariables>) {
        return Apollo.useQuery<GetCommercialPapersCountQuery, GetCommercialPapersCountQueryVariables>(GetCommercialPapersCountDocument, baseOptions);
      }
export function useGetCommercialPapersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommercialPapersCountQuery, GetCommercialPapersCountQueryVariables>) {
          return Apollo.useLazyQuery<GetCommercialPapersCountQuery, GetCommercialPapersCountQueryVariables>(GetCommercialPapersCountDocument, baseOptions);
        }
export type GetCommercialPapersCountQueryHookResult = ReturnType<typeof useGetCommercialPapersCountQuery>;
export type GetCommercialPapersCountLazyQueryHookResult = ReturnType<typeof useGetCommercialPapersCountLazyQuery>;
export type GetCommercialPapersCountQueryResult = Apollo.QueryResult<GetCommercialPapersCountQuery, GetCommercialPapersCountQueryVariables>;
export const GetCommercialPaperByIdDocument = gql`
    query getCommercialPaperById($id: ID!) {
  getCommercialPaperById(id: $id) {
    id
    submittedAt
    company {
      ...company
    }
    amount
    amountNeeded
    noteMarketValue
    masterNoteMarketValue
    purchasePrice
    lockDown
    title
    sellFee
    shortHoldFeeDuration
    interestFrequency
    purchaseFee
    shortHoldFee
    shortHoldDescription
    managementFee
    interestFrequencyDescription
    type
    numberOfPaidInterest
    potentialRisks
    description
    payoutDate
    interestRate
    status
    industryType
    proposedDateOfIssue
    conditions
    purposeOfIssue
    commercialPaperType
    certOfIncorporation {
      url
    }
    memorandum {
      ...uploadFile
    }
    directorsApproval {
      url
    }
    accountsReport {
      url
    }
    financialStatements {
      url
    }
    taxCertificate {
      url
    }
    companyConsent {
      url
    }
    relevantDocuments {
      url
    }
    eligibilityRequirement {
      ...eligibilityRequirement
    }
    corporateGovernanceRequirement {
      ...corporateGovernanceRequirement
    }
    maturesAt
    investmentTermType
    investmentTerm
    lengthOfCP
    notes {
      id
      message
      noteType
      created_at
      user {
        firstName
        profilePicture {
          url
        }
      }
    }
  }
}
    ${CompanyFragmentDoc}
${UploadFileFragmentDoc}
${EligibilityRequirementFragmentDoc}
${CorporateGovernanceRequirementFragmentDoc}`;

/**
 * __useGetCommercialPaperByIdQuery__
 *
 * To run a query within a React component, call `useGetCommercialPaperByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommercialPaperByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommercialPaperByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommercialPaperByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCommercialPaperByIdQuery, GetCommercialPaperByIdQueryVariables>) {
        return Apollo.useQuery<GetCommercialPaperByIdQuery, GetCommercialPaperByIdQueryVariables>(GetCommercialPaperByIdDocument, baseOptions);
      }
export function useGetCommercialPaperByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommercialPaperByIdQuery, GetCommercialPaperByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetCommercialPaperByIdQuery, GetCommercialPaperByIdQueryVariables>(GetCommercialPaperByIdDocument, baseOptions);
        }
export type GetCommercialPaperByIdQueryHookResult = ReturnType<typeof useGetCommercialPaperByIdQuery>;
export type GetCommercialPaperByIdLazyQueryHookResult = ReturnType<typeof useGetCommercialPaperByIdLazyQuery>;
export type GetCommercialPaperByIdQueryResult = Apollo.QueryResult<GetCommercialPaperByIdQuery, GetCommercialPaperByIdQueryVariables>;
export const DownloadCommercialPaperSummaryDocument = gql`
    query downloadCommercialPaperSummary($id: ID!) {
  downloadCommercialPaperSummary(id: $id) {
    url
  }
}
    `;

/**
 * __useDownloadCommercialPaperSummaryQuery__
 *
 * To run a query within a React component, call `useDownloadCommercialPaperSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCommercialPaperSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCommercialPaperSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadCommercialPaperSummaryQuery(baseOptions: Apollo.QueryHookOptions<DownloadCommercialPaperSummaryQuery, DownloadCommercialPaperSummaryQueryVariables>) {
        return Apollo.useQuery<DownloadCommercialPaperSummaryQuery, DownloadCommercialPaperSummaryQueryVariables>(DownloadCommercialPaperSummaryDocument, baseOptions);
      }
export function useDownloadCommercialPaperSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCommercialPaperSummaryQuery, DownloadCommercialPaperSummaryQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCommercialPaperSummaryQuery, DownloadCommercialPaperSummaryQueryVariables>(DownloadCommercialPaperSummaryDocument, baseOptions);
        }
export type DownloadCommercialPaperSummaryQueryHookResult = ReturnType<typeof useDownloadCommercialPaperSummaryQuery>;
export type DownloadCommercialPaperSummaryLazyQueryHookResult = ReturnType<typeof useDownloadCommercialPaperSummaryLazyQuery>;
export type DownloadCommercialPaperSummaryQueryResult = Apollo.QueryResult<DownloadCommercialPaperSummaryQuery, DownloadCommercialPaperSummaryQueryVariables>;
export const CountMyActiveCommercialPapersDocument = gql`
    query countMyActiveCommercialPapers($currency: String) {
  countMyActivePapers(currency: $currency)
}
    `;

/**
 * __useCountMyActiveCommercialPapersQuery__
 *
 * To run a query within a React component, call `useCountMyActiveCommercialPapersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMyActiveCommercialPapersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMyActiveCommercialPapersQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCountMyActiveCommercialPapersQuery(baseOptions?: Apollo.QueryHookOptions<CountMyActiveCommercialPapersQuery, CountMyActiveCommercialPapersQueryVariables>) {
        return Apollo.useQuery<CountMyActiveCommercialPapersQuery, CountMyActiveCommercialPapersQueryVariables>(CountMyActiveCommercialPapersDocument, baseOptions);
      }
export function useCountMyActiveCommercialPapersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountMyActiveCommercialPapersQuery, CountMyActiveCommercialPapersQueryVariables>) {
          return Apollo.useLazyQuery<CountMyActiveCommercialPapersQuery, CountMyActiveCommercialPapersQueryVariables>(CountMyActiveCommercialPapersDocument, baseOptions);
        }
export type CountMyActiveCommercialPapersQueryHookResult = ReturnType<typeof useCountMyActiveCommercialPapersQuery>;
export type CountMyActiveCommercialPapersLazyQueryHookResult = ReturnType<typeof useCountMyActiveCommercialPapersLazyQuery>;
export type CountMyActiveCommercialPapersQueryResult = Apollo.QueryResult<CountMyActiveCommercialPapersQuery, CountMyActiveCommercialPapersQueryVariables>;
export const GetAllSupportTopicsDocument = gql`
    query getAllSupportTopics {
  getAllSupportTopics {
    id
    displayName
  }
}
    `;

/**
 * __useGetAllSupportTopicsQuery__
 *
 * To run a query within a React component, call `useGetAllSupportTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSupportTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSupportTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSupportTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSupportTopicsQuery, GetAllSupportTopicsQueryVariables>) {
        return Apollo.useQuery<GetAllSupportTopicsQuery, GetAllSupportTopicsQueryVariables>(GetAllSupportTopicsDocument, baseOptions);
      }
export function useGetAllSupportTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSupportTopicsQuery, GetAllSupportTopicsQueryVariables>) {
          return Apollo.useLazyQuery<GetAllSupportTopicsQuery, GetAllSupportTopicsQueryVariables>(GetAllSupportTopicsDocument, baseOptions);
        }
export type GetAllSupportTopicsQueryHookResult = ReturnType<typeof useGetAllSupportTopicsQuery>;
export type GetAllSupportTopicsLazyQueryHookResult = ReturnType<typeof useGetAllSupportTopicsLazyQuery>;
export type GetAllSupportTopicsQueryResult = Apollo.QueryResult<GetAllSupportTopicsQuery, GetAllSupportTopicsQueryVariables>;
export const GetAvailableCommercialPapersDocument = gql`
    query getAvailableCommercialPapers($input: AvailableCommercialPapersInput) {
  getAvailableCommercialPapers(input: $input) {
    page
    pages
    commercialPapers {
      ...commercialPaper
      lengthOfCP
    }
  }
}
    ${CommercialPaperFragmentDoc}`;

/**
 * __useGetAvailableCommercialPapersQuery__
 *
 * To run a query within a React component, call `useGetAvailableCommercialPapersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCommercialPapersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCommercialPapersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableCommercialPapersQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableCommercialPapersQuery, GetAvailableCommercialPapersQueryVariables>) {
        return Apollo.useQuery<GetAvailableCommercialPapersQuery, GetAvailableCommercialPapersQueryVariables>(GetAvailableCommercialPapersDocument, baseOptions);
      }
export function useGetAvailableCommercialPapersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCommercialPapersQuery, GetAvailableCommercialPapersQueryVariables>) {
          return Apollo.useLazyQuery<GetAvailableCommercialPapersQuery, GetAvailableCommercialPapersQueryVariables>(GetAvailableCommercialPapersDocument, baseOptions);
        }
export type GetAvailableCommercialPapersQueryHookResult = ReturnType<typeof useGetAvailableCommercialPapersQuery>;
export type GetAvailableCommercialPapersLazyQueryHookResult = ReturnType<typeof useGetAvailableCommercialPapersLazyQuery>;
export type GetAvailableCommercialPapersQueryResult = Apollo.QueryResult<GetAvailableCommercialPapersQuery, GetAvailableCommercialPapersQueryVariables>;
export const GetCommercialPaperForInvestorDocument = gql`
    query getCommercialPaperForInvestor($id: ID!) {
  getCommercialPaperForInvestor(id: $id) {
    commercialPaper {
      ...commercialPaper
      rolloverRequests {
        proposedMaturityDate
        reason
      }
      lengthOfCP
    }
    isAnInvestorOfCP
    amountInvested
  }
}
    ${CommercialPaperFragmentDoc}`;

/**
 * __useGetCommercialPaperForInvestorQuery__
 *
 * To run a query within a React component, call `useGetCommercialPaperForInvestorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommercialPaperForInvestorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommercialPaperForInvestorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommercialPaperForInvestorQuery(baseOptions: Apollo.QueryHookOptions<GetCommercialPaperForInvestorQuery, GetCommercialPaperForInvestorQueryVariables>) {
        return Apollo.useQuery<GetCommercialPaperForInvestorQuery, GetCommercialPaperForInvestorQueryVariables>(GetCommercialPaperForInvestorDocument, baseOptions);
      }
export function useGetCommercialPaperForInvestorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommercialPaperForInvestorQuery, GetCommercialPaperForInvestorQueryVariables>) {
          return Apollo.useLazyQuery<GetCommercialPaperForInvestorQuery, GetCommercialPaperForInvestorQueryVariables>(GetCommercialPaperForInvestorDocument, baseOptions);
        }
export type GetCommercialPaperForInvestorQueryHookResult = ReturnType<typeof useGetCommercialPaperForInvestorQuery>;
export type GetCommercialPaperForInvestorLazyQueryHookResult = ReturnType<typeof useGetCommercialPaperForInvestorLazyQuery>;
export type GetCommercialPaperForInvestorQueryResult = Apollo.QueryResult<GetCommercialPaperForInvestorQuery, GetCommercialPaperForInvestorQueryVariables>;
export const GetManagerMetricsDocument = gql`
    query getManagerMetrics($filters: GetManagerMetricsFilters, $currency: String!) {
  getManagerMetrics(filters: $filters, currency: $currency) {
    investors {
      id
      role {
        type
      }
      created_at
    }
    transactions {
      ...transaction
    }
    closedNotes {
      ...commercialPaper
    }
    createdNotes {
      ...commercialPaper
    }
    fundingNotes {
      ...commercialPaper
    }
    fundedNotes {
      ...commercialPaper
    }
  }
}
    ${TransactionFragmentDoc}
${CommercialPaperFragmentDoc}`;

/**
 * __useGetManagerMetricsQuery__
 *
 * To run a query within a React component, call `useGetManagerMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerMetricsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetManagerMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>) {
        return Apollo.useQuery<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>(GetManagerMetricsDocument, baseOptions);
      }
export function useGetManagerMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>) {
          return Apollo.useLazyQuery<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>(GetManagerMetricsDocument, baseOptions);
        }
export type GetManagerMetricsQueryHookResult = ReturnType<typeof useGetManagerMetricsQuery>;
export type GetManagerMetricsLazyQueryHookResult = ReturnType<typeof useGetManagerMetricsLazyQuery>;
export type GetManagerMetricsQueryResult = Apollo.QueryResult<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>;
export const GetMyBankingInformationDocument = gql`
    query getMyBankingInformation {
  getMyBankingInformation {
    id
    bankName
    accountHolder
    typeOfAccount
    accountNumber
  }
}
    `;

/**
 * __useGetMyBankingInformationQuery__
 *
 * To run a query within a React component, call `useGetMyBankingInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBankingInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBankingInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBankingInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>) {
        return Apollo.useQuery<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>(GetMyBankingInformationDocument, baseOptions);
      }
export function useGetMyBankingInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>) {
          return Apollo.useLazyQuery<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>(GetMyBankingInformationDocument, baseOptions);
        }
export type GetMyBankingInformationQueryHookResult = ReturnType<typeof useGetMyBankingInformationQuery>;
export type GetMyBankingInformationLazyQueryHookResult = ReturnType<typeof useGetMyBankingInformationLazyQuery>;
export type GetMyBankingInformationQueryResult = Apollo.QueryResult<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>;
export const GetMyFinancialSummaryDocument = gql`
    query getMyFinancialSummary {
  getMyFinancialSummary {
    ...financialSummary
  }
}
    ${FinancialSummaryFragmentDoc}`;

/**
 * __useGetMyFinancialSummaryQuery__
 *
 * To run a query within a React component, call `useGetMyFinancialSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFinancialSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFinancialSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFinancialSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>) {
        return Apollo.useQuery<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>(GetMyFinancialSummaryDocument, baseOptions);
      }
export function useGetMyFinancialSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>) {
          return Apollo.useLazyQuery<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>(GetMyFinancialSummaryDocument, baseOptions);
        }
export type GetMyFinancialSummaryQueryHookResult = ReturnType<typeof useGetMyFinancialSummaryQuery>;
export type GetMyFinancialSummaryLazyQueryHookResult = ReturnType<typeof useGetMyFinancialSummaryLazyQuery>;
export type GetMyFinancialSummaryQueryResult = Apollo.QueryResult<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>;
export const GetMyProfileDocument = gql`
    query getMyProfile {
  getMyProfile {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetMyProfileQuery__
 *
 * To run a query within a React component, call `useGetMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>) {
        return Apollo.useQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, baseOptions);
      }
export function useGetMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, baseOptions);
        }
export type GetMyProfileQueryHookResult = ReturnType<typeof useGetMyProfileQuery>;
export type GetMyProfileLazyQueryHookResult = ReturnType<typeof useGetMyProfileLazyQuery>;
export type GetMyProfileQueryResult = Apollo.QueryResult<GetMyProfileQuery, GetMyProfileQueryVariables>;
export const MyWalletBalanceDocument = gql`
    query myWalletBalance($currency: String) {
  myWalletBalance(currency: $currency)
}
    `;

/**
 * __useMyWalletBalanceQuery__
 *
 * To run a query within a React component, call `useMyWalletBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWalletBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWalletBalanceQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useMyWalletBalanceQuery(baseOptions?: Apollo.QueryHookOptions<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>) {
        return Apollo.useQuery<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>(MyWalletBalanceDocument, baseOptions);
      }
export function useMyWalletBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>) {
          return Apollo.useLazyQuery<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>(MyWalletBalanceDocument, baseOptions);
        }
export type MyWalletBalanceQueryHookResult = ReturnType<typeof useMyWalletBalanceQuery>;
export type MyWalletBalanceLazyQueryHookResult = ReturnType<typeof useMyWalletBalanceLazyQuery>;
export type MyWalletBalanceQueryResult = Apollo.QueryResult<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>;
export const FindNotificationsDocument = gql`
    query findNotifications {
  notifications {
    id
    message
    isRead
    title
    category
  }
}
    `;

/**
 * __useFindNotificationsQuery__
 *
 * To run a query within a React component, call `useFindNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<FindNotificationsQuery, FindNotificationsQueryVariables>) {
        return Apollo.useQuery<FindNotificationsQuery, FindNotificationsQueryVariables>(FindNotificationsDocument, baseOptions);
      }
export function useFindNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindNotificationsQuery, FindNotificationsQueryVariables>) {
          return Apollo.useLazyQuery<FindNotificationsQuery, FindNotificationsQueryVariables>(FindNotificationsDocument, baseOptions);
        }
export type FindNotificationsQueryHookResult = ReturnType<typeof useFindNotificationsQuery>;
export type FindNotificationsLazyQueryHookResult = ReturnType<typeof useFindNotificationsLazyQuery>;
export type FindNotificationsQueryResult = Apollo.QueryResult<FindNotificationsQuery, FindNotificationsQueryVariables>;
export const GetSiteDataDocument = gql`
    query getSiteData {
  jamiipesa {
    privacyPolicy
    termsAndConditions
  }
}
    `;

/**
 * __useGetSiteDataQuery__
 *
 * To run a query within a React component, call `useGetSiteDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSiteDataQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteDataQuery, GetSiteDataQueryVariables>) {
        return Apollo.useQuery<GetSiteDataQuery, GetSiteDataQueryVariables>(GetSiteDataDocument, baseOptions);
      }
export function useGetSiteDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDataQuery, GetSiteDataQueryVariables>) {
          return Apollo.useLazyQuery<GetSiteDataQuery, GetSiteDataQueryVariables>(GetSiteDataDocument, baseOptions);
        }
export type GetSiteDataQueryHookResult = ReturnType<typeof useGetSiteDataQuery>;
export type GetSiteDataLazyQueryHookResult = ReturnType<typeof useGetSiteDataLazyQuery>;
export type GetSiteDataQueryResult = Apollo.QueryResult<GetSiteDataQuery, GetSiteDataQueryVariables>;
export const GetInvestmentsDocument = gql`
    query getInvestments($filters: InvestmentFilter, $currency: String!) {
  getInvestments(filters: $filters, currency: $currency) {
    investments {
      id
      amount
      totalReturn
      lastPayInterestDate
      approvedAt
      status
      commercialPaper {
        id
        title
        interestFrequency
        masterNote {
          title
        }
        proposedDateOfIssue
        nextInterestPayment
        serviceInterestRate
        type
        payoutDate
      }
      company {
        name
        industryType
        logo {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetInvestmentsQuery(baseOptions: Apollo.QueryHookOptions<GetInvestmentsQuery, GetInvestmentsQueryVariables>) {
        return Apollo.useQuery<GetInvestmentsQuery, GetInvestmentsQueryVariables>(GetInvestmentsDocument, baseOptions);
      }
export function useGetInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestmentsQuery, GetInvestmentsQueryVariables>) {
          return Apollo.useLazyQuery<GetInvestmentsQuery, GetInvestmentsQueryVariables>(GetInvestmentsDocument, baseOptions);
        }
export type GetInvestmentsQueryHookResult = ReturnType<typeof useGetInvestmentsQuery>;
export type GetInvestmentsLazyQueryHookResult = ReturnType<typeof useGetInvestmentsLazyQuery>;
export type GetInvestmentsQueryResult = Apollo.QueryResult<GetInvestmentsQuery, GetInvestmentsQueryVariables>;
export const MyTotalInvestedAmountByCpDocument = gql`
    query myTotalInvestedAmountByCP($commercialPaperId: ID!) {
  myTotalInvestedAmountByCP(commercialPaperId: $commercialPaperId)
}
    `;

/**
 * __useMyTotalInvestedAmountByCpQuery__
 *
 * To run a query within a React component, call `useMyTotalInvestedAmountByCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTotalInvestedAmountByCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTotalInvestedAmountByCpQuery({
 *   variables: {
 *      commercialPaperId: // value for 'commercialPaperId'
 *   },
 * });
 */
export function useMyTotalInvestedAmountByCpQuery(baseOptions: Apollo.QueryHookOptions<MyTotalInvestedAmountByCpQuery, MyTotalInvestedAmountByCpQueryVariables>) {
        return Apollo.useQuery<MyTotalInvestedAmountByCpQuery, MyTotalInvestedAmountByCpQueryVariables>(MyTotalInvestedAmountByCpDocument, baseOptions);
      }
export function useMyTotalInvestedAmountByCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTotalInvestedAmountByCpQuery, MyTotalInvestedAmountByCpQueryVariables>) {
          return Apollo.useLazyQuery<MyTotalInvestedAmountByCpQuery, MyTotalInvestedAmountByCpQueryVariables>(MyTotalInvestedAmountByCpDocument, baseOptions);
        }
export type MyTotalInvestedAmountByCpQueryHookResult = ReturnType<typeof useMyTotalInvestedAmountByCpQuery>;
export type MyTotalInvestedAmountByCpLazyQueryHookResult = ReturnType<typeof useMyTotalInvestedAmountByCpLazyQuery>;
export type MyTotalInvestedAmountByCpQueryResult = Apollo.QueryResult<MyTotalInvestedAmountByCpQuery, MyTotalInvestedAmountByCpQueryVariables>;
export const GetAcceptedSellRequestsDocument = gql`
    query getAcceptedSellRequests($currency: String!) {
  getAcceptedSellRequests(currency: $currency) {
    sellRequestLosses {
      loss
      time
    }
  }
}
    `;

/**
 * __useGetAcceptedSellRequestsQuery__
 *
 * To run a query within a React component, call `useGetAcceptedSellRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcceptedSellRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcceptedSellRequestsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetAcceptedSellRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>) {
        return Apollo.useQuery<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>(GetAcceptedSellRequestsDocument, baseOptions);
      }
export function useGetAcceptedSellRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>) {
          return Apollo.useLazyQuery<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>(GetAcceptedSellRequestsDocument, baseOptions);
        }
export type GetAcceptedSellRequestsQueryHookResult = ReturnType<typeof useGetAcceptedSellRequestsQuery>;
export type GetAcceptedSellRequestsLazyQueryHookResult = ReturnType<typeof useGetAcceptedSellRequestsLazyQuery>;
export type GetAcceptedSellRequestsQueryResult = Apollo.QueryResult<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>;
export const GetInvestmentsByNoteIdDocument = gql`
    query getInvestmentsByNoteId($page: Int, $limit: Int, $noteId: ID!) {
  getInvestmentsByNoteId(page: $page, limit: $limit, noteId: $noteId) {
    investments {
      amount
      user {
        firstName
        lastName
      }
    }
    pages
    page
  }
}
    `;

/**
 * __useGetInvestmentsByNoteIdQuery__
 *
 * To run a query within a React component, call `useGetInvestmentsByNoteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentsByNoteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentsByNoteIdQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useGetInvestmentsByNoteIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>) {
        return Apollo.useQuery<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>(GetInvestmentsByNoteIdDocument, baseOptions);
      }
export function useGetInvestmentsByNoteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>) {
          return Apollo.useLazyQuery<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>(GetInvestmentsByNoteIdDocument, baseOptions);
        }
export type GetInvestmentsByNoteIdQueryHookResult = ReturnType<typeof useGetInvestmentsByNoteIdQuery>;
export type GetInvestmentsByNoteIdLazyQueryHookResult = ReturnType<typeof useGetInvestmentsByNoteIdLazyQuery>;
export type GetInvestmentsByNoteIdQueryResult = Apollo.QueryResult<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>;
export const GetMarketValueLogDocument = gql`
    query getMarketValueLog($page: Int, $masterNoteId: ID, $limit: Int) {
  getMarketValueLog(page: $page, masterNoteId: $masterNoteId, limit: $limit) {
    marketValueLog {
      approvedAt
      value
    }
    page
    pages
  }
}
    `;

/**
 * __useGetMarketValueLogQuery__
 *
 * To run a query within a React component, call `useGetMarketValueLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketValueLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketValueLogQuery({
 *   variables: {
 *      page: // value for 'page'
 *      masterNoteId: // value for 'masterNoteId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMarketValueLogQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>) {
        return Apollo.useQuery<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>(GetMarketValueLogDocument, baseOptions);
      }
export function useGetMarketValueLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>) {
          return Apollo.useLazyQuery<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>(GetMarketValueLogDocument, baseOptions);
        }
export type GetMarketValueLogQueryHookResult = ReturnType<typeof useGetMarketValueLogQuery>;
export type GetMarketValueLogLazyQueryHookResult = ReturnType<typeof useGetMarketValueLogLazyQuery>;
export type GetMarketValueLogQueryResult = Apollo.QueryResult<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>;
export const GetMyMasterNoteByIdDocument = gql`
    query getMyMasterNoteById($id: ID!) {
  getMyMasterNoteById(id: $id) {
    ...masterNote
  }
}
    ${MasterNoteFragmentDoc}`;

/**
 * __useGetMyMasterNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetMyMasterNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMasterNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMasterNoteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyMasterNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>) {
        return Apollo.useQuery<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>(GetMyMasterNoteByIdDocument, baseOptions);
      }
export function useGetMyMasterNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>(GetMyMasterNoteByIdDocument, baseOptions);
        }
export type GetMyMasterNoteByIdQueryHookResult = ReturnType<typeof useGetMyMasterNoteByIdQuery>;
export type GetMyMasterNoteByIdLazyQueryHookResult = ReturnType<typeof useGetMyMasterNoteByIdLazyQuery>;
export type GetMyMasterNoteByIdQueryResult = Apollo.QueryResult<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>;
export const GetAllMyMasterNotesDocument = gql`
    query getAllMyMasterNotes($filters: MasterNoteFilter, $limit: Int, $page: Int) {
  getAllMyMasterNotes(filters: $filters, limit: $limit, page: $page) {
    masterNotes {
      ...masterNote
    }
    page
    pages
    count
  }
}
    ${MasterNoteFragmentDoc}`;

/**
 * __useGetAllMyMasterNotesQuery__
 *
 * To run a query within a React component, call `useGetAllMyMasterNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyMasterNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyMasterNotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAllMyMasterNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>) {
        return Apollo.useQuery<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>(GetAllMyMasterNotesDocument, baseOptions);
      }
export function useGetAllMyMasterNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>) {
          return Apollo.useLazyQuery<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>(GetAllMyMasterNotesDocument, baseOptions);
        }
export type GetAllMyMasterNotesQueryHookResult = ReturnType<typeof useGetAllMyMasterNotesQuery>;
export type GetAllMyMasterNotesLazyQueryHookResult = ReturnType<typeof useGetAllMyMasterNotesLazyQuery>;
export type GetAllMyMasterNotesQueryResult = Apollo.QueryResult<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>;
export const GetMyNotificationsDocument = gql`
    query getMyNotifications($sort: String) {
  getMyNotifications(sort: $sort) {
    id
    title
    message
    category
    additionalInformation
  }
}
    `;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, baseOptions);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, baseOptions);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const GetNewRolloverRequestsDocument = gql`
    query getNewRolloverRequests($commercialPaperId: ID!) {
  getNewRolloverRequests(commercialPaperId: $commercialPaperId) {
    id
    proposedMaturityDate
    reason
  }
}
    `;

/**
 * __useGetNewRolloverRequestsQuery__
 *
 * To run a query within a React component, call `useGetNewRolloverRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewRolloverRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewRolloverRequestsQuery({
 *   variables: {
 *      commercialPaperId: // value for 'commercialPaperId'
 *   },
 * });
 */
export function useGetNewRolloverRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetNewRolloverRequestsQuery, GetNewRolloverRequestsQueryVariables>) {
        return Apollo.useQuery<GetNewRolloverRequestsQuery, GetNewRolloverRequestsQueryVariables>(GetNewRolloverRequestsDocument, baseOptions);
      }
export function useGetNewRolloverRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewRolloverRequestsQuery, GetNewRolloverRequestsQueryVariables>) {
          return Apollo.useLazyQuery<GetNewRolloverRequestsQuery, GetNewRolloverRequestsQueryVariables>(GetNewRolloverRequestsDocument, baseOptions);
        }
export type GetNewRolloverRequestsQueryHookResult = ReturnType<typeof useGetNewRolloverRequestsQuery>;
export type GetNewRolloverRequestsLazyQueryHookResult = ReturnType<typeof useGetNewRolloverRequestsLazyQuery>;
export type GetNewRolloverRequestsQueryResult = Apollo.QueryResult<GetNewRolloverRequestsQuery, GetNewRolloverRequestsQueryVariables>;
export const GetTransactionByIdDocument = gql`
    query getTransactionById($id: ID!) {
  getTransactionById(id: $id) {
    ...transaction
  }
}
    ${TransactionFragmentDoc}`;

/**
 * __useGetTransactionByIdQuery__
 *
 * To run a query within a React component, call `useGetTransactionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>) {
        return Apollo.useQuery<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>(GetTransactionByIdDocument, baseOptions);
      }
export function useGetTransactionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>(GetTransactionByIdDocument, baseOptions);
        }
export type GetTransactionByIdQueryHookResult = ReturnType<typeof useGetTransactionByIdQuery>;
export type GetTransactionByIdLazyQueryHookResult = ReturnType<typeof useGetTransactionByIdLazyQuery>;
export type GetTransactionByIdQueryResult = Apollo.QueryResult<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>;
export const GetMyTransactionsDocument = gql`
    query getMyTransactions($currency: String!) {
  getMyTransactions(currency: $currency) {
    ...transaction
    commercialPaper {
      title
      company {
        logo {
          url
        }
        name
      }
    }
  }
}
    ${TransactionFragmentDoc}`;

/**
 * __useGetMyTransactionsQuery__
 *
 * To run a query within a React component, call `useGetMyTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTransactionsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetMyTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
        return Apollo.useQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, baseOptions);
      }
export function useGetMyTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
          return Apollo.useLazyQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, baseOptions);
        }
export type GetMyTransactionsQueryHookResult = ReturnType<typeof useGetMyTransactionsQuery>;
export type GetMyTransactionsLazyQueryHookResult = ReturnType<typeof useGetMyTransactionsLazyQuery>;
export type GetMyTransactionsQueryResult = Apollo.QueryResult<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>;
export const DownloadReceiptDocument = gql`
    query downloadReceipt($id: ID!) {
  downloadReceipt(id: $id) {
    url
  }
}
    `;

/**
 * __useDownloadReceiptQuery__
 *
 * To run a query within a React component, call `useDownloadReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadReceiptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadReceiptQuery(baseOptions: Apollo.QueryHookOptions<DownloadReceiptQuery, DownloadReceiptQueryVariables>) {
        return Apollo.useQuery<DownloadReceiptQuery, DownloadReceiptQueryVariables>(DownloadReceiptDocument, baseOptions);
      }
export function useDownloadReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReceiptQuery, DownloadReceiptQueryVariables>) {
          return Apollo.useLazyQuery<DownloadReceiptQuery, DownloadReceiptQueryVariables>(DownloadReceiptDocument, baseOptions);
        }
export type DownloadReceiptQueryHookResult = ReturnType<typeof useDownloadReceiptQuery>;
export type DownloadReceiptLazyQueryHookResult = ReturnType<typeof useDownloadReceiptLazyQuery>;
export type DownloadReceiptQueryResult = Apollo.QueryResult<DownloadReceiptQuery, DownloadReceiptQueryVariables>;
export const UsersDocument = gql`
    query Users($sort: String, $limit: Int, $start: Int, $where: JSON) {
  users(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    username
    email
    provider
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;